export const DataENG = [
  {
    ID: 0,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "Office of the Special Representative of the Secretary-General for Children and Armed Conflict",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of the Special Representative of the Secretary-General for Children and Armed Conflict",
    Title: "Decrease in the verified number of children in detention",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion of human rights",
    Beneficiary: "Youth",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Reduced sexual violence, including its use as a tactic of war and terror, and reduced violence against children, including grave violations committed against children in situations of armed conflict.",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CD,HT,NG,SO,YE",
    Image: "1POLICY1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=55"
  },
  {
    ID: 1,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "Office of the Special Representative of the Secretary-General for Children and Armed Conflict",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of the Special Representative of the Secretary-General for Children and Armed Conflict",
    Title: "Increase in the signature of action plans, handover protocols and other commitments between the United Nations and parties to conflict to end and prevent grave violations against children",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "Youth",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Reduced sexual violence, including its use as a tactic of war and terror, and reduced violence against children, including grave violations committed against children in situations of armed conflict.",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=56"
  },
  {
    ID: 2,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "Office of the Special Representative of the Secretary-General for Children and Armed Conflict",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of the Special Representative of the Secretary-General for Children and Armed Conflict",
    Title: "Decrease in the number of children recruited and used by parties to conflict in situations of armed conflict",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "Youth",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Reduced sexual violence, including its use as a tactic of war and terror, and reduced violence against children, including grave violations committed against children in situations of armed conflict.",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=57"
  },
  {
    ID: 3,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "Office of the Special Representative of the Secretary-General for Children and Armed Conflict",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of the Special Representative of the Secretary-General for Children and Armed Conflict",
    Title: "More children released from armed forces and armed groups",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "Youth",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Reduced sexual violence, including its use as a tactic of war and terror, and reduced violence against children, including grave violations committed against children in situations of armed conflict.",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=58"
  },
  {
    ID: 4,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "Office of the Special Representative of the Secretary-General on Sexual Violence in Conflict",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of the Special Representative of the Secretary-General on Sexual Violence in Conflict",
    Title: "Strengthened national ownership to prevent conflict-related sexual violence and deliver justice",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion of human rights",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Reduced sexual violence, including its use as a tactic of war and terror, and reduced violence against children, including grave violations committed against children in situations of armed conflict.",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "UA",
    Image: "1POLICY5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=67"
  },
  {
    ID: 5,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "Office of the Special Representative of the Secretary-General on Sexual Violence in Conflict",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of the Special Representative of the Secretary-General on Sexual Violence in Conflict",
    Title: "Strengthened service provision and justice response on conflict-related sexual violence by national authorities",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Reduced sexual violence, including its use as a tactic of war and terror, and reduced violence against children, including grave violations committed against children in situations of armed conflict.",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DJ,ER,ET,SO,SD,QQ",
    Image: "1POLICY6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=68"
  },
  {
    ID: 6,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "Office of the Special Representative of the Secretary-General on Sexual Violence in Conflict",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of the Special Representative of the Secretary-General on Sexual Violence in Conflict",
    Title: "Strengthened judicial response from national authorities to bolster survivor-centred justice and accountability for conflict-related sexual violence",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Reduced sexual violence, including its use as a tactic of war and terror, and reduced violence against children, including grave violations committed against children in situations of armed conflict.",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CO,CF,CD,UA",
    Image: "1POLICY7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=69"
  },
  {
    ID: 7,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "Office of the Special Representative of the Secretary-General on Sexual Violence in Conflict",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of the Special Representative of the Secretary-General on Sexual Violence in Conflict",
    Title: "Enhanced compliance with international norms on preventing and addressing conflict-related sexual violence",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Reduced sexual violence, including its use as a tactic of war and terror, and reduced violence against children, including grave violations committed against children in situations of armed conflict.",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=69"
  },
  {
    ID: 8,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "Office of the Special Representative of the Secretary-General on Violence Against Children",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of the Special Representative of the Secretary-General on Violence against Children",
    Title: "Strengthened commitment of the private sector to protect children from violence in the context of travel and tourism",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion of human rights",
    Beneficiary: "Youth",
    BeneficiaryTwo: "Private sector, including micro, small and medium-sized enterprises",
    SpecificResult: "Reduced sexual violence, including its use as a tactic of war and terror, and reduced violence against children, including grave violations committed against children in situations of armed conflict.",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=78"
  },
  {
    ID: 9,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "Office of the Special Representative of the Secretary-General on Violence Against Children",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of the Special Representative of the Secretary-General on Violence against Children",
    Title: "Revitalized pathfinding country initiative (Pathfinding Global Alliance on Ending Violence against Children) to end violence against children by 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "Youth",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Reduced sexual violence, including its use as a tactic of war and terror, and reduced violence against children, including grave violations committed against children in situations of armed conflict.",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=79"
  },
  {
    ID: 10,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "Office of the Special Representative of the Secretary-General on Violence Against Children",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of the Special Representative of the Secretary-General on Violence against Children",
    Title: "Member States adopt strategic road maps to accelerate action to end violence against children by 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "Youth",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Reduced sexual violence, including its use as a tactic of war and terror, and reduced violence against children, including grave violations committed against children in situations of armed conflict.",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=80"
  },
  {
    ID: 11,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "Office of the Special Representative of the Secretary-General on Violence Against Children",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of the Special Representative of the Secretary-General on Violence against Children",
    Title: "Peer learning between Member States accelerates action to end violence against children",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "Youth",
    BeneficiaryTwo: "International community",
    SpecificResult: "Reduced sexual violence, including its use as a tactic of war and terror, and reduced violence against children, including grave violations committed against children in situations of armed conflict.",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=80"
  },
  {
    ID: 12,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "Office of the United Nations Special Coordinator on Improving the United Nations Response to Sexual Exploitation and Abuse",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of the United Nations Special Coordinator on Improving the United Nations Response to Sexual Exploitation and Abuse",
    Title: "Expanded integration of protection measures in Country Cooperation Frameworks",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion of justice and international law",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Enhanced response against sexual exploitation and abuse, sexual harassment and fraud and corruption; improved mainstreaming of victim-centered approach",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=91"
  },
  {
    ID: 13,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "Office of the United Nations Special Coordinator on Improving the United Nations Response to Sexual Exploitation and Abuse",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of the United Nations Special Coordinator on Improving the United Nations Response to Sexual Exploitation and Abuse",
    Title: "One UN coordinated approach to more effectively address sexual exploitation and abuse",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Enhanced response against sexual exploitation and abuse, sexual harassment and fraud and corruption; improved mainstreaming of victim-centered approach",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=92"
  },
  {
    ID: 14,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "Office of the United Nations Special Coordinator on Improving the United Nations Response to Sexual Exploitation and Abuse",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of the United Nations Special Coordinator on Improving the United Nations Response to Sexual Exploitation and Abuse",
    Title: "Effective prevention and response efforts through the institutionalization of protection from sexual exploitation and abuse across the United Nations system",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Enhanced response against sexual exploitation and abuse, sexual harassment and fraud and corruption; improved mainstreaming of victim-centered approach",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=93"
  },
  {
    ID: 15,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "Office of the United Nations Special Coordinator on Improving the United Nations Response to Sexual Exploitation and Abuse",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of the United Nations Special Coordinator on Improving the United Nations Response to Sexual Exploitation and Abuse",
    Title: "Strengthened system-wide strategic approach to addressing sexual exploitation and abuse",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Enhanced response against sexual exploitation and abuse, sexual harassment and fraud and corruption; improved mainstreaming of victim-centered approach",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=94"
  },
  {
    ID: 16,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "Office of the United Nations Ombudsman and Mediation Services",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of the United Nations Ombudsman and Mediation Services",
    Title: "Managing workplace conflict better through capacity- and skill-building activities",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened mechanisms of internal justice and mediation for more ethical behaviour, enhanced harmony and improved access to justice within the UN",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=102"
  },
  {
    ID: 17,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "Office of the United Nations Ombudsman and Mediation Services",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of the United Nations Ombudsman and Mediation Services",
    Title: "United Nations non-staff personnel have access to informal conflict resolution services",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened mechanisms of internal justice and mediation for more ethical behaviour, enhanced harmony and improved access to justice within the UN",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=102"
  },
  {
    ID: 18,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "Office of the United Nations Ombudsman and Mediation Services",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of the United Nations Ombudsman and Mediation Services",
    Title: "Increased access of services for staff in the field",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened mechanisms of internal justice and mediation for more ethical behaviour, enhanced harmony and improved access to justice within the UN",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=103"
  },
  {
    ID: 19,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "Office of the United Nations Ombudsman and Mediation Services",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of the United Nations Ombudsman and Mediation Services",
    Title: "Improved awareness of mediation services",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened mechanisms of internal justice and mediation for more ethical behaviour, enhanced harmony and improved access to justice within the UN",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=103"
  },
  {
    ID: 20,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "Office of Administration of Justice",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of Administration of Justice",
    Title: "Improved capabilities in tracking cases filed at the United Nations Dispute Tribunal",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened mechanisms of internal justice and mediation for more ethical behaviour, enhanced harmony and improved access to justice within the UN",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=111"
  },
  {
    ID: 21,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "Office of Administration of Justice",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of Administration of Justice",
    Title: "Improved transparency of the system of administration of justice through the use of business intelligence and reporting on trend analysis",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened mechanisms of internal justice and mediation for more ethical behaviour, enhanced harmony and improved access to justice within the UN",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=111"
  },
  {
    ID: 22,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "Office of Administration of Justice",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of Administration of Justice",
    Title: "Increased use of legal advice from the Office of Staff Legal Assistance",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened mechanisms of internal justice and mediation for more ethical behaviour, enhanced harmony and improved access to justice within the UN",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=112"
  },
  {
    ID: 23,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "Office of Administration of Justice",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of Administration of Justice",
    Title: "More timely resolution of cases before the United Nations Dispute Tribunal",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened mechanisms of internal justice and mediation for more ethical behaviour, enhanced harmony and improved access to justice within the UN",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=113"
  },
  {
    ID: 24,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "Ethics Office",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Ethics Office",
    Title: "Increased staff confidence in seeking advice on protection against retaliation",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened mechanisms of internal justice and mediation for more ethical behaviour, enhanced harmony and improved access to justice within the UN",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=121"
  },
  {
    ID: 25,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "Ethics Office",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Ethics Office",
    Title: "Enhanced ethical awareness and access to ethics services by field personnel",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened mechanisms of internal justice and mediation for more ethical behaviour, enhanced harmony and improved access to justice within the UN",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=122"
  },
  {
    ID: 26,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "Ethics Office",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Ethics Office",
    Title: "Increased transparency and accountability through enhanced advice and guidance provided through the financial disclosure programme",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened mechanisms of internal justice and mediation for more ethical behaviour, enhanced harmony and improved access to justice within the UN",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=122"
  },
  {
    ID: 27,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "Ethics Office",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Ethics Office",
    Title: "Enhanced staff understanding of and timeliness in protection against retaliation processes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened mechanisms of internal justice and mediation for more ethical behaviour, enhanced harmony and improved access to justice within the UN",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=123"
  },
  {
    ID: 28,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "Resident coordinator system",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Resident coordinator system",
    Title: "National Governments advanced integrated policy approaches to Sustainable Development Goal acceleration",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "International community",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=132"
  },
  {
    ID: 29,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "Resident coordinator system",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Resident coordinator system",
    Title: "Increased transparency and accountability for United Nations results and the contribution to the Sustainable Development Goals through standard United Nations Sustainable Development Cooperation Framework indicators",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Increased capacity to report progress towards SDGs; Increased number / quality of voluntary national reviews.",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=133"
  },
  {
    ID: 30,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "Resident coordinator system",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Resident coordinator system",
    Title: "Enhanced effectiveness of United Nations support in achieving the Sustainable Development Goals through data-driven solutions and digital innovation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=134"
  },
  {
    ID: 31,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "Resident coordinator system",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Resident coordinator system",
    Title: "Safeguarding lives and livelihoods amid long-term socio-economic impacts of crises",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Public administration",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=135"
  },
  {
    ID: 32,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "United Nations Youth Office",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "United Nations Youth Office",
    Title: "Progress in advancing youth priorities and meaningful youth engagement",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Youth",
    BeneficiaryTwo: "International community",
    SpecificResult: "Strengthened  multilateralism",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=150"
  },
  {
    ID: 33,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "United Nations Youth Office",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "United Nations Youth Office",
    Title: "Youth engagement at all levels: moving from quantity to quality",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Youth",
    BeneficiaryTwo: "International community",
    SpecificResult: "Increased cooperation, information and best practice sharing for progress towards the SDGs",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=150"
  },
  {
    ID: 34,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "United Nations Youth Office",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "United Nations Youth Office",
    Title: "Towards a global youth investment platform to scale up youth-related programming",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Youth",
    BeneficiaryTwo: "International community",
    SpecificResult: "Increased capacity to report progress towards SDGs; Increased number / quality of voluntary national reviews.",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=151"
  },
  {
    ID: 35,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "United Nations Youth Office",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "United Nations Youth Office",
    Title: "Strengthened youth participation in peace and security processes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Youth",
    BeneficiaryTwo: "International community",
    SpecificResult: "Strengthened  multilateralism",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=151"
  },
  {
    ID: 36,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "Office of Data Protection and Privacy",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of Data Protection and Privacy",
    Title: "Increased operational readiness in data protection and privacy management",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=160"
  },
  {
    ID: 37,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "Office of Data Protection and Privacy",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of Data Protection and Privacy",
    Title: "Increased data protection and privacy across the Secretariat",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=160"
  },
  {
    ID: 38,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "Office of Data Protection and Privacy",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of Data Protection and Privacy",
    Title: "Optimized business processes to integrate and ensure compliance with the data protection and privacy policy across the Organization",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Enabling legal and regulatory frameworks; reduced exposure to legal liabilities",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=161"
  },
  {
    ID: 39,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "Office of Data Protection and Privacy",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office of Data Protection and Privacy",
    Title: "Enhanced organizational resilience and data protection and privacy-by-design maturity in the age of artificial intelligence",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Technological advancements that lead to improved quality, availability, accessibility and security of information",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=161"
  },
  {
    ID: 40,
    BudgetSection: 1,
    Entity: "ODET",
    EntityFullName: "Office for Digital and Emerging Technologies",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office for Digital and Emerging Technologies",
    Title: "Progress on the Global Digital Compact becomes visible to all stakeholders",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=168"
  },
  {
    ID: 41,
    BudgetSection: 1,
    Entity: "ODET",
    EntityFullName: "Office for Digital and Emerging Technologies",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office for Digital and Emerging Technologies",
    Title: "Strengthened multi-stakeholder commitment to the Global Digital Compact",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=169"
  },
  {
    ID: 42,
    BudgetSection: 1,
    Entity: "ODET",
    EntityFullName: "Office for Digital and Emerging Technologies",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "Office for Digital and Emerging Technologies",
    Title: "Advanced cooperation on international governance of artificial intelligence",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=169"
  },
  {
    ID: 43,
    BudgetSection: 1,
    Entity: "UNAOC",
    EntityFullName: "United Nations Alliance of Civilizations",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "United Nations Alliance of Civilizations",
    Title: "Enhanced ownership of Member States towards the promotion of a culture of peace, interreligious and intercultural dialogue for mutual understanding, and addressing all forms of religious intolerance",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion of human rights",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=180"
  },
  {
    ID: 44,
    BudgetSection: 1,
    Entity: "UNAOC",
    EntityFullName: "United Nations Alliance of Civilizations",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "United Nations Alliance of Civilizations",
    Title: "Increased awareness about contemporary trends in Islamophobia among State and non-State actors",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=181"
  },
  {
    ID: 45,
    BudgetSection: 1,
    Entity: "UNAOC",
    EntityFullName: "United Nations Alliance of Civilizations",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "United Nations Alliance of Civilizations",
    Title: "Enhanced United Nations system-wide coordination and stakeholder engagement to address antisemitism",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=181"
  },
  {
    ID: 46,
    BudgetSection: 1,
    Entity: "UNSWE",
    EntityFullName: "United Nations Sustainable Development Group System-wide Evaluation Office",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "United Nations Sustainable Development Group System-wide Evaluation Office",
    Title: "System-wide evaluation evidence informs UN80 Initiative decision-making",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=189"
  },
  {
    ID: 47,
    BudgetSection: 1,
    Entity: "UNSWE",
    EntityFullName: "United Nations Sustainable Development Group System-wide Evaluation Office",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "United Nations Sustainable Development Group System-wide Evaluation Office",
    Title: "Increased availability and use of system-wide evaluation results",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=190"
  },
  {
    ID: 48,
    BudgetSection: 1,
    Entity: "UNSWE",
    EntityFullName: "United Nations Sustainable Development Group System-wide Evaluation Office",
    Programme: "Overall policymaking, direction and coordination",
    Subprogramme: "United Nations Sustainable Development Group System-wide Evaluation Office",
    Title: "Improved use of United Nations system evaluation evidence by Member States and intergovernmental bodies for decision-making",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=en#page=190"
  },
  {
    ID: 49,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Department for General Assembly and Conference Management",
    Programme: "General Assembly and Economic and Social Council affairs and conference management",
    Subprogramme: "General Assembly and Economic and Social Council affairs",
    Title: "Increasing number of informal processes conducted by President of the General Assembly-appointed co-facilitators",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved multi-lateral meetings and deliberations",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=en#page=9"
  },
  {
    ID: 50,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Department for General Assembly and Conference Management",
    Programme: "General Assembly and Economic and Social Council affairs and conference management",
    Subprogramme: "General Assembly and Economic and Social Council affairs",
    Title: "Standardized information on the proceedings of various intergovernmental bodies available to delegates",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Technological advancements that lead to improved quality, availability, accessibility and security of information",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=en#page=9"
  },
  {
    ID: 51,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Department for General Assembly and Conference Management",
    Programme: "General Assembly and Economic and Social Council affairs and conference management",
    Subprogramme: "General Assembly and Economic and Social Council affairs",
    Title: "Simpler, more intuitive interaction between delegations and the Secretariat using the e-deleGATE platform",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved efficiency of processes due to science, technology and innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=en#page=10"
  },
  {
    ID: 52,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Department for General Assembly and Conference Management",
    Programme: "General Assembly and Economic and Social Council affairs and conference management",
    Subprogramme: "General Assembly and Economic and Social Council affairs",
    Title: "Improved availability of e-deleGATE modules to subsidiary organs",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved efficiency of processes due to science, technology and innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=en#page=10"
  },
  {
    ID: 53,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Department for General Assembly and Conference Management",
    Programme: "General Assembly and Economic and Social Council affairs and conference management",
    Subprogramme: "Planning and coordination of conference services",
    Title: "Increased number of meetings held away from Headquarters serviced",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BR,CA,CR,ET,FR,DE,MA,PA,QA,SA,ES,EI,TH,TM,UY",
    Image: "2DGACM5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=en#page=13"
  },
  {
    ID: 54,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Department for General Assembly and Conference Management",
    Programme: "General Assembly and Economic and Social Council affairs and conference management",
    Subprogramme: "Planning and coordination of conference services",
    Title: "Global gateway for servicing conferences and meetings",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved multi-lateral meetings and deliberations",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=en#page=13"
  },
  {
    ID: 55,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Department for General Assembly and Conference Management",
    Programme: "General Assembly and Economic and Social Council affairs and conference management",
    Subprogramme: "Planning and coordination of conference services",
    Title: "Increased feedback from Member States through the global survey",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=en#page=14"
  },
  {
    ID: 56,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Department for General Assembly and Conference Management",
    Programme: "General Assembly and Economic and Social Council affairs and conference management",
    Subprogramme: "Planning and coordination of conference services",
    Title: "Resilient operations ensured through cross-training in conference services",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=en#page=14"
  },
  {
    ID: 57,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Department for General Assembly and Conference Management",
    Programme: "General Assembly and Economic and Social Council affairs and conference management",
    Subprogramme: "Documentation services",
    Title: "Timely issuance of documentation sustained, notwithstanding constraints",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved multi-lateral meetings and deliberations",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=en#page=18"
  },
  {
    ID: 58,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Department for General Assembly and Conference Management",
    Programme: "General Assembly and Economic and Social Council affairs and conference management",
    Subprogramme: "Documentation services",
    Title: "High-quality multilingual documentation through translation quality management framework",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=en#page=19"
  },
  {
    ID: 59,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Department for General Assembly and Conference Management",
    Programme: "General Assembly and Economic and Social Council affairs and conference management",
    Subprogramme: "Documentation services",
    Title: "Timely availability of documentation for meetings",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved multi-lateral meetings and deliberations",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=en#page=20"
  },
  {
    ID: 60,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Department for General Assembly and Conference Management",
    Programme: "General Assembly and Economic and Social Council affairs and conference management",
    Subprogramme: "Documentation services",
    Title: "Equal treatment of official languages upheld",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved multi-lateral meetings and deliberations",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=en#page=20"
  },
  {
    ID: 61,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Department for General Assembly and Conference Management",
    Programme: "General Assembly and Economic and Social Council affairs and conference management",
    Subprogramme: "Meetings and publishing services",
    Title: "Quality maintained and efficiencies generated for meeting organizers through integrated global management of interpretation resources",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=en#page=24"
  },
  {
    ID: 62,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Department for General Assembly and Conference Management",
    Programme: "General Assembly and Economic and Social Council affairs and conference management",
    Subprogramme: "Meetings and publishing services",
    Title: "Increased interpretation services available to meet the growing demand of Member States for meetings with interpretation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=en#page=25"
  },
  {
    ID: 63,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Department for General Assembly and Conference Management",
    Programme: "General Assembly and Economic and Social Council affairs and conference management",
    Subprogramme: "Meetings and publishing services",
    Title: "Enhanced publishing products for Member States and the public",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Technological advancements that lead to improved quality, availability, accessibility and security of information",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=en#page=26"
  },
  {
    ID: 64,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "Department for General Assembly and Conference Management",
    Programme: "General Assembly and Economic and Social Council affairs and conference management",
    Subprogramme: "Meetings and publishing services",
    Title: "Meeting coverage sustained by leveraging in-house interpretation planning technology",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Technological advancements that lead to improved quality, availability, accessibility and security of information",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=en#page=26"
  },
  {
    ID: 65,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Prevention, management and resolution of conflicts",
    Title: "Member States and other stakeholders contribute to the review on the future of all forms of United Nations peace operations",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=13"
  },
  {
    ID: 66,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Prevention, management and resolution of conflicts",
    Title: "Reduced threats to international peace and security",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CO,LY,MZ,SD,QQ",
    Image: "3DPPA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=14"
  },
  {
    ID: 67,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Prevention, management and resolution of conflicts",
    Title: "Regional and subregional organizations have access to support on mediation, preventive diplomacy and good offices",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=14"
  },
  {
    ID: 68,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Prevention, management and resolution of conflicts",
    Title: "Member States have enhanced access to rapid mediation support",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=15"
  },
  {
    ID: 69,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Electoral assistance",
    Title: "Enhanced women’s leadership and participation in electoral and political processes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Women and girls",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=17"
  },
  {
    ID: 70,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Electoral assistance",
    Title: "Increased representation of women in electoral and political processes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Women and girls",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=18"
  },
  {
    ID: 71,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Electoral assistance",
    Title: "Strengthened capacity of Member States receiving United Nations electoral assistance through joint initiatives with regional and subregional organizations",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "International community",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=19"
  },
  {
    ID: 72,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Electoral assistance",
    Title: "Member States receive timely and effective response to requests for United Nations electoral assistance",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "International community",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=19"
  },
  {
    ID: 73,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Security Council affairs",
    Title: "Improved working methods of the Security Council through more timely consideration of members’ feedback",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved multi-lateral meetings and deliberations",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=22"
  },
  {
    ID: 74,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Security Council affairs",
    Title: "Enhanced engagement with Member States on the Security Council’s work",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=23"
  },
  {
    ID: 75,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Security Council affairs",
    Title: "Improved access for Member States and the public to up-to-date, contemporaneous analytical information on the practice and work of the Security Council",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=23"
  },
  {
    ID: 76,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Security Council affairs",
    Title: "Security Council members receive timely information on the implementation of sanctions measures",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=24"
  },
  {
    ID: 77,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Decolonization",
    Title: "Strengthened public awareness of decolonization",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=26"
  },
  {
    ID: 78,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Decolonization",
    Title: "The Special Committee has access to an up-to-date list of qualified experts on decolonization",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=27"
  },
  {
    ID: 79,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Decolonization",
    Title: "Increased dissemination of information on decolonization",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=27"
  },
  {
    ID: 80,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Decolonization",
    Title: "The Special Committee has access to enhanced reporting on assistance to Non-Self-Governing Territories",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Increased capacity to report progress towards SDGs; Increased number / quality of voluntary national reviews.",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=28"
  },
  {
    ID: 81,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Question of Palestine",
    Title: "Increased engagement and support by Member States for the Committee",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Strengthened  multilateralism",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=31"
  },
  {
    ID: 82,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Question of Palestine",
    Title: "Enhanced public outreach by the Committee on the question of Palestine",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=31"
  },
  {
    ID: 83,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Question of Palestine",
    Title: "Enhanced Committee briefings and engagement with the Security Council",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Strengthened  multilateralism",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=32"
  },
  {
    ID: 84,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Question of Palestine",
    Title: "Increased advocacy and public engagement by the Committee on the question of Palestine",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=32"
  },
  {
    ID: 85,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Peacebuilding Support Office",
    Title: "Member States strengthened national prevention and peacebuilding strategies and approaches",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Member States in Asia and the Pacific ",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "TD,MR,PG",
    Image: "3DPPA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=35"
  },
  {
    ID: 86,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Peacebuilding Support Office",
    Title: "Increased focus on mission transitions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=36"
  },
  {
    ID: 87,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Peacebuilding Support Office",
    Title: "Strengthened partnership with international financial institutions for nationally-owned peacebuilding and prevention strategies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=36"
  },
  {
    ID: 88,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Peacebuilding Support Office",
    Title: "Increased investment in Peacebuilding Fund initiatives reporting catalytic effects",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=37"
  },
  {
    ID: 89,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Cooperation between the United Nations and the League of Arab States",
    Title: "Enhanced cooperation between the League of Arab States and the United Nations on women’s rights and child protection in armed conflict",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=40"
  },
  {
    ID: 90,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Cooperation between the United Nations and the League of Arab States",
    Title: "Progress on preventive diplomacy, mediation and analysis by the League of Arab States",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=40"
  },
  {
    ID: 91,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Cooperation between the United Nations and the League of Arab States",
    Title: "Strengthened engagement with the General Secretariat of the League of Arab States and the League’s member States",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=41"
  },
  {
    ID: 92,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "Department of Political and Peacebuilding Affairs",
    Programme: "Political affairs",
    Subprogramme: "Cooperation between the United Nations and the League of Arab States",
    Title: "Strengthened United Nations-League of Arab States partnership in advancing conflict prevention and sustaining peace in the Arab region",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=42"
  },
  {
    ID: 93,
    BudgetSection: 3,
    Entity: "UNSCO",
    EntityFullName: "Office of the United Nations Special Coordinator for the Middle East Peace Process",
    Programme: "Political affairs",
    Subprogramme: "Office of the United Nations Special Coordinator for the Middle East Peace Process",
    Title: "Evidence-based recovery planning for Gaza",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=65"
  },
  {
    ID: 94,
    BudgetSection: 3,
    Entity: "UNSCO",
    EntityFullName: "Office of the United Nations Special Coordinator for the Middle East Peace Process",
    Programme: "Political affairs",
    Subprogramme: "Office of the United Nations Special Coordinator for the Middle East Peace Process",
    Title: "Progress towards a single Palestinian Government administering the entire Occupied Palestinian Territory, within the framework of a negotiated two-State solution",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "PS",
    Image: "3DPPA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=65"
  },
  {
    ID: 95,
    BudgetSection: 3,
    Entity: "UNSCO",
    EntityFullName: "Office of the United Nations Special Coordinator for the Middle East Peace Process",
    Programme: "Political affairs",
    Subprogramme: "Office of the United Nations Special Coordinator for the Middle East Peace Process",
    Title: "Towards a political framework to resolve the Israeli-Palestinian conflict",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "PS",
    Image: "3DPPA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=66"
  },
  {
    ID: 96,
    BudgetSection: 3,
    Entity: "UNSCO",
    EntityFullName: "Office of the United Nations Special Coordinator for the Middle East Peace Process",
    Programme: "Political affairs",
    Subprogramme: "Office of the United Nations Special Coordinator for the Middle East Peace Process",
    Title: "Progress towards the implementation of the Comprehensive Plan to End the Gaza Conflict as endorsed by the Security Council in resolution 2803 (2025)",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=67"
  },
  {
    ID: 97,
    BudgetSection: 3,
    Entity: "UNRoD",
    EntityFullName: "United Nations Register of Damage Caused by the Construction of the Wall in the Occupied Palestinian Territory",
    Programme: "Political affairs",
    Subprogramme: "United Nations Register of Damage Caused by the Construction of the Wall in the Occupied Palestinian Territory",
    Title: "Optimized damage claims review process for faster servicing of claimants",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Improved efficiency of processes due to science, technology and innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=75"
  },
  {
    ID: 98,
    BudgetSection: 3,
    Entity: "UNRoD",
    EntityFullName: "United Nations Register of Damage Caused by the Construction of the Wall in the Occupied Palestinian Territory",
    Programme: "Political affairs",
    Subprogramme: "United Nations Register of Damage Caused by the Construction of the Wall in the Occupied Palestinian Territory",
    Title: "Reduced number of unprocessed claims",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Improved efficiency of processes due to science, technology and innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "PS",
    Image: "3DPPA34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=76"
  },
  {
    ID: 99,
    BudgetSection: 3,
    Entity: "UNRoD",
    EntityFullName: "United Nations Register of Damage Caused by the Construction of the Wall in the Occupied Palestinian Territory",
    Programme: "Political affairs",
    Subprogramme: "United Nations Register of Damage Caused by the Construction of the Wall in the Occupied Palestinian Territory",
    Title: "Enhanced rectification process to complete deficient collected claims",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "PS",
    Image: "3DPPA35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=77"
  },
  {
    ID: 100,
    BudgetSection: 3,
    Entity: "UNRoD",
    EntityFullName: "United Nations Register of Damage Caused by the Construction of the Wall in the Occupied Palestinian Territory",
    Programme: "Political affairs",
    Subprogramme: "United Nations Register of Damage Caused by the Construction of the Wall in the Occupied Palestinian Territory",
    Title: "Decision-making by the Board strengthened by a harmonized submission process",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Improved efficiency of processes due to science, technology and innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=77"
  },
  {
    ID: 101,
    BudgetSection: 3,
    Entity: "UNOAU",
    EntityFullName: "United Nations Office to the African Union",
    Programme: "Political affairs",
    Subprogramme: "United Nations Office to the African Union",
    Title: "Somalia security transition took place and African Union peace support capacities strengthened",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SO",
    Image: "3DPPA37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=86"
  },
  {
    ID: 102,
    BudgetSection: 3,
    Entity: "UNOAU",
    EntityFullName: "United Nations Office to the African Union",
    Programme: "Political affairs",
    Subprogramme: "United Nations Office to the African Union",
    Title: "Advanced youth involvement in peace and security initiatives in Africa",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Youth",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "3DPPA38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=87"
  },
  {
    ID: 103,
    BudgetSection: 3,
    Entity: "UNOAU",
    EntityFullName: "United Nations Office to the African Union",
    Programme: "Political affairs",
    Subprogramme: "United Nations Office to the African Union",
    Title: "Enhancing joint United Nations-African Union efforts in preventing and mediating conflict, sustaining peace and addressing the root causes of conflict",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "3DPPA39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=88"
  },
  {
    ID: 104,
    BudgetSection: 3,
    Entity: "UNOAU",
    EntityFullName: "United Nations Office to the African Union",
    Programme: "Political affairs",
    Subprogramme: "United Nations Office to the African Union",
    Title: "Strengthened meaningful participation, leadership and influence of women in peace and security processes in Africa",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "3DPPA40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=88"
  },
  {
    ID: 105,
    BudgetSection: 3,
    Entity: "OCT",
    EntityFullName: "Office of Counter-Terrorism",
    Programme: "Political affairs",
    Subprogramme: "Office of Counter-Terrorism",
    Title: "A global network for victims of terrorism to advocate for their rights, shape policy and access support",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "International community",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=103"
  },
  {
    ID: 106,
    BudgetSection: 3,
    Entity: "OCT",
    EntityFullName: "Office of Counter-Terrorism",
    Programme: "Political affairs",
    Subprogramme: "Office of Counter-Terrorism",
    Title: "Member States advance their efforts in countering terrorist use of weapons",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=103"
  },
  {
    ID: 107,
    BudgetSection: 3,
    Entity: "OCT",
    EntityFullName: "Office of Counter-Terrorism",
    Programme: "Political affairs",
    Subprogramme: "Office of Counter-Terrorism",
    Title: "Enhanced national counter-terrorism capabilities through strengthened inter-agency coordination and intelligence analyst skills to prevent and counter terrorism",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "International community",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=104"
  },
  {
    ID: 108,
    BudgetSection: 3,
    Entity: "OCT",
    EntityFullName: "Office of Counter-Terrorism",
    Programme: "Political affairs",
    Subprogramme: "Office of Counter-Terrorism",
    Title: "Enhanced national capacity to counter the use of unmanned aircraft systems for terrorist purposes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=en#page=105"
  },
  {
    ID: 109,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "Office for Disarmament Affairs",
    Programme: "Disarmament",
    Subprogramme: "Multilateral negotiations and deliberations on disarmament and arms limitation",
    Title: "Increased annual reporting by High Contracting Parties to the Convention on Prohibitions or Restrictions on the Use of Certain Conventional Weapons Which May Be Deemed to Be Excessively Injurious or to Have Indiscriminate Effects",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Disarmament",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of disarmament, non-proliferation and arms control efforts and initiatives.",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=en#page=8"
  },
  {
    ID: 110,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "Office for Disarmament Affairs",
    Programme: "Disarmament",
    Subprogramme: "Multilateral negotiations and deliberations on disarmament and arms limitation",
    Title: "Increase in deliberations and eventual negotiations in the Conference on Disarmament",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Disarmament",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of disarmament, non-proliferation and arms control efforts and initiatives.",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=en#page=9"
  },
  {
    ID: 111,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "Office for Disarmament Affairs",
    Programme: "Disarmament",
    Subprogramme: "Multilateral negotiations and deliberations on disarmament and arms limitation",
    Title: "Prevention of an arms race in outer space",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Disarmament",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of disarmament, non-proliferation and arms control efforts and initiatives.",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=en#page=10"
  },
  {
    ID: 112,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "Office for Disarmament Affairs",
    Programme: "Disarmament",
    Subprogramme: "Multilateral negotiations and deliberations on disarmament and arms limitation",
    Title: "Addressing emerging technologies in the area of lethal autonomous weapons systems",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Disarmament",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of disarmament, non-proliferation and arms control efforts and initiatives.",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=en#page=10"
  },
  {
    ID: 113,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "Office for Disarmament Affairs",
    Programme: "Disarmament",
    Subprogramme: "Weapons of mass destruction",
    Title: "Member States from the Asia-Pacific region identify potential synergies for their engagement with instruments for addressing the threat posed by the proliferation or use of biological weapons",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Disarmament",
    Beneficiary: "Member States in Latin America and the Caribbean",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Advancement of disarmament, non-proliferation and arms control efforts and initiatives.",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CL,CO,CR,CU,DM,DO,EC,SV,GD,GT,GY,HT,HN,JM,MX,NI,PA,PY,PE,KN,LC,VC,SR,TT,UY,VE,AF,BH,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,IN,AP,ID,IR,IQ,JP,JO,KZ,KW,KG,LA,LB,MY,MV,MH,FM,MN,MM,NR,NP,OM,PK,PW,PG,PH,QA,KR,WS,SA,SG,SB,LK,SY,TJ,TH,TL,TO,TR,TM,TV,AE,UZ,VU,VN,YE",
    Image: "4ODA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=en#page=14"
  },
  {
    ID: 114,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "Office for Disarmament Affairs",
    Programme: "Disarmament",
    Subprogramme: "Weapons of mass destruction",
    Title: "Process to achieve the establishment of a Middle East zone free of nuclear weapons and other weapons of mass destruction",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Disarmament",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of disarmament, non-proliferation and arms control efforts and initiatives.",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,DJ,EG,QG,IR,IQ,JO,KW,LB,LY,MA,OM,QA,SA,SY,TN,AE,PS,YE",
    Image: "4ODA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=en#page=14"
  },
  {
    ID: 115,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "Office for Disarmament Affairs",
    Programme: "Disarmament",
    Subprogramme: "Weapons of mass destruction",
    Title: "Improved readiness of the Secretary-General’s Mechanism for Investigation of Alleged Use of Chemical and Biological Weapons",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Disarmament",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of disarmament, non-proliferation and arms control efforts and initiatives.",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=en#page=16"
  },
  {
    ID: 116,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "Office for Disarmament Affairs",
    Programme: "Disarmament",
    Subprogramme: "Weapons of mass destruction",
    Title: "Group of Scientific and Technical Experts on Nuclear Disarmament Verification advances understanding of technical challenges in and possible approaches to nuclear disarmament verification",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Disarmament",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of disarmament, non-proliferation and arms control efforts and initiatives.",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=en#page=16"
  },
  {
    ID: 117,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "Office for Disarmament Affairs",
    Programme: "Disarmament",
    Subprogramme: "Conventional arms",
    Title: "Increased understanding of and proposals to mitigate the impact of the global increase in military expenditure on progress towards the achievement of the Sustainable Development Goals",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Disarmament",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=en#page=21"
  },
  {
    ID: 118,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "Office for Disarmament Affairs",
    Programme: "Disarmament",
    Subprogramme: "Conventional arms",
    Title: "Increased utilization of the global assistance mechanism for through-life ammunition management",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Disarmament",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of disarmament, non-proliferation and arms control efforts and initiatives.",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=en#page=21"
  },
  {
    ID: 119,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "Office for Disarmament Affairs",
    Programme: "Disarmament",
    Subprogramme: "Conventional arms",
    Title: "Addressing developments in the manufacturing, technology and design of small arms and light weapons to prevent, combat and eradicate their illicit trade and misuse",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Disarmament",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of disarmament, non-proliferation and arms control efforts and initiatives.",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=en#page=22"
  },
  {
    ID: 120,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "Office for Disarmament Affairs",
    Programme: "Disarmament",
    Subprogramme: "Conventional arms",
    Title: "Strengthened expertise to advance implementation of the Programme of Action on Small Arms and Light Weapons and its International Tracing Instrument",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Disarmament",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of disarmament, non-proliferation and arms control efforts and initiatives.",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=en#page=23"
  },
  {
    ID: 121,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "Office for Disarmament Affairs",
    Programme: "Disarmament",
    Subprogramme: "Regional disarmament, capacity-building and outreach",
    Title: "Strengthened national disarmament expertise for advancing disarmament efforts",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Disarmament",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of disarmament, non-proliferation and arms control efforts and initiatives.",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SR,ZM",
    Image: "4ODA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=en#page=26"
  },
  {
    ID: 122,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "Office for Disarmament Affairs",
    Programme: "Disarmament",
    Subprogramme: "Regional disarmament, capacity-building and outreach",
    Title: "Global Mechanism on developments in the field of information and communications technologies in the context of international security and advancing responsible State behaviour in the use of information and communication technologies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Disarmament",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of disarmament, non-proliferation and arms control efforts and initiatives.",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=en#page=27"
  },
  {
    ID: 123,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "Office for Disarmament Affairs",
    Programme: "Disarmament",
    Subprogramme: "Multilateral negotiations and deliberations on disarmament and arms limitation",
    Title: "Strengthened disarmament expertise through the United Nations Disarmament Fellowship, Training and Advisory Services Programme",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Disarmament",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of disarmament, non-proliferation and arms control efforts and initiatives.",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=en#page=30"
  },
  {
    ID: 124,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "Office for Disarmament Affairs",
    Programme: "Disarmament",
    Subprogramme: "Information and outreach",
    Title: "Empowerment of youth in the field of disarmament and non-proliferation",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Disarmament",
    Beneficiary: "Youth",
    BeneficiaryTwo: "International community",
    SpecificResult: "Advancement of disarmament, non-proliferation and arms control efforts and initiatives.",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=en#page=30"
  },
  {
    ID: 125,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "Office for Disarmament Affairs",
    Programme: "Disarmament",
    Subprogramme: "Information and outreach",
    Title: "Increased awareness of disarmament and non-proliferation issues",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Disarmament",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of disarmament, non-proliferation and arms control efforts and initiatives.",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=en#page=31"
  },
  {
    ID: 126,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "Office for Disarmament Affairs",
    Programme: "Disarmament",
    Subprogramme: "Regional disarmament",
    Title: "Regional, subregional and national-level sensitization and support to the implementation of the Global Framework for Through-life Conventional Ammunition Management",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Disarmament",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of disarmament, non-proliferation and arms control efforts and initiatives.",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=en#page=31"
  },
  {
    ID: 127,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "Office for Disarmament Affairs",
    Programme: "Disarmament",
    Subprogramme: "Regional disarmament",
    Title: "Increased integration of disarmament into national development frameworks",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Disarmament",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of disarmament, non-proliferation and arms control efforts and initiatives.",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=en#page=32"
  },
  {
    ID: 128,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "Department of Peace Operations",
    Programme: "Peacekeeping operations",
    Subprogramme: "Operations",
    Title: "Progress in the implementation of the 2019 Political Agreement for Peace and Reconciliation in the Central African Republic",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Member States in Africa",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CF",
    Image: "5DPO1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=8"
  },
  {
    ID: 129,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "Department of Peace Operations",
    Programme: "Peacekeeping operations",
    Subprogramme: "Operations",
    Title: "Progress in the implementation of the 2018 Revitalized Agreement on the Resolution of the Conflict in the Republic of South Sudan",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Member States in Africa",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "SS,II",
    Image: "5DPO2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=8"
  },
  {
    ID: 130,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "Department of Peace Operations",
    Programme: "Peacekeeping operations",
    Subprogramme: "Operations",
    Title: "Strengthened peacebuilding in Abyei through the Joint Programme of the Resident Coordinators in the Sudan and South Sudan in Abyei",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Member States in Africa",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SS,II,SD,QQ",
    Image: "5DPO3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=9"
  },
  {
    ID: 131,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "Department of Peace Operations",
    Programme: "Peacekeeping operations",
    Subprogramme: "Operations",
    Title: "Enhanced disarmament, demobilization, repatriation, resettlement and reintegration of foreign combatants in eastern Democratic Republic of the Congo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Member States in Africa",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CD",
    Image: "5DPO4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=10"
  },
  {
    ID: 132,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "Department of Peace Operations",
    Programme: "Peacekeeping operations",
    Subprogramme: "Military",
    Title: "Strengthened preparedness for the transition and withdrawal of United Nations peacekeeping missions",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Improved performance, safety and security of PK missions, including smooth transitions following the Security Council resolutions",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CY,LB,SS,II,SD,QQ",
    Image: "5DPO5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=12"
  },
  {
    ID: 133,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "Department of Peace Operations",
    Programme: "Peacekeeping operations",
    Subprogramme: "Military",
    Title: "Missions establish explosive ordnance disposal capabilities to respond to threats posed by improvised explosive devices",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Improved performance, safety and security of PK missions, including smooth transitions following the Security Council resolutions",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "LB",
    Image: "5DPO6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=13"
  },
  {
    ID: 134,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "Department of Peace Operations",
    Programme: "Peacekeeping operations",
    Subprogramme: "Military",
    Title: "Peace operations respond to counter threats of hostile unmanned aircraft systems",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Improved performance, safety and security of PK missions, including smooth transitions following the Security Council resolutions",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CD,ML",
    Image: "5DPO7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=14"
  },
  {
    ID: 135,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "Department of Peace Operations",
    Programme: "Peacekeeping operations",
    Subprogramme: "Military",
    Title: "Peace operations strengthen monitoring, analysis and response to misinformation, disinformation and hate speech",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Improved performance, safety and security of PK missions, including smooth transitions following the Security Council resolutions",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CD,LB,ML,SS,II",
    Image: "5DPO8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=14"
  },
  {
    ID: 136,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "Department of Peace Operations",
    Programme: "Peacekeeping operations",
    Subprogramme: "Rule of law and security institutions",
    Title: "Strengthened national and regional capacities to mitigate the threats posed by improvised explosive devices",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=17"
  },
  {
    ID: 137,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "Department of Peace Operations",
    Programme: "Peacekeeping operations",
    Subprogramme: "Rule of law and security institutions",
    Title: "Improved performance of United Nations police to enhance mandate implementation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=18"
  },
  {
    ID: 138,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "Department of Peace Operations",
    Programme: "Peacekeeping operations",
    Subprogramme: "Rule of law and security institutions",
    Title: "Host States enabled to continue and sustain progress on rule of law and security institutions reform during and after mission transitions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CF,CD,ML,SO",
    Image: "5DPO11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=19"
  },
  {
    ID: 139,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "Department of Peace Operations",
    Programme: "Peacekeeping operations",
    Subprogramme: "Rule of law and security institutions",
    Title: "Increased accountability for crimes committed against United Nations personnel serving in peacekeeping operations",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CF,CD,LB,ML",
    Image: "5DPO12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=20"
  },
  {
    ID: 140,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "Department of Peace Operations",
    Programme: "Peacekeeping operations",
    Subprogramme: "Policy, evaluation and training",
    Title: "Strengthened policy and guidance for protection of civilians in African Union-led peace support operations",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Member States in Africa",
    BeneficiaryTwo: "International community",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "5DPO13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=23"
  },
  {
    ID: 141,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "Department of Peace Operations",
    Programme: "Peacekeeping operations",
    Subprogramme: "Policy, evaluation and training",
    Title: "An online platform to foster direct collaboration among Member States on the preparation of peacekeeping personnel",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=24"
  },
  {
    ID: 142,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "Department of Peace Operations",
    Programme: "Peacekeeping operations",
    Subprogramme: "Policy, evaluation and training",
    Title: "Improved analysis and planning at the field office level to address local conflict dynamics and promote political solutions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=25"
  },
  {
    ID: 143,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "Department of Peace Operations",
    Programme: "Peacekeeping operations",
    Subprogramme: "Policy, evaluation and training",
    Title: "Strengthened prevention and response to conflict-related sexual violence in peacekeeping operations",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Reduced sexual violence, including its use as a tactic of war and terror, and reduced violence against children, including grave violations committed against children in situations of armed conflict.",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=25"
  },
  {
    ID: 144,
    BudgetSection: 5,
    Entity: "UNTSO",
    EntityFullName: "United Nations Truce Supervision Organization",
    Programme: "Peacekeeping operations",
    Subprogramme: "United Nations Truce Supervision Organization",
    Title: "Enhanced observation along the ceasefire line and in the area of separation",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=43"
  },
  {
    ID: 145,
    BudgetSection: 5,
    Entity: "UNTSO",
    EntityFullName: "United Nations Truce Supervision Organization",
    Programme: "Peacekeeping operations",
    Subprogramme: "United Nations Truce Supervision Organization",
    Title: "Increased engagement in the mandate and work of the United Nations Truce Supervision Organization",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=43"
  },
  {
    ID: 146,
    BudgetSection: 5,
    Entity: "UNTSO",
    EntityFullName: "United Nations Truce Supervision Organization",
    Programme: "Peacekeeping operations",
    Subprogramme: "United Nations Truce Supervision Organization",
    Title: "Strengthened organizational ability to adapt to changing operating environments",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved performance, safety and security of PK missions, including smooth transitions following the Security Council resolutions",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=44"
  },
  {
    ID: 147,
    BudgetSection: 5,
    Entity: "UNTSO",
    EntityFullName: "United Nations Truce Supervision Organization",
    Programme: "Peacekeeping operations",
    Subprogramme: "United Nations Truce Supervision Organization",
    Title: "Strengthened planning and coordination mechanisms in southern Lebanon",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved performance, safety and security of PK missions, including smooth transitions following the Security Council resolutions",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=45"
  },
  {
    ID: 148,
    BudgetSection: 5,
    Entity: "UNMOGIP",
    EntityFullName: "United Nations Military Observer Group in India and Pakistan",
    Programme: "Peacekeeping operations",
    Subprogramme: "United Nations Military Observer Group in India and Pakistan",
    Title: "Limited number of complaints concerning alleged ceasefire violations",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "IN,AP,PK",
    Image: "5DPO21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=52"
  },
  {
    ID: 149,
    BudgetSection: 5,
    Entity: "UNMOGIP",
    EntityFullName: "United Nations Military Observer Group in India and Pakistan",
    Programme: "Peacekeeping operations",
    Subprogramme: "United Nations Military Observer Group in India and Pakistan",
    Title: "Improved situational awareness through geospatial information systems",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "IN,AP,PK",
    Image: "5DPO22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=53"
  },
  {
    ID: 150,
    BudgetSection: 5,
    Entity: "UNMOGIP",
    EntityFullName: "United Nations Military Observer Group in India and Pakistan",
    Programme: "Peacekeeping operations",
    Subprogramme: "United Nations Military Observer Group in India and Pakistan",
    Title: "Continued presence at the line of control",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "IN,AP,PK",
    Image: "5DPO23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=54"
  },
  {
    ID: 151,
    BudgetSection: 5,
    Entity: "UNMOGIP",
    EntityFullName: "United Nations Military Observer Group in India and Pakistan",
    Programme: "Peacekeeping operations",
    Subprogramme: "United Nations Military Observer Group in India and Pakistan",
    Title: "Enhanced mutual understanding through strengthened liaison and engagement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "IN,AP,PK",
    Image: "5DPO24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=en#page=54"
  },
  {
    ID: 152,
    BudgetSection: 6,
    Entity: "OOSA",
    EntityFullName: "Office for Outer Space Affairs",
    Programme: "Peaceful uses of outer space",
    Subprogramme: "Peaceful uses of outer space",
    Title: "Enhanced planning and preparedness for potentially hazardous near-Earth objects",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "6COPUOS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.6)&l=en#page=4"
  },
  {
    ID: 153,
    BudgetSection: 6,
    Entity: "OOSA",
    EntityFullName: "Office for Outer Space Affairs",
    Programme: "Peaceful uses of outer space",
    Subprogramme: "Peaceful uses of outer space",
    Title: "Increased access to space",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "6COPUOS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.6)&l=en#page=5"
  },
  {
    ID: 154,
    BudgetSection: 6,
    Entity: "OOSA",
    EntityFullName: "Office for Outer Space Affairs",
    Programme: "Peaceful uses of outer space",
    Subprogramme: "Peaceful uses of outer space",
    Title: "Greater access to space solutions, partnerships, capacity-building and involvement in governance of outer space activities",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: "LDCs, LLDCs, SIDS and other developing countries",
    SpecificResult: "Strengthened  multilateralism",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "6COPUOS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.6)&l=en#page=6"
  },
  {
    ID: 155,
    BudgetSection: 6,
    Entity: "OOSA",
    EntityFullName: "Office for Outer Space Affairs",
    Programme: "Peaceful uses of outer space",
    Subprogramme: "Peaceful uses of outer space",
    Title: "Increased use of space-based technology and data for disaster management and emergency response",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintenance of international peace and security",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Technological advancements that lead to improved quality, availability, accessibility and security of information",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "6COPUOS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.6)&l=en#page=6"
  },
  {
    ID: 156,
    BudgetSection: 7,
    Entity: "ICJ",
    EntityFullName: "International Court of Justice",
    Programme: "International Court of Justice",
    Subprogramme: "Registry",
    Title: "Enhanced understanding of the Court’s activities among the general public",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.7)&l=en#page=4"
  },
  {
    ID: 157,
    BudgetSection: 7,
    Entity: "ICJ",
    EntityFullName: "International Court of Justice",
    Programme: "International Court of Justice",
    Subprogramme: "Registry",
    Title: "Enhanced process of transmission and receipt of documents relating to judicial proceedings",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.7)&l=en#page=4"
  },
  {
    ID: 158,
    BudgetSection: 7,
    Entity: "ICJ",
    EntityFullName: "International Court of Justice",
    Programme: "International Court of Justice",
    Subprogramme: "Registry",
    Title: "Increased availability of information about the Court on social media platforms",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.7)&l=en#page=5"
  },
  {
    ID: 159,
    BudgetSection: 7,
    Entity: "ICJ",
    EntityFullName: "International Court of Justice",
    Programme: "International Court of Justice",
    Subprogramme: "Registry",
    Title: "Increased visibility and understanding of the Court’s activities among young people",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: "Youth",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.7)&l=en#page=5"
  },
  {
    ID: 160,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "Provision of legal services to the United Nations system as a whole",
    Title: "Legal frameworks for establishing a new United Nations field operation in Haiti and support for the multinational Gang Suppression Force in Haiti",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Enabling legal and regulatory frameworks; reduced exposure to legal liabilities",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "HT",
    Image: "8OLA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=9"
  },
  {
    ID: 161,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "Provision of legal services to the United Nations system as a whole",
    Title: "Conclusion of an agreement concerning continuing residual functions of the Extraordinary Chambers in the Courts of Cambodia",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Enabling legal and regulatory frameworks; reduced exposure to legal liabilities",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "KH",
    Image: "8OLA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=10"
  },
  {
    ID: 162,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "Provision of legal services to the United Nations system as a whole",
    Title: "Legal and procedural framework for United Nations conferences, including the 2026 United Nations Water Conference to Accelerate the Implementation of Sustainable Development Goal 6",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Enabling legal and regulatory frameworks; reduced exposure to legal liabilities",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SN,AE",
    Image: "8OLA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=11"
  },
  {
    ID: 163,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "Provision of legal services to the United Nations system as a whole",
    Title: "Advancement of organizational reforms and institutional transitions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Enabling legal and regulatory frameworks; reduced exposure to legal liabilities",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=12"
  },
  {
    ID: 164,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "General legal services provided to United Nations organs and programmes",
    Title: "Access by client offices to standard contract templates",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Enabling legal and regulatory frameworks; reduced exposure to legal liabilities",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=14"
  },
  {
    ID: 165,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "General legal services provided to United Nations organs and programmes",
    Title: "Access by client offices to legal advice facilitated by the updated matter management system",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Enabling legal and regulatory frameworks; reduced exposure to legal liabilities",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=15"
  },
  {
    ID: 166,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "General legal services provided to United Nations organs and programmes",
    Title: "Access by client offices to updated United Nations General Conditions of Contract",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Enabling legal and regulatory frameworks; reduced exposure to legal liabilities",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=15"
  },
  {
    ID: 167,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "General legal services provided to United Nations organs and programmes",
    Title: "Access by client offices to an updated model contract for the provision of air cargo services",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Enabling legal and regulatory frameworks; reduced exposure to legal liabilities",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=16"
  },
  {
    ID: 168,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "Progressive development and codification of international law",
    Title: "Special Committee on the Charter of the United Nations and on the Strengthening of the Role of the Organization adopted a substantive report",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=18"
  },
  {
    ID: 169,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "Progressive development and codification of international law",
    Title: "Applications from more States for the training programmes in international law under the Programme of Assistance",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=18"
  },
  {
    ID: 170,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "Progressive development and codification of international law",
    Title: "Increased access by the international legal community to documentary materials of a legal character concerning the United Nations and related intergovernmental organizations in the United Nations Juridical Yearbook",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=19"
  },
  {
    ID: 171,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "Progressive development and codification of international law",
    Title: "Better understanding of the legal issues concerning the settlement of disputes to which international organizations are parties",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=20"
  },
  {
    ID: 172,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "Law of the sea and ocean affairs",
    Title: "Required conditions met for the entry into force of the Agreement on Marine Biological Diversity of Areas beyond National Jurisdiction",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: "Climate and environment",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=22"
  },
  {
    ID: 173,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "Law of the sea and ocean affairs",
    Title: "Enhanced commitment of Member States to the conservation and sustainable use of oceans and their resources through the implementation of international law",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: "Climate and environment",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=23"
  },
  {
    ID: 174,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "Law of the sea and ocean affairs",
    Title: "Strengthened science-policy interface for the protection of the marine environment and the conservation and sustainable use of marine resources",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: "Climate and environment",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=24"
  },
  {
    ID: 175,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "Law of the sea and ocean affairs",
    Title: "Strengthened role of the Commission on the Limits of the Continental Shelf and its subcommissions in accordance with the United Nations Convention on the Law of the Sea",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: "Climate and environment",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=24"
  },
  {
    ID: 176,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "Progressive harmonization, modernization and unification of the law of international trade",
    Title: "Strengthened judicial capacity in applying guidance provided in United Nations Commission on International Trade Law insolvency law texts",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: "Private sector, including micro, small and medium-sized enterprises",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=28"
  },
  {
    ID: 177,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "Progressive harmonization, modernization and unification of the law of international trade",
    Title: "Greater legal certainty for commercial data transactions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: "Private sector, including micro, small and medium-sized enterprises",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=29"
  },
  {
    ID: 178,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "Progressive harmonization, modernization and unification of the law of international trade",
    Title: "United Nations Commission on International Trade Law considers the relevance of its instruments on public procurement framework",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=30"
  },
  {
    ID: 179,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "Progressive harmonization, modernization and unification of the law of international trade",
    Title: "Implementation of the reforms to investor-State dispute settlement through a multilateral framework convention mechanism",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: "Private sector, including micro, small and medium-sized enterprises",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=30"
  },
  {
    ID: 180,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "Custody, registration and publication of treaties",
    Title: "Opening for signature of the United Nations Convention against Cybercrime; Strengthening International Cooperation for Combating Certain Crimes Committed by Means of Information and Communications Technology Systems and for the Sharing of Evidence in Electronic Form of Serious Crimes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=33"
  },
  {
    ID: 181,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "Custody, registration and publication of treaties",
    Title: "Member States advance discussion on treaty practice",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=34"
  },
  {
    ID: 182,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "Custody, registration and publication of treaties",
    Title: "Treaties and treaty actions are made publicly available in the United Nations Treaty Series",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=34"
  },
  {
    ID: 183,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "Office of Legal Affairs",
    Programme: "Legal affairs",
    Subprogramme: "Custody, registration and publication of treaties",
    Title: "Member States address the role of international cooperation, including in the use of technology and capacity-building, in strengthening the international treaty framework",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=35"
  },
  {
    ID: 184,
    BudgetSection: 8,
    Entity: "IIMM",
    EntityFullName: "Independent Investigative Mechanism for Myanmar",
    Programme: "Legal affairs",
    Subprogramme: "Independent Investigative Mechanism for Myanmar",
    Title: "Competent authorities have access to forensic analysis of open-source information",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "MM",
    Image: "8OLA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=60"
  },
  {
    ID: 185,
    BudgetSection: 8,
    Entity: "IIMM",
    EntityFullName: "Independent Investigative Mechanism for Myanmar",
    Programme: "Legal affairs",
    Subprogramme: "Independent Investigative Mechanism for Myanmar",
    Title: "Victims, survivors, civil society and information providers engage in accountability processes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "MM",
    Image: "8OLA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=61"
  },
  {
    ID: 186,
    BudgetSection: 8,
    Entity: "IIMM",
    EntityFullName: "Independent Investigative Mechanism for Myanmar",
    Programme: "Legal affairs",
    Subprogramme: "Independent Investigative Mechanism for Myanmar",
    Title: "Increased access to evidence with the broadest possible admissibility in national, regional and international courts",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "MM",
    Image: "8OLA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=62"
  },
  {
    ID: 187,
    BudgetSection: 8,
    Entity: "IIMM",
    EntityFullName: "Independent Investigative Mechanism for Myanmar",
    Programme: "Legal affairs",
    Subprogramme: "Independent Investigative Mechanism for Myanmar",
    Title: "Witnesses and sources contribute to accountability efforts securely and with necessary psychosocial support",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "MM",
    Image: "8OLA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=62"
  },
  {
    ID: 188,
    BudgetSection: 8,
    Entity: "IIIM",
    EntityFullName: "International, Impartial and Independent Mechanism to Assist in the Investigation and Prosecution of Persons Responsible for the Most Serious Crimes under International Law Committed in the Syrian Arab Republic since March 2011",
    Programme: "Legal affairs",
    Subprogramme: "International, Impartial and Independent Mechanism to Assist in the Investigation and Prosecution of Persons Responsible for the Most Serious Crimes under International Law Committed in the Syrian Arab Republic since March 2011",
    Title: "Steps towards Syrian-led transitional justice",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SY",
    Image: "8OLA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=72"
  },
  {
    ID: 189,
    BudgetSection: 8,
    Entity: "IIIM",
    EntityFullName: "International, Impartial and Independent Mechanism to Assist in the Investigation and Prosecution of Persons Responsible for the Most Serious Crimes under International Law Committed in the Syrian Arab Republic since March 2011",
    Programme: "Legal affairs",
    Subprogramme: "International, Impartial and Independent Mechanism to Assist in the Investigation and Prosecution of Persons Responsible for the Most Serious Crimes under International Law Committed in the Syrian Arab Republic since March 2011",
    Title: "Enhanced protection and support to victims, witnesses or other sources cooperating with the Mechanism",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SY",
    Image: "8OLA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=73"
  },
  {
    ID: 190,
    BudgetSection: 8,
    Entity: "IIIM",
    EntityFullName: "International, Impartial and Independent Mechanism to Assist in the Investigation and Prosecution of Persons Responsible for the Most Serious Crimes under International Law Committed in the Syrian Arab Republic since March 2011",
    Programme: "Legal affairs",
    Subprogramme: "International, Impartial and Independent Mechanism to Assist in the Investigation and Prosecution of Persons Responsible for the Most Serious Crimes under International Law Committed in the Syrian Arab Republic since March 2011",
    Title: "An integrated approach for inclusive justice",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "SY",
    Image: "8OLA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=73"
  },
  {
    ID: 191,
    BudgetSection: 8,
    Entity: "IIIM",
    EntityFullName: "International, Impartial and Independent Mechanism to Assist in the Investigation and Prosecution of Persons Responsible for the Most Serious Crimes under International Law Committed in the Syrian Arab Republic since March 2011",
    Programme: "Legal affairs",
    Subprogramme: "International, Impartial and Independent Mechanism to Assist in the Investigation and Prosecution of Persons Responsible for the Most Serious Crimes under International Law Committed in the Syrian Arab Republic since March 2011",
    Title: "Syrian-led, Syrian-owned truth, justice and accountability for the most serious crimes under international law committed in the Syrian Arab Republic since 2011",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of justice and international law",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SY",
    Image: "8OLA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=en#page=74"
  },
  {
    ID: 192,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Intergovernmental support and coordination for sustainable development",
    Title: "Reaffirmed political commitments to the 2030 Agenda for Sustainable Development on its tenth anniversary",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=16"
  },
  {
    ID: 193,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Intergovernmental support and coordination for sustainable development",
    Title: "Strengthened role of the Economic and Social Council to support Member States to translate commitments from the Sustainable Development Goals Summit into actions and national policies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Increased capacity to report progress towards SDGs; Increased number / quality of voluntary national reviews.",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=17"
  },
  {
    ID: 194,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Intergovernmental support and coordination for sustainable development",
    Title: "Accelerated achievement of the Sustainable Development Goals through an effective preparatory process for voluntary national reviews",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Increased capacity to report progress towards SDGs; Increased number / quality of voluntary national reviews.",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=18"
  },
  {
    ID: 195,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Intergovernmental support and coordination for sustainable development",
    Title: "Strengthened Economic and Social Council guidance to the United Nations development system for improved delivery of operational activities for development",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Increased cooperation, information and best practice sharing for progress towards the SDGs",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=18"
  },
  {
    ID: 196,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Inclusive social development",
    Title: "The World Social Report 2025 informed social policy dialogue in intergovernmental bodies",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=22"
  },
  {
    ID: 197,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Inclusive social development",
    Title: "Improved coherence of the United Nations system efforts in addressing the needs of Indigenous Peoples",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "International community",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=22"
  },
  {
    ID: 198,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Inclusive social development",
    Title: "Accelerated social development through the Second World Summit for Social Development",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=23"
  },
  {
    ID: 199,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Inclusive social development",
    Title: "Improved quality of life of older persons through the fifth review and appraisal of the implementation of the Madrid International Plan of Action on Ageing",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=23"
  },
  {
    ID: 200,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Sustainable development",
    Title: "Implementation plan for the United Nations Decade of Sustainable Transport (2026–2035) launched",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "International community",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=26"
  },
  {
    ID: 201,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Sustainable development",
    Title: "Accelerated progress for Sustainable Development Goal 14 through the third United Nations Ocean Conference",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=27"
  },
  {
    ID: 202,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Sustainable development",
    Title: "Accelerating the achievement of Sustainable Development Goal 6 through the 2026 United Nations Water Conference",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=27"
  },
  {
    ID: 203,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Sustainable development",
    Title: "The Global Sustainable Development Report 2027 guides the implementation of the 2030 Agenda",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Increased cooperation, information and best practice sharing for progress towards the SDGs",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=28"
  },
  {
    ID: 204,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Statistics",
    Title: "Users have improved understanding of migration statistics",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=31"
  },
  {
    ID: 205,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Statistics",
    Title: "UNdata modernization",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "International community",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=31"
  },
  {
    ID: 206,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Statistics",
    Title: "Improved global capacity for evidence-based Sustainable Development Goals progress monitoring",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "International community",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=32"
  },
  {
    ID: 207,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Statistics",
    Title: "Member States implement the System of National Accounts 2025",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "International community",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=32"
  },
  {
    ID: 208,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Population",
    Title: "National and district population projections produced using internationally recognized probabilistic methods",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "International community",
    SpecificResult: "Improved information on population, migration, civil registrations and demographics including sex-disaggregated statistics",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "UG",
    Image: "9DESA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=36"
  },
  {
    ID: 209,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Population",
    Title: "Enhanced comparability of estimates and projections of urbanization and spatial distribution for the Sustainable Development Goals",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "International community",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=37"
  },
  {
    ID: 210,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Population",
    Title: "Enhanced online tools for demographic analysis, projection and visualization",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "International community",
    SpecificResult: "Improved information on population, migration, civil registrations and demographics including sex-disaggregated statistics",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=37"
  },
  {
    ID: 211,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Population",
    Title: "Strengthened evidence base on international migration to support policymaking and promote a well-informed public discourse",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Improved information on population, migration, civil registrations and demographics including sex-disaggregated statistics",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=38"
  },
  {
    ID: 212,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Economic analysis and policy",
    Title: "Improved digital tools to strengthen government officials’ knowledge of macroeconomics and trade",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=41"
  },
  {
    ID: 213,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Economic analysis and policy",
    Title: "Use of advanced policy simulation tools for data-driven and evidence-informed policymaking",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "International community",
    SpecificResult: "Increased capacity to report progress towards SDGs; Increased number / quality of voluntary national reviews.",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=42"
  },
  {
    ID: 214,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Economic analysis and policy",
    Title: "Increased engagement and use of analytical products for evidence-based policymaking",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "International community",
    SpecificResult: "Increased cooperation, information and best practice sharing for progress towards the SDGs",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=43"
  },
  {
    ID: 215,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Economic analysis and policy",
    Title: "Least developed countries are prepared to navigate the graduation process and post-graduation landscape",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: " ",
    SpecificResult: "Increased cooperation, information and best practice sharing for progress towards the SDGs",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "9DESA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=43"
  },
  {
    ID: 216,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Institutions and digital transformation",
    Title: "Supreme audit institutions assessed the implementation of Sustainable Development Goal 13 on climate action",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Climate and environment",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=47"
  },
  {
    ID: 217,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Institutions and digital transformation",
    Title: "National implementation of the principles of effective governance for sustainable development to enhance trust in public institutions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "International community",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=47"
  },
  {
    ID: 218,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Institutions and digital transformation",
    Title: "Efficient and resilient response to future challenges and opportunities to accelerate sustainable development",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=48"
  },
  {
    ID: 219,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Institutions and digital transformation",
    Title: "Public officials apply behavioural insights and adopt good practices to advance innovation and digital transformation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=49"
  },
  {
    ID: 220,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Sustainable forest management",
    Title: "Member States commence implementation of the new quadrennial programme of work (2025–2028) to accelerate the United Nations Strategic Plan for Forests",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: "Climate and environment",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=52"
  },
  {
    ID: 221,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Sustainable forest management",
    Title: "Increased reach of the United Nations Forum on Forests and contribution of forests to the 2030 Agenda",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: "Climate and environment",
    SpecificResult: "Increased capacity to report progress towards SDGs; Increased number / quality of voluntary national reviews.",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=53"
  },
  {
    ID: 222,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Sustainable forest management",
    Title: "Advancement of the Sustainable Development Goals through the United Nations Strategic Plan for Forests 2017–2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: "Climate and environment",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=53"
  },
  {
    ID: 223,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Sustainable forest management",
    Title: "Strengthened commitment and action by the International Arrangement on Forests to achieve the Global Forest Goals",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: "Climate and environment",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=54"
  },
  {
    ID: 224,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Financing for sustainable development",
    Title: "A new financing framework, the Sevilla Commitment, adopted as a follow-up to the Addis Ababa Action Agenda",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=57"
  },
  {
    ID: 225,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Financing for sustainable development",
    Title: "Strengthened engagement of Member States in the financing for development follow-up process to improve coherence and implementation of agreed outcomes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=58"
  },
  {
    ID: 226,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Financing for sustainable development",
    Title: "Enhanced engagement of developing countries in shaping international tax norms",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=59"
  },
  {
    ID: 227,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "Department of Economic and Social Affairs",
    Programme: "Economic and social affairs",
    Subprogramme: "Financing for sustainable development",
    Title: "International debt architecture is operationalized",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=en#page=59"
  },
  {
    ID: 228,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "Office of the High Representative for the Least Developed Countries, Landlocked Developing Countries and Small Island Developing States",
    Programme: "Least developed countries, landlocked developing countries and small island developing States",
    Subprogramme: "Least developed countries",
    Title: "Accelerated implementation and strengthened monitoring of the Doha Programme of Action for the Least Developed Countries",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: " ",
    SpecificResult: "Increased capacity to report progress towards SDGs; Increased number / quality of voluntary national reviews.",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=en#page=8"
  },
  {
    ID: 229,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "Office of the High Representative for the Least Developed Countries, Landlocked Developing Countries and Small Island Developing States",
    Programme: "Least developed countries, landlocked developing countries and small island developing States",
    Subprogramme: "Least developed countries",
    Title: "A new food stockholding mechanism to reduce food insecurity in least developed countries",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=en#page=9"
  },
  {
    ID: 230,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "Office of the High Representative for the Least Developed Countries, Landlocked Developing Countries and Small Island Developing States",
    Programme: "Least developed countries, landlocked developing countries and small island developing States",
    Subprogramme: "Least developed countries",
    Title: "Strengthened resilience to external shocks in the least developed countries",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: " ",
    SpecificResult: "Inclusive and sustainable recovery from disasters; building resilience for future disasters",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=en#page=9"
  },
  {
    ID: 231,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "Office of the High Representative for the Least Developed Countries, Landlocked Developing Countries and Small Island Developing States",
    Programme: "Least developed countries, landlocked developing countries and small island developing States",
    Subprogramme: "Least developed countries",
    Title: "Least developing countries strengthen pathways for sustainable and irreversible graduation from the least developed country category",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: " ",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=en#page=10"
  },
  {
    ID: 232,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "Office of the High Representative for the Least Developed Countries, Landlocked Developing Countries and Small Island Developing States",
    Programme: "Least developed countries, landlocked developing countries and small island developing States",
    Subprogramme: "Landlocked developing countries",
    Title: "Adoption of the Awaza Political Declaration at the third United Nations Conference on Landlocked Developing Countries",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: " ",
    SpecificResult: "Increased cooperation, information and best practice sharing for progress towards the SDGs",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=en#page=13"
  },
  {
    ID: 233,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "Office of the High Representative for the Least Developed Countries, Landlocked Developing Countries and Small Island Developing States",
    Programme: "Least developed countries, landlocked developing countries and small island developing States",
    Subprogramme: "Landlocked developing countries",
    Title: "Strategic financing for development initiatives to enhance landlocked developing countries’ economic resilience",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=en#page=14"
  },
  {
    ID: 234,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "Office of the High Representative for the Least Developed Countries, Landlocked Developing Countries and Small Island Developing States",
    Programme: "Least developed countries, landlocked developing countries and small island developing States",
    Subprogramme: "Landlocked developing countries",
    Title: "Advancement of freedom of transit issues for landlocked developing countries",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=en#page=15"
  },
  {
    ID: 235,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "Office of the High Representative for the Least Developed Countries, Landlocked Developing Countries and Small Island Developing States",
    Programme: "Least developed countries, landlocked developing countries and small island developing States",
    Subprogramme: "Landlocked developing countries",
    Title: "Mainstreaming of the Awaza Programme of Action for Landlocked Developing Countries into national and sectoral development strategies, development cooperation frameworks and strategic plans",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: " ",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=en#page=15"
  },
  {
    ID: 236,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "Office of the High Representative for the Least Developed Countries, Landlocked Developing Countries and Small Island Developing States",
    Programme: "Least developed countries, landlocked developing countries and small island developing States",
    Subprogramme: "Small island developing States",
    Title: "Advancing debt sustainability for small island developing States",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=en#page=18"
  },
  {
    ID: 237,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "Office of the High Representative for the Least Developed Countries, Landlocked Developing Countries and Small Island Developing States",
    Programme: "Least developed countries, landlocked developing countries and small island developing States",
    Subprogramme: "Small island developing States",
    Title: "Data-driven decisions to address structural vulnerabilities and resilience of small island developing States",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: " ",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=en#page=19"
  },
  {
    ID: 238,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "Office of the High Representative for the Least Developed Countries, Landlocked Developing Countries and Small Island Developing States",
    Programme: "Least developed countries, landlocked developing countries and small island developing States",
    Subprogramme: "Small island developing States",
    Title: "Small island developing States use the monitoring and reporting framework for the Antigua and Barbuda Agenda for Small Island Developing States to inform national planning strategies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: " ",
    SpecificResult: "Increased capacity to report progress towards SDGs; Increased number / quality of voluntary national reviews.",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=en#page=19"
  },
  {
    ID: 239,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "Office of the High Representative for the Least Developed Countries, Landlocked Developing Countries and Small Island Developing States",
    Programme: "Least developed countries, landlocked developing countries and small island developing States",
    Subprogramme: "Small island developing States",
    Title: "Unlocking strategic partnerships to accelerate implementation of the Antigua and Barbuda Agenda for Small Island Developing States",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved cooperation and partnerships and increased coherence, synergies and reduced overlap through consistent communication",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=en#page=20"
  },
  {
    ID: 240,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "Office of the High Representative for the Least Developed Countries, Landlocked Developing Countries and Small Island Developing States",
    Programme: "Least developed countries, landlocked developing countries and small island developing States",
    Subprogramme: "Advocacy, outreach and analysis",
    Title: "Strengthened integration of the three programmes of action into relevant intergovernmental processes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: " ",
    SpecificResult: "Increased capacity to report progress towards SDGs; Increased number / quality of voluntary national reviews.",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AO,AG,AM,AZ,BS,SD,QQ,BD,BZ,BJ,BT,BO,BW,BF,BI,CV,KH,CF,TD,KM,CK,CU,CD,DJ,DM,DO,ER,SZ,ET,FJ,GM,GD,GN,GW,HT,JM,KZ,KG,KI,LA,LS,LR,MK,MG,MW,MV,ML,MH,MR,MU,FM,MN,MZ,MM,NR,NP,NE,NU,PW,PG,PY,MD,RW,KN,LC,VC,WS,SN,SC,SL,SB,SO,SS,II,SD,QQ,SR,TJ,TL,TG,TO,TT,TM,TV,UG,TZ,UZ,VU,YE,ZM,ZW",
    Image: "10UNOHRLLS13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=en#page=23"
  },
  {
    ID: 241,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "Office of the High Representative for the Least Developed Countries, Landlocked Developing Countries and Small Island Developing States",
    Programme: "Least developed countries, landlocked developing countries and small island developing States",
    Subprogramme: "Advocacy, outreach and analysis",
    Title: "Real-time analytics and monitoring of the three programmes of action to inform policy formulation, planning and decision-making",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,AG,AM,AZ,BS,SD,QQ,BD,BZ,BJ,BT,BO,BW,BF,BI,CV,KH,CF,TD,KM,CK,CU,CD,DJ,DM,DO,ER,SZ,ET,FJ,GM,GD,GN,GW,HT,JM,KZ,KG,KI,LA,LS,LR,MK,MG,MW,MV,ML,MH,MR,MU,FM,MN,MZ,MM,NR,NP,NE,NU,PW,PG,PY,MD,RW,KN,LC,VC,WS,SN,SC,SL,SB,SO,SS,II,SD,QQ,SR,TJ,TL,TG,TO,TT,TM,TV,UG,TZ,UZ,VU,YE,ZM,ZW",
    Image: "10UNOHRLLS14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=en#page=23"
  },
  {
    ID: 242,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "Office of the Special Adviser on Africa",
    Programme: "United Nations system support for the African Union’s Agenda 2063: The Africa We Want",
    Subprogramme: "Data and knowledge management for evidence-based policies and advocacy in support of Agenda 2063",
    Title: "African policymakers applied integrated analytical approaches to promote long-term peace and development outcomes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Development of Africa",
    Beneficiary: "Member States in Africa",
    BeneficiaryTwo: " ",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=en#page=8"
  },
  {
    ID: 243,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "Office of the Special Adviser on Africa",
    Programme: "United Nations system support for the African Union’s Agenda 2063: The Africa We Want",
    Subprogramme: "Data and knowledge management for evidence-based policies and advocacy in support of Agenda 2063",
    Title: "Digital solutions to transform financial systems and manage debt in Africa",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Member States in Africa",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=en#page=9"
  },
  {
    ID: 244,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "Office of the Special Adviser on Africa",
    Programme: "United Nations system support for the African Union’s Agenda 2063: The Africa We Want",
    Subprogramme: "Data and knowledge management for evidence-based policies and advocacy in support of Agenda 2063",
    Title: "Policy ecosystems to equip the workforce of Africa in a global digital economy",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Member States in Africa",
    BeneficiaryTwo: "Private sector, including micro, small and medium-sized enterprises",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=en#page=10"
  },
  {
    ID: 245,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "Office of the Special Adviser on Africa",
    Programme: "United Nations system support for the African Union’s Agenda 2063: The Africa We Want",
    Subprogramme: "Data and knowledge management for evidence-based policies and advocacy in support of Agenda 2063",
    Title: "Strengthened policy on youth education and skills development to address food insecurity and promote climate resilience in Africa",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Member States in Africa",
    BeneficiaryTwo: "Youth",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=en#page=10"
  },
  {
    ID: 246,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "Office of the Special Adviser on Africa",
    Programme: "United Nations system support for the African Union’s Agenda 2063: The Africa We Want",
    Subprogramme: "Regional coordination of United Nations support for the integrated implementation of the 2030 Agenda for Sustainable Development and Agenda 2063",
    Title: "Domestic resource mobilization strategy adopted to finance the second 10-year implementation plan of Agenda 2063",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Development of Africa",
    Beneficiary: "Member States in Africa",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=en#page=13"
  },
  {
    ID: 247,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "Office of the Special Adviser on Africa",
    Programme: "United Nations system support for the African Union’s Agenda 2063: The Africa We Want",
    Subprogramme: "Regional coordination of United Nations support for the integrated implementation of the 2030 Agenda for Sustainable Development and Agenda 2063",
    Title: "Long-term strategies for debt management in Africa",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Member States in Africa",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=en#page=13"
  },
  {
    ID: 248,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "Office of the Special Adviser on Africa",
    Programme: "United Nations system support for the African Union’s Agenda 2063: The Africa We Want",
    Subprogramme: "Regional coordination of United Nations support for the integrated implementation of the 2030 Agenda for Sustainable Development and Agenda 2063",
    Title: "Strengthened responsiveness and accountability of public institutions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Member States in Africa",
    BeneficiaryTwo: "Public administration",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=en#page=14"
  },
  {
    ID: 249,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "Office of the Special Adviser on Africa",
    Programme: "United Nations system support for the African Union’s Agenda 2063: The Africa We Want",
    Subprogramme: "Regional coordination of United Nations support for the integrated implementation of the 2030 Agenda for Sustainable Development and Agenda 2063",
    Title: "African Member States develop policies to address the impacts of climate change",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Member States in Africa",
    BeneficiaryTwo: "Climate and environment",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=en#page=14"
  },
  {
    ID: 250,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "Office of the Special Adviser on Africa",
    Programme: "United Nations system support for the African Union’s Agenda 2063: The Africa We Want",
    Subprogramme: "Public information and awareness activities in support of Agenda 2063",
    Title: "Media partnership with a reach of 130 million highlights African perspectives on artificial intelligence and digital employment",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Development of Africa",
    Beneficiary: "Member States in Africa",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=en#page=17"
  },
  {
    ID: 251,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "Office of the Special Adviser on Africa",
    Programme: "United Nations system support for the African Union’s Agenda 2063: The Africa We Want",
    Subprogramme: "Public information and awareness activities in support of Agenda 2063",
    Title: "Engagement of the general public on Africa’s debt burden and potential solutions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Member States in Africa",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=en#page=17"
  },
  {
    ID: 252,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "Office of the Special Adviser on Africa",
    Programme: "United Nations system support for the African Union’s Agenda 2063: The Africa We Want",
    Subprogramme: "Public information and awareness activities in support of Agenda 2063",
    Title: "Strengthened outreach by media partners on education, decent jobs and social protection in Africa",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Member States in Africa",
    BeneficiaryTwo: "International community",
    SpecificResult: "Improved cooperation and partnerships and increased coherence, synergies and reduced overlap through consistent communication",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=en#page=18"
  },
  {
    ID: 253,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "Office of the Special Adviser on Africa",
    Programme: "United Nations system support for the African Union’s Agenda 2063: The Africa We Want",
    Subprogramme: "Public information and awareness activities in support of Agenda 2063",
    Title: "Increased visibility of youth-led solutions for climate resilience",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Member States in Africa",
    BeneficiaryTwo: "Youth",
    SpecificResult: "Improved cooperation and partnerships and increased coherence, synergies and reduced overlap through consistent communication",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=en#page=18"
  },
  {
    ID: 254,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "United Nations Conference on Trade and Development",
    Programme: "Trade and development",
    Subprogramme: "Globalization, interdependence and development",
    Title: "Trade and Development Foresights informs global policy discussions and responses",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: "LDCs, LLDCs, SIDS and other developing countries",
    SpecificResult: "Increased cooperation, information and best practice sharing for progress towards the SDGs",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=en#page=12"
  },
  {
    ID: 255,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "United Nations Conference on Trade and Development",
    Programme: "Trade and development",
    Subprogramme: "Globalization, interdependence and development",
    Title: "Enhanced debt data transparency of developing countries",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EC,EG,QG,JO",
    Image: "12UNCTAD2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=en#page=13"
  },
  {
    ID: 256,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "United Nations Conference on Trade and Development",
    Programme: "Trade and development",
    Subprogramme: "Globalization, interdependence and development",
    Title: "Developing economies design sustainable industrial and structural transformation policies through South-South and triangular cooperation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: "Private sector, including micro, small and medium-sized enterprises",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "KZ,MY,PK,TR",
    Image: "12UNCTAD3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=en#page=13"
  },
  {
    ID: 257,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "United Nations Conference on Trade and Development",
    Programme: "Trade and development",
    Subprogramme: "Globalization, interdependence and development",
    Title: "Borrower countries manage debt in a more efficient and sustainable way",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=en#page=14"
  },
  {
    ID: 258,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "United Nations Conference on Trade and Development",
    Programme: "Trade and development",
    Subprogramme: "Investment and enterprise",
    Title: "Strengthened entrepreneurship ecosystems for inclusive and innovative enterprise development",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: " ",
    SpecificResult: "Entrepreneurship and increased competitiveness of micro, small and medium-sized enterprises",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=en#page=18"
  },
  {
    ID: 259,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "United Nations Conference on Trade and Development",
    Programme: "Trade and development",
    Subprogramme: "Investment and enterprise",
    Title: "Accelerated Sustainable Development Goal investment",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=en#page=18"
  },
  {
    ID: 260,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "United Nations Conference on Trade and Development",
    Programme: "Trade and development",
    Subprogramme: "Investment and enterprise",
    Title: "Member States foster conducive business and investment climate",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=en#page=19"
  },
  {
    ID: 261,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "United Nations Conference on Trade and Development",
    Programme: "Trade and development",
    Subprogramme: "Investment and enterprise",
    Title: "Increased adoption of sustainable investment practices",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "International community",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=en#page=20"
  },
  {
    ID: 262,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "United Nations Conference on Trade and Development",
    Programme: "Trade and development",
    Subprogramme: "International trade and commodities",
    Title: "Enhanced consumer product safety",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "International community",
    SpecificResult: "Strengthened  multilateralism",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=en#page=25"
  },
  {
    ID: 263,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "United Nations Conference on Trade and Development",
    Programme: "Trade and development",
    Subprogramme: "International trade and commodities",
    Title: "Strengthened implementation of nationally determined contributions through trade policies by developing countries",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "GM",
    Image: "12UNCTAD10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=en#page=25"
  },
  {
    ID: 264,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "United Nations Conference on Trade and Development",
    Programme: "Trade and development",
    Subprogramme: "International trade and commodities",
    Title: "Member States harness critical energy transition minerals for sustainable development",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "International community",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "NA,ZM",
    Image: "12UNCTAD11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=en#page=26"
  },
  {
    ID: 265,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "United Nations Conference on Trade and Development",
    Programme: "Trade and development",
    Subprogramme: "International trade and commodities",
    Title: "Timely non-tariff measures data for better regulatory practices and economic development",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=en#page=27"
  },
  {
    ID: 266,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "United Nations Conference on Trade and Development",
    Programme: "Trade and development",
    Subprogramme: "Technology and logistics",
    Title: "Developing countries advance the conceptualization and development of science, technology and innovation parks for sustainable development",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "LDCs, LLDCs, SIDS and other developing countries",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "GH,MN,MZ,UZ",
    Image: "12UNCTAD13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=en#page=32"
  },
  {
    ID: 267,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "United Nations Conference on Trade and Development",
    Programme: "Trade and development",
    Subprogramme: "Technology and logistics",
    Title: "Improved availability of digital economy statistics in developing countries",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: "Private sector, including micro, small and medium-sized enterprises",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=en#page=33"
  },
  {
    ID: 268,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "United Nations Conference on Trade and Development",
    Programme: "Trade and development",
    Subprogramme: "Technology and logistics",
    Title: "Enhanced efficiency and sustainability of trade procedures",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "LDCs, LLDCs, SIDS and other developing countries",
    SpecificResult: "Improved efficiency of processes due to science, technology and innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "JM,VC,TJ,TL,VU,ZW",
    Image: "12UNCTAD15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=en#page=33"
  },
  {
    ID: 269,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "United Nations Conference on Trade and Development",
    Programme: "Trade and development",
    Subprogramme: "Technology and logistics",
    Title: "Strengthening inclusion in trade facilitation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Women and girls",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=en#page=34"
  },
  {
    ID: 270,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "United Nations Conference on Trade and Development",
    Programme: "Trade and development",
    Subprogramme: "Africa, least developed countries and special programmes",
    Title: "Least developed countries identify a common position on rules of origin and agenda for the Fourteenth Ministerial Conference of the World Trade Organization",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened  multilateralism",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,AG,AM,AZ,BS,SD,QQ,BD,BZ,BJ,BT,BO,BW,BF,BI,CV,KH,CF,TD,KM,CK,CU,CD,DJ,DM,DO,ER,SZ,ET,FJ,GM,GD,GN,GW,HT,JM,KZ,KG,KI,LA,LS,LR,MK,MG,MW,MV,ML,MH,MR,MU,FM,MN,MZ,MM,NR,NP,NE,NU,PW,PG,PY,MD,RW,KN,LC,VC,WS,SN,SC,SL,SB,SO,SS,II,SD,QQ,SR,TJ,TL,TG,TO,TT,TM,TV,UG,TZ,UZ,VU,YE,ZM,ZW",
    Image: "12UNCTAD17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=en#page=39"
  },
  {
    ID: 271,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "United Nations Conference on Trade and Development",
    Programme: "Trade and development",
    Subprogramme: "Africa, least developed countries and special programmes",
    Title: "Enhanced statistical capacity of least developed countries and other developing countries, to help embrace a paradigm shift in the formulation of holistic economic diversification policies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AO,ET,KE,NG",
    Image: "12UNCTAD18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=en#page=40"
  },
  {
    ID: 272,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "United Nations Conference on Trade and Development",
    Programme: "Trade and development",
    Subprogramme: "Africa, least developed countries and special programmes",
    Title: "Enhanced capacity of small island developing States to build productive capacities",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,KM,DO,MV,JM,VC,TT",
    Image: "12UNCTAD19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=en#page=41"
  },
  {
    ID: 273,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "United Nations Conference on Trade and Development",
    Programme: "Trade and development",
    Subprogramme: "Africa, least developed countries and special programmes",
    Title: "Least developed countries enabled to formulate and implement inclusive and coherent trade policies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BF,TD,TZ",
    Image: "12UNCTAD20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=en#page=41"
  },
  {
    ID: 274,
    BudgetSection: 13,
    Entity: "ITC",
    EntityFullName: "International Trade Centre",
    Programme: "International Trade Centre",
    Subprogramme: "Operational aspects of trade promotion and export development",
    Title: "Strengthened innovation, business and job opportunities in Africa and Latin America for youth start-ups and entrepreneurs",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Youth",
    SpecificResult: "Entrepreneurship and increased competitiveness of micro, small and medium-sized enterprises",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CO,UG",
    Image: "13ITC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.13)&l=en#page=5"
  },
  {
    ID: 275,
    BudgetSection: 13,
    Entity: "ITC",
    EntityFullName: "International Trade Centre",
    Programme: "International Trade Centre",
    Subprogramme: "Operational aspects of trade promotion and export development",
    Title: "Strengthened services provided by local business support organizations to small businesses to capitalize on the African Continental Free Trade Area",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "LDCs, LLDCs, SIDS and other developing countries",
    SpecificResult: "Entrepreneurship and increased competitiveness of micro, small and medium-sized enterprises",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "13ITC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.13)&l=en#page=5"
  },
  {
    ID: 276,
    BudgetSection: 13,
    Entity: "ITC",
    EntityFullName: "International Trade Centre",
    Programme: "International Trade Centre",
    Subprogramme: "Operational aspects of trade promotion and export development",
    Title: "Transition of textile and clothing small and medium-sized enterprises in Africa and the Asia-Pacific region to sustainable operations",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "LDCs, LLDCs, SIDS and other developing countries",
    SpecificResult: "Entrepreneurship and increased competitiveness of micro, small and medium-sized enterprises",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW,AF,BH,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,IN,AP,ID,IR,IQ,JP,JO,KZ,KW,KG,LA,LB,MY,MV,MH,FM,MN,MM,NR,NP,OM,PK,PW,PG,PH,QA,KR,WS,SA,SG,SB,LK,SY,TJ,TH,TL,TO,TR,TM,TV,AE,UZ,VU,VN,YE",
    Image: "13ITC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.13)&l=en#page=6"
  },
  {
    ID: 277,
    BudgetSection: 13,
    Entity: "ITC",
    EntityFullName: "International Trade Centre",
    Programme: "International Trade Centre",
    Subprogramme: "Operational aspects of trade promotion and export development",
    Title: "Strengthened export competitiveness of small and medium-sized enterprises from Eastern Europe and Central Asia",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: " ",
    SpecificResult: "Entrepreneurship and increased competitiveness of micro, small and medium-sized enterprises",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AM,KZ,KG,TJ,UZ",
    Image: "13ITC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.13)&l=en#page=7"
  },
  {
    ID: 278,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Climate action",
    Title: "Cities commit to sustainable cooling targets",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=10"
  },
  {
    ID: 279,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Climate action",
    Title: "Member States develop national methane road maps and action plans",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=11"
  },
  {
    ID: 280,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Climate action",
    Title: "Member States adopt environmentally sound technologies for climate change mitigation and adaptation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=12"
  },
  {
    ID: 281,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Climate action",
    Title: "Governments at the national and subnational levels adopt climate adaptation strategies and policies, including national adaptation plans",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=13"
  },
  {
    ID: 282,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Digital transformations in supporting environmental action",
    Title: "Governments and policymakers gained access to an artificial intelligence-powered environment portal",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=15"
  },
  {
    ID: 283,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Digital transformations in supporting environmental action",
    Title: "Increased interoperability of global environmental data",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=16"
  },
  {
    ID: 284,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Digital transformations in supporting environmental action",
    Title: "Strengthened digital capacities to drive environmental sustainability",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Technological advancements that lead to improved quality, availability, accessibility and security of information",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=16"
  },
  {
    ID: 285,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Digital transformations in supporting environmental action",
    Title: "World Environment Situation Room informs policy decision-making",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=17"
  },
  {
    ID: 286,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Nature action",
    Title: "Member States commit to protecting marine biodiversity beyond national borders",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=19"
  },
  {
    ID: 287,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Nature action",
    Title: "Public sector institutions capture the economic contribution of biodiversity and ecosystem services in decision-making",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=20"
  },
  {
    ID: 288,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Nature action",
    Title: "Strengthened resilience of coastal reef ecosystems and local communities",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Inclusive and sustainable recovery from disasters; building resilience for future disasters",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=21"
  },
  {
    ID: 289,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Nature action",
    Title: "Expansion of sustainably managed and restored ecosystems",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=21"
  },
  {
    ID: 290,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Environmental governance",
    Title: "Member States advance legal frameworks and national strategies to address illegal waste trafficking",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=24"
  },
  {
    ID: 291,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Environmental governance",
    Title: "Reduced production and consumption of hydrofluorocarbons through the implementation of the Kigali Amendment to the Montreal Protocol on Substances that Deplete the Ozone Layer",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=25"
  },
  {
    ID: 292,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Environmental governance",
    Title: "Legal stakeholders enhance the implementation and enforcement of environmental law",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancement of international law and enhanced international dispute resolution mechanisms",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=25"
  },
  {
    ID: 293,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Environmental governance",
    Title: "Environmental objectives are integrated into national policy and legal frameworks",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=26"
  },
  {
    ID: 294,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Chemicals and pollution action",
    Title: "Chemicals of global concern and their waste reduced",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=28"
  },
  {
    ID: 295,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Chemicals and pollution action",
    Title: "Adoption of policies and practices to support circular economy approaches in high-impact sectors to reduce pollution",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=29"
  },
  {
    ID: 296,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Chemicals and pollution action",
    Title: "Adoption of policies and strategies to address the environmental dimensions of antimicrobial resistance",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=30"
  },
  {
    ID: 297,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Chemicals and pollution action",
    Title: "Member States adopt policies, laws or regulations on chemicals and waste management in key sectors",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=30"
  },
  {
    ID: 298,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Finance and economic transformations",
    Title: "Insurance companies commit to sustainability approaches in their business practices",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved cooperation and partnerships and increased coherence, synergies and reduced overlap through consistent communication",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=33"
  },
  {
    ID: 299,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Finance and economic transformations",
    Title: "Increased availability of tools and measures to transform choices and behaviour by governments, businesses and individual consumers for environmental sustainability",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=34"
  },
  {
    ID: 300,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Finance and economic transformations",
    Title: "Accelerating progress towards sustainable consumption and production patterns",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=34"
  },
  {
    ID: 301,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Finance and economic transformations",
    Title: "Member States adopt policies to increase sustainable finance",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=35"
  },
  {
    ID: 302,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Science policy",
    Title: "Countries implement the System of Environmental-Economic Accounting",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=38"
  },
  {
    ID: 303,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Science policy",
    Title: "Improved electronic waste (e-waste) monitoring and collection",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=38"
  },
  {
    ID: 304,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Science policy",
    Title: "Strengthened science-policy interface in Latin America and the Caribbean",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CL,CO,CR,CU,DM,DO,EC,SV,GD,GT,GY,HT,HN,JM,MX,NI,PA,PY,PE,KN,LC,VC,SR,TT,UY,VE",
    Image: "14UNEP27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=39"
  },
  {
    ID: 305,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "United Nations Environment Programme",
    Programme: "Environment",
    Subprogramme: "Science policy",
    Title: "Governments and institutions use United Nations Environment Programme knowledge, data, statistics and assessments to inform policymaking",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=en#page=40"
  },
  {
    ID: 306,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "United Nations Human Settlements Programme",
    Programme: "Human settlements",
    Subprogramme: "Housing, land, basic services and urban environment",
    Title: "Integrated sustainable mobility and transit‑supportive housing to expand equitable access to safe, equitable public transport in cities, particularly city peripheries",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "GH,KE,NG,UG",
    Image: "15UN-Habitat1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=en#page=12"
  },
  {
    ID: 307,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "United Nations Human Settlements Programme",
    Programme: "Human settlements",
    Subprogramme: "Housing, land, basic services and urban environment",
    Title: "Cities and countries commit to providing adequate housing for all and addressing homelessness and housing exclusion",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CR,KM,CU,MX",
    Image: "15UN-Habitat2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=en#page=13"
  },
  {
    ID: 308,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "United Nations Human Settlements Programme",
    Programme: "Human settlements",
    Subprogramme: "Housing, land, basic services and urban environment",
    Title: "Increased security of tenure rights to land",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "NP",
    Image: "15UN-Habitat3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=en#page=14"
  },
  {
    ID: 309,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "United Nations Human Settlements Programme",
    Programme: "Human settlements",
    Subprogramme: "Housing, land, basic services and urban environment",
    Title: "Increased access to adequate housing, land and basic services",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=en#page=14"
  },
  {
    ID: 310,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "United Nations Human Settlements Programme",
    Programme: "Human settlements",
    Subprogramme: "Planning, finance policy, localization and governance",
    Title: "Planning law reforms strengthen multilevel governance for resilient and sustainable cities",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BW,SL,ZW",
    Image: "15UN-Habitat5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=en#page=18"
  },
  {
    ID: 311,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "United Nations Human Settlements Programme",
    Programme: "Human settlements",
    Subprogramme: "Planning, finance policy, localization and governance",
    Title: "Upgraded own-source revenue systems to improve the performance of local governments",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=en#page=18"
  },
  {
    ID: 312,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "United Nations Human Settlements Programme",
    Programme: "Human settlements",
    Subprogramme: "Planning, finance policy, localization and governance",
    Title: "Sustainable Development Goals localization fosters system change and territorial transformation by nurturing inclusive multilevel governance, stakeholder participation, institutional capacities and finance for local solutions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=en#page=19"
  },
  {
    ID: 313,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "United Nations Human Settlements Programme",
    Programme: "Human settlements",
    Subprogramme: "Knowledge, data, digitalization and capacity development",
    Title: "Urban practitioners have open access to practical knowledge and guidance in multiple languages to help accelerate the implementation of the New Urban Agenda and the Sustainable Development Goals",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Youth",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=en#page=22"
  },
  {
    ID: 314,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "United Nations Human Settlements Programme",
    Programme: "Human settlements",
    Subprogramme: "Knowledge, data, digitalization and capacity development",
    Title: "Digital transformation for sustainable urban development",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=en#page=23"
  },
  {
    ID: 315,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "United Nations Human Settlements Programme",
    Programme: "Human settlements",
    Subprogramme: "Knowledge, data, digitalization and capacity development",
    Title: "National and local authorities increase and improve the production of disaggregated and policy-relevant data on housing, land and basic services (cumulative)",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=en#page=24"
  },
  {
    ID: 316,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "United Nations Human Settlements Programme",
    Programme: "Human settlements",
    Subprogramme: "Partnerships, coalitions, advocacy and communication",
    Title: "The Global Stakeholder Forum advances inclusive and accountable urban development",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Increased cooperation, information and best practice sharing for progress towards the SDGs",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=en#page=26"
  },
  {
    ID: 317,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "United Nations Human Settlements Programme",
    Programme: "Human settlements",
    Subprogramme: "Partnerships, coalitions, advocacy and communication",
    Title: "The World Urban Forum is leveraged to advance global commitments to ensure adequate housing, land and basic services for all",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Increased cooperation, information and best practice sharing for progress towards the SDGs",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=en#page=27"
  },
  {
    ID: 318,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "United Nations Human Settlements Programme",
    Programme: "Human settlements",
    Subprogramme: "Strengthened climate action and improved urban environment",
    Title: "Nationally determined contributions increasingly contain urban content",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Climate and environment",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=en#page=30"
  },
  {
    ID: 319,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "United Nations Human Settlements Programme",
    Programme: "Human settlements",
    Subprogramme: "Strengthened climate action and improved urban environment",
    Title: "Urban climate action plans to build the resilience of the most vulnerable",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Inclusive and sustainable recovery from disasters; building resilience for future disasters",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=en#page=31"
  },
  {
    ID: 320,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "United Nations Human Settlements Programme",
    Programme: "Human settlements",
    Subprogramme: "Effective urban crisis prevention and response",
    Title: "Sustainable integration of displaced communities in urban areas in Somalia",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "SO",
    Image: "15UN-Habitat15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=en#page=32"
  },
  {
    ID: 321,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "United Nations Human Settlements Programme",
    Programme: "Human settlements",
    Subprogramme: "Effective urban crisis prevention and response",
    Title: "Integrated and participatory urban planning and inclusive development",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SO",
    Image: "15UN-Habitat16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=en#page=33"
  },
  {
    ID: 322,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Countering transnational organized crime",
    Title: "Strengthened international cooperation on combating cybercrime and sharing electronic evidence for serious crimes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "International community",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=20"
  },
  {
    ID: 323,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Countering transnational organized crime",
    Title: "Improved registration and traceability of firearms, parts, components and ammunition",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "International community",
    SpecificResult: "Enhanced control on drugs, illicit goods and trafficking in persons; reduced illicit financial flows",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "HN,SN",
    Image: "16UNODC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=21"
  },
  {
    ID: 324,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Countering transnational organized crime",
    Title: "Enhanced detection of trafficking by air, sea and land",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "International community",
    SpecificResult: "Enhanced control on drugs, illicit goods and trafficking in persons; reduced illicit financial flows",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=21"
  },
  {
    ID: 325,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Countering transnational organized crime",
    Title: "Strengthened normative, policy and institutional responses against organized crime globally",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "International community",
    SpecificResult: "Enhanced control on drugs, illicit goods and trafficking in persons; reduced illicit financial flows",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=22"
  },
  {
    ID: 326,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "A comprehensive and balanced approach to counter the world drug problem",
    Title: "Enhanced ability of Member States to disrupt criminal networks engaged in drug trafficking through strengthened case-based international cooperation",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "International community",
    SpecificResult: "Enhanced control on drugs, illicit goods and trafficking in persons; reduced illicit financial flows",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AR,BO,BR,CV,CL,CI,DE,PE",
    Image: "16UNODC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=25"
  },
  {
    ID: 327,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "A comprehensive and balanced approach to counter the world drug problem",
    Title: "Member States in sub-Saharan Africa implement stronger health and development interventions in the context of addressing the world drug problem",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "16UNODC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=25"
  },
  {
    ID: 328,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "A comprehensive and balanced approach to counter the world drug problem",
    Title: "Global gaps in service provision filled through new health and development initiatives implemented at the national level",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=26"
  },
  {
    ID: 329,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "A comprehensive and balanced approach to counter the world drug problem",
    Title: "Forensic laboratory personnel equipped in the analysis and identification of synthetic drugs and precursor chemicals used in their manufacture",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "International community",
    SpecificResult: "Enhanced control on drugs, illicit goods and trafficking in persons; reduced illicit financial flows",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=27"
  },
  {
    ID: 330,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Countering corruption",
    Title: "Member States investigate, prosecute and adjudicate complex international corruption cases",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DO,KE,MY,PA,TZ,VN",
    Image: "16UNODC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=30"
  },
  {
    ID: 331,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Countering corruption",
    Title: "States’ use of beneficial ownership information in anti-corruption efforts strengthened",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "GT,HN,PY,PH,VN,ZM",
    Image: "16UNODC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=30"
  },
  {
    ID: 332,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Countering corruption",
    Title: "Strengthened cooperation among States at the regional level to counter corruption",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=31"
  },
  {
    ID: 333,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Countering corruption",
    Title: "Effective legal and policy frameworks of States to address corruption in line with the United Nations Convention against Corruption",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=31"
  },
  {
    ID: 334,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Terrorism prevention",
    Title: "Strengthened criminal justice responses to counter terrorist financing in Côte d’Ivoire",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "International community",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CI",
    Image: "16UNODC13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=34"
  },
  {
    ID: 335,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Terrorism prevention",
    Title: "Institutional change in Southern Africa to build strong and accountable criminal justice systems and counter terrorism",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "MZ",
    Image: "16UNODC14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=35"
  },
  {
    ID: 336,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Terrorism prevention",
    Title: "Increased contributions of women officials to the strengthening of criminal justice systems against terrorism",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Women and girls",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=35"
  },
  {
    ID: 337,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Terrorism prevention",
    Title: "States are better prepared to counter radiological and nuclear terrorism through the International Convention for the Suppression of Acts of Nuclear Terrorism",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "International community",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=36"
  },
  {
    ID: 338,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Justice",
    Title: "Improved compliance of national prison systems with international standards to promote rehabilitation",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=39"
  },
  {
    ID: 339,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Justice",
    Title: "Crime prevention and criminal justice reform efforts with full respect for human rights",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=40"
  },
  {
    ID: 340,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Justice",
    Title: "Children and youth empowered to prevent child involvement in crime and violence",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Youth",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=41"
  },
  {
    ID: 341,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Justice",
    Title: "Increased national ownership of crime prevention and criminal justice initiatives through institutional partnerships",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=41"
  },
  {
    ID: 342,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Research, trend analysis and forensics",
    Title: "Improved capacity and expertise of law enforcement officers and forensic personnel from the Americas in crime scene investigation and the examination of counterfeit and fraudulent security documents",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced control on drugs, illicit goods and trafficking in persons; reduced illicit financial flows",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AR,BO,CL,CR,DO,EC,SV,GT,GY,HN,JM,PA,PY,PE,TT,UY",
    Image: "16UNODC21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=44"
  },
  {
    ID: 343,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Research, trend analysis and forensics",
    Title: "Member States drug testing and toxicology laboratories monitor their performance as part of quality assurance practices",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced control on drugs, illicit goods and trafficking in persons; reduced illicit financial flows",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=44"
  },
  {
    ID: 344,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Research, trend analysis and forensics",
    Title: "Greater access to the evidence needed by Member States to understand and combat trafficking in persons",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "International community",
    SpecificResult: "Enhanced control on drugs, illicit goods and trafficking in persons; reduced illicit financial flows",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=45"
  },
  {
    ID: 345,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Research, trend analysis and forensics",
    Title: "Member States increasingly utilize UNODC research for policymaking",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced control on drugs, illicit goods and trafficking in persons; reduced illicit financial flows",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=46"
  },
  {
    ID: 346,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Policy support",
    Title: "Victims of trafficking receive comprehensive, victim-centred support through the United Nations voluntary trust fund for victims of trafficking in persons, especially women and children",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Women and girls",
    SpecificResult: "Enhanced control on drugs, illicit goods and trafficking in persons; reduced illicit financial flows",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=48"
  },
  {
    ID: 347,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Policy support",
    Title: "Young people engage meaningfully in decision-making processes on drugs, crime and corruption",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Youth",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened  multilateralism",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=49"
  },
  {
    ID: 348,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Policy support",
    Title: "Public-private partnership initiatives are implemented in the context of the United Nations Convention against Cybercrime",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Private sector, including micro, small and medium-sized enterprises",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DO,NG",
    Image: "16UNODC27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=50"
  },
  {
    ID: 349,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Policy support",
    Title: "Increased public awareness of the threats posed by drugs, crime, corruption and terrorism through targeted social media content",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=50"
  },
  {
    ID: 350,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Technical cooperation and field support",
    Title: "Improved accountability and justice system effectiveness in Haiti",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "HT",
    Image: "16UNODC29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=53"
  },
  {
    ID: 351,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Technical cooperation and field support",
    Title: "Navigating challenges to safety at sea through strengthened maritime safety management systems",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AO,KM,KE,MG,MU,MZ,NA,SC,TZ",
    Image: "16UNODC30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=53"
  },
  {
    ID: 352,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Technical cooperation and field support",
    Title: "Enhanced transparency and efficiency in asset management for improved crime prevention and public trust",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "MZ",
    Image: "16UNODC31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=54"
  },
  {
    ID: 353,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Technical cooperation and field support",
    Title: "Organized criminal activity prevented and addressed on the lands and territories traditionally inhabited by Indigenous Peoples",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced adherence to the rule of law; strengthened crime prevention and criminal justice; reduced corruption; preventing and countering terrorism ",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BR",
    Image: "16UNODC32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=55"
  },
  {
    ID: 354,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Provision of secretariat services and substantive support to the Commission on Narcotic Drugs, the Commission on Crime Prevention and Criminal Justice and the United Nations Congress on Crime Prevention and Criminal Justice",
    Title: "Preparations advanced for the Fifteenth United Nations Congress on Crime Prevention and Criminal Justice",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened  multilateralism",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT,CR,ET,MA,TH",
    Image: "16UNODC33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=57"
  },
  {
    ID: 355,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Provision of secretariat services and substantive support to the Commission on Narcotic Drugs, the Commission on Crime Prevention and Criminal Justice and the United Nations Congress on Crime Prevention and Criminal Justice",
    Title: "Strengthened implementation of international crime prevention and criminal justice policy commitments",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened  multilateralism",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=58"
  },
  {
    ID: 356,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Provision of secretariat services and substantive support to the Commission on Narcotic Drugs, the Commission on Crime Prevention and Criminal Justice and the United Nations Congress on Crime Prevention and Criminal Justice",
    Title: "Accelerated crime prevention, criminal justice and the rule of law through the adoption and implementation of the Abu Dhabi declaration",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened  multilateralism",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=59"
  },
  {
    ID: 357,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Provision of secretariat services and substantive support to the Commission on Narcotic Drugs, the Commission on Crime Prevention and Criminal Justice and the United Nations Congress on Crime Prevention and Criminal Justice",
    Title: "Accelerated implementation of international drug policy commitments to effectively address and counter the world drug problem",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened  multilateralism",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=59"
  },
  {
    ID: 358,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Provision of secretariat services and substantive support to the International Narcotics Control Board",
    Title: "Effective functioning of the international system of estimates and assessments for licit trade in narcotic drugs and psychotropic substances for medical and scientific purposes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced control on drugs, illicit goods and trafficking in persons; reduced illicit financial flows",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=63"
  },
  {
    ID: 359,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Provision of secretariat services and substantive support to the International Narcotics Control Board",
    Title: "Reduced trafficking in highly potent new psychoactive substances and non-medical synthetic opioids",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced control on drugs, illicit goods and trafficking in persons; reduced illicit financial flows",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=63"
  },
  {
    ID: 360,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Provision of secretariat services and substantive support to the International Narcotics Control Board",
    Title: "Strengthened capacity of Member States to ensure adequate availability of internationally controlled substances for medical and scientific purposes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced control on drugs, illicit goods and trafficking in persons; reduced illicit financial flows",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=64"
  },
  {
    ID: 361,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "United Nations Office on Drugs and Crime",
    Programme: "International drug control, crime and terrorism prevention and criminal justice",
    Subprogramme: "Provision of secretariat services and substantive support to the International Narcotics Control Board",
    Title: "Reduced availability of precursor chemicals and non-scheduled chemicals for use in the illicit manufacture of drugs",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Drug control, crime prevention and combating organized crime and international terrorism in all its forms and manifestations",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced control on drugs, illicit goods and trafficking in persons; reduced illicit financial flows",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=en#page=65"
  },
  {
    ID: 362,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "United Nations Entity for Gender Equality and the Empowerment of Women",
    Programme: "UN-Women",
    Subprogramme: "Intergovernmental support, coordination and strategic partnerships",
    Title: "Priority actions identified and advanced to accelerate the implementation of the Beijing Platform for Action",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion of human rights",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.17)&l=en#page=8"
  },
  {
    ID: 363,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "United Nations Entity for Gender Equality and the Empowerment of Women",
    Programme: "UN-Women",
    Subprogramme: "Intergovernmental support, coordination and strategic partnerships",
    Title: "Strengthened global norms and standards on gender equality and the empowerment of all women and girls",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.17)&l=en#page=9"
  },
  {
    ID: 364,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "United Nations Entity for Gender Equality and the Empowerment of Women",
    Programme: "UN-Women",
    Subprogramme: "Intergovernmental support, coordination and strategic partnerships",
    Title: "A gender perspective mainstreamed in United Nations Sustainable Development Cooperation Frameworks",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: " ",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.17)&l=en#page=9"
  },
  {
    ID: 365,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "United Nations Entity for Gender Equality and the Empowerment of Women",
    Programme: "UN-Women",
    Subprogramme: "Intergovernmental support, coordination and strategic partnerships",
    Title: "Enhanced gender mainstreaming through the United Nations System-wide Action Plan on Gender Equality and the Empowerment of Women 3.0",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.17)&l=en#page=10"
  },
  {
    ID: 366,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "United Nations Entity for Gender Equality and the Empowerment of Women",
    Programme: "UN-Women",
    Subprogramme: "Policy and programme activities",
    Title: "Member States use time-use data to inform evidence-based policies to recognize, reduce and redistribute unpaid care work",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.17)&l=en#page=13"
  },
  {
    ID: 367,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "United Nations Entity for Gender Equality and the Empowerment of Women",
    Programme: "UN-Women",
    Subprogramme: "Policy and programme activities",
    Title: "Governments implement fiscal policies and gender-responsive budgeting to promote gender equality",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: " ",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.17)&l=en#page=13"
  },
  {
    ID: 368,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "United Nations Entity for Gender Equality and the Empowerment of Women",
    Programme: "UN-Women",
    Subprogramme: "Policy and programme activities",
    Title: "Governments adopt national action plans to prevent violence against women and girls",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: " ",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.17)&l=en#page=14"
  },
  {
    ID: 369,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "United Nations Entity for Gender Equality and the Empowerment of Women",
    Programme: "UN-Women",
    Subprogramme: "Policy and programme activities",
    Title: "Governments make progress on reforming discriminatory laws",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.17)&l=en#page=15"
  },
  {
    ID: 370,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Macroeconomic policy, finance and governance",
    Title: "Strengthened debt management and sustainable financing strategies in small island developing States",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Development of Africa",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CV,KM",
    Image: "18ECA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=12"
  },
  {
    ID: 371,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Macroeconomic policy, finance and governance",
    Title: "Members of ECA apply innovative approaches to mobilize domestic resources and external private capital",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "BW,ET,GN,MR,UG,TZ",
    Image: "18ECA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=13"
  },
  {
    ID: 372,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Macroeconomic policy, finance and governance",
    Title: "Enhanced macroeconomic forecasting and development planning for inclusive and sustainable growth",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BW",
    Image: "18ECA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=14"
  },
  {
    ID: 373,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Macroeconomic policy, finance and governance",
    Title: "Improved economic and financial governance to enhance structural transformation and inclusive development",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BJ,ET,GN,UG,ZM",
    Image: "18ECA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=14"
  },
  {
    ID: 374,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Regional integration and trade",
    Title: "Enhanced readiness of Ethiopia to trade under the African Continental Free Trade Area",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Development of Africa",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "ET",
    Image: "18ECA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=17"
  },
  {
    ID: 375,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Regional integration and trade",
    Title: "Sustainable trade strategies to mitigate the impact of climate change",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=18"
  },
  {
    ID: 376,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Regional integration and trade",
    Title: "Members of ECA adopt measures to de-risk investments in regional value chains and special economic zones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=19"
  },
  {
    ID: 377,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Regional integration and trade",
    Title: "Improved national policy and institutional environment for the private sector to participate in intra-African trade through the African Continental Free Trade Area",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=19"
  },
  {
    ID: 378,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Technology, innovation, connectivity and infrastructure development",
    Title: "Member States have access to a tax policy simulation tool to support evidence-based policymaking for affordable connectivity, inclusive economic growth, and job creation in Africa",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=23"
  },
  {
    ID: 379,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Technology, innovation, connectivity and infrastructure development",
    Title: "Increased use of new technologies by members of ECA, reinforced by robust regulatory frameworks",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=23"
  },
  {
    ID: 380,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Technology, innovation, connectivity and infrastructure development",
    Title: "Members of ECA leverage technology and innovation to manage their transport and energy infrastructure",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "EG,QG,GH,KE,MG",
    Image: "18ECA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=24"
  },
  {
    ID: 381,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Technology, innovation, connectivity and infrastructure development",
    Title: "Strengthened strategies and policies for infrastructure development",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SZ,GM",
    Image: "18ECA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=25"
  },
  {
    ID: 382,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Data and statistics",
    Title: "Members of ECA produce and use improved economic statistics for regional integration policies",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=28"
  },
  {
    ID: 383,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Data and statistics",
    Title: "Progress towards integrated statistical and geospatial information frameworks",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "ER,GH,NA",
    Image: "18ECA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=29"
  },
  {
    ID: 384,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Data and statistics",
    Title: "Improved civil registration and vital statistics systems",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Improved information on population, migration, civil registrations and demographics including sex-disaggregated statistics",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BI,KE,NA,TZ",
    Image: "18ECA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=30"
  },
  {
    ID: 385,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Data and statistics",
    Title: "Strengthened national statistical systems enabling the regular production and policy use of innovative statistical products for evidence-based decision-making",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Improved information on population, migration, civil registrations and demographics including sex-disaggregated statistics",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=30"
  },
  {
    ID: 386,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Climate change, food security and natural resources",
    Title: "Members of ECA strengthen policy and institutional frameworks for climate-resilient agricultural value chains",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Development of Africa",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CI,GH,ZM,ZW",
    Image: "18ECA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=35"
  },
  {
    ID: 387,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Climate change, food security and natural resources",
    Title: "Members of ECA develop and implement national and regional policy and cooperation frameworks for the sustainable use of natural resources",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=36"
  },
  {
    ID: 388,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Climate change, food security and natural resources",
    Title: "Resilient and inclusive agrifood systems",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=37"
  },
  {
    ID: 389,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Climate change, food security and natural resources",
    Title: "Enhanced climate ambition and climate action in Africa",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=37"
  },
  {
    ID: 390,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Economic empowerment of women and youth ",
    Title: "Strengthened data collection, monitoring and reporting on gender equality and the empowerment of women",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Development of Africa",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Improved information on population, migration, civil registrations and demographics including sex-disaggregated statistics",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BI,SS,II",
    Image: "18ECA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=41"
  },
  {
    ID: 391,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Economic empowerment of women and youth ",
    Title: "Members of ECA integrate a gender perspective into fiscal policy",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "ET,KE,RW,UG,TZ",
    Image: "18ECA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=42"
  },
  {
    ID: 392,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Economic empowerment of women and youth ",
    Title: "Members of ECA take action to improve the financial inclusion of women",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "GM,SL",
    Image: "18ECA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=43"
  },
  {
    ID: 393,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Economic empowerment of women and youth ",
    Title: "Members of ECA leverage digitalization to empower young entrepreneurs",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Youth",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Entrepreneurship and increased competitiveness of micro, small and medium-sized enterprises",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "ZA",
    Image: "18ECA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=43"
  },
  {
    ID: 394,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Subregional activities for development: Subregional activities in North Africa",
    Title: "Members of ECA take action to increase sustainable finance",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,SL",
    Image: "18ECA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=46"
  },
  {
    ID: 395,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Subregional activities for development: Subregional activities in North Africa",
    Title: "Members of ECA mobilize finance for sustainable development",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,LY",
    Image: "18ECA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=46"
  },
  {
    ID: 396,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Subregional activities for development: Subregional activities in North Africa",
    Title: "Members of ECA accelerate inclusive and sustainable growth through increased productivity, diversification and value addition",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Entrepreneurship and increased competitiveness of micro, small and medium-sized enterprises",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,EG,QG,LY,MR,SD,QQ,TN",
    Image: "18ECA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=47"
  },
  {
    ID: 397,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Subregional activities for development: Subregional activities in North Africa",
    Title: "Members of ECA take actions to maximize diaspora engagement as alternative sources of finance for development",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,EG,QG,LY,MR,SD,QQ,TN",
    Image: "18ECA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=47"
  },
  {
    ID: 398,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Subregional activities for development: Subregional activities in West Africa",
    Title: "Members of ECA in West Africa integrate agricultural value chain analysis into planning frameworks",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Development of Africa",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BJ,BF,CV,CI,GM,GH,GN,GW,LR,ML,MR,NE,NG,SN,SL,TG",
    Image: "18ECA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=50"
  },
  {
    ID: 399,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Subregional activities for development: Subregional activities in West Africa",
    Title: "Members of ECA assess debt sustainability and develop longer-term fiscal strategies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SL",
    Image: "18ECA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=51"
  },
  {
    ID: 400,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Subregional activities for development: Subregional activities in West Africa",
    Title: "Increased operationalization of national African Continental Free Trade Area strategies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CV,GH,LR",
    Image: "18ECA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=52"
  },
  {
    ID: 401,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Subregional activities for development: Subregional activities in West Africa",
    Title: "Enhanced national budgeting and monitoring systems to harness the demographic dividend",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Increased cooperation, information and best practice sharing for progress towards the SDGs",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BJ,BF,CV,CI,GM,GH,GN,GW,LR,ML,MR,NE,NG,SN,SL,TG",
    Image: "18ECA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=52"
  },
  {
    ID: 402,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Subregional activities for development: Subregional activities in Central Africa",
    Title: "Sao Tome and Principe developed and validated its first tourism satellite accounts",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Increased cooperation, information and best practice sharing for progress towards the SDGs",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "ST",
    Image: "18ECA33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=55"
  },
  {
    ID: 403,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Subregional activities for development: Subregional activities in Central Africa",
    Title: "Members of ECA develop special economic zones for sustainable and inclusive economic diversification",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CM,CG,CD,GA",
    Image: "18ECA34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=56"
  },
  {
    ID: 404,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Subregional activities for development: Subregional activities in Central Africa",
    Title: "Central African members of ECA enhance natural asset valuation and capitalization",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CG,ST",
    Image: "18ECA35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=56"
  },
  {
    ID: 405,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Subregional activities for development: Subregional activities in Central Africa",
    Title: "Strengthened trade facilitation systems and institutional capacities to accelerate regional economic integration",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BI,CM,CF,TD,GQ,CD,GA,CG,RW,ST",
    Image: "18ECA36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=57"
  },
  {
    ID: 406,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Subregional activities for development: Subregional activities in East Africa",
    Title: "Somalia launches Centennial Vision 2060 and ratifies the Agreement Establishing the African Continental Free Trade Area",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SO",
    Image: "18ECA37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=60"
  },
  {
    ID: 407,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Subregional activities for development: Subregional activities in East Africa",
    Title: "Members of ECA and regional organizations develop investment promotion strategies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BI,DJ,ER,ET,KE,RW,SC,SO,SS,II,UG,TZ",
    Image: "18ECA38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=61"
  },
  {
    ID: 408,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Subregional activities for development: Subregional activities in East Africa",
    Title: "Members of ECA implement regional frameworks on tourism and the blue economy",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "BI,DJ,ER,ET,KE,RW,SC,SO,SS,II,UG,TZ",
    Image: "18ECA39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=61"
  },
  {
    ID: 409,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Subregional activities for development: Subregional activities in East Africa",
    Title: "Strengthened connectivity and infrastructure for deeper regional integration",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BI,DJ,ER,ET,KE,RW,SC,SO,SS,II,UG,TZ",
    Image: "18ECA40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=62"
  },
  {
    ID: 410,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Subregional activities for development: Subregional activities in Southern Africa",
    Title: "Accelerated intraregional trade and investment in the SADC region through digital technology",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AO,BW,KM,CD,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,TZ,ZM,ZW",
    Image: "18ECA41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=65"
  },
  {
    ID: 411,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Subregional activities for development: Subregional activities in Southern Africa",
    Title: "Accelerating the transition towards more sustainable economies in Southern Africa",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "18ECA42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=66"
  },
  {
    ID: 412,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Subregional activities for development: Subregional activities in Southern Africa",
    Title: "Inclusive industrialization through value chain development in Southern Africa",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "18ECA43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=67"
  },
  {
    ID: 413,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Subregional activities for development: Subregional activities in Southern Africa",
    Title: "Accelerated implementation of the Agreement Establishing the African Continental Free Trade Area and other trade agreements in Southern Africa",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "18ECA44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=68"
  },
  {
    ID: 414,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Economic development and planning",
    Title: "Members of ECA move from fragmented to integrated approaches to social protection through the development of national social protection strategies",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Development of Africa",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CM,SN,ZW",
    Image: "18ECA45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=71"
  },
  {
    ID: 415,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Economic development and planning",
    Title: "Members of ECA develop a future-ready workforce",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Youth",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=71"
  },
  {
    ID: 416,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Economic development and planning",
    Title: "Strengthened localized development planning and development financing",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=72"
  },
  {
    ID: 417,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Economic development and planning",
    Title: "Improved public administration training systems to enhance national development planning",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Increased cooperation, information and best practice sharing for progress towards the SDGs",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DJ",
    Image: "18ECA48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=72"
  },
  {
    ID: 418,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Poverty and socioeconomic policy",
    Title: "Members of ECA established a common position for Africa on priorities for social development",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Development of Africa",
    Beneficiary: "Youth",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "Increased cooperation, information and best practice sharing for progress towards the SDGs",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=75"
  },
  {
    ID: 419,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Poverty and socioeconomic policy",
    Title: "Improved social protection systems for the most vulnerable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "GH,NA,SN,TZ",
    Image: "18ECA50.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=76"
  },
  {
    ID: 420,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Poverty and socioeconomic policy",
    Title: "Strengthened national and regional reviews of population-related frameworks to promote sustainable development and leave no one behind",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "International community",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA51.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=76"
  },
  {
    ID: 421,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "Economic Commission for Africa ",
    Programme: "Economic and social development in Africa",
    Subprogramme: "Poverty and socioeconomic policy",
    Title: "Strengthened evidence-based employment policies to harness Africa’s demographic dividend",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Development of Africa",
    Beneficiary: "Youth",
    BeneficiaryTwo: "Member States in Africa",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA52.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=en#page=77"
  },
  {
    ID: 422,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Macroeconomic policy, poverty reduction and financing for development",
    Title: "Asia-Pacific countries’ priorities reflected in the global financing for development agenda",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Member States in Asia and the Pacific ",
    BeneficiaryTwo: "Public administration",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=16"
  },
  {
    ID: 423,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Macroeconomic policy, poverty reduction and financing for development",
    Title: "Improved policymaking for macroeconomic and financing for development issues",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "SD,QQ,BT,KH,MV,MN,PK,LK",
    Image: "19ESCAP2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=17"
  },
  {
    ID: 424,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Macroeconomic policy, poverty reduction and financing for development",
    Title: "Member States introduce new policy initiatives and reforms to accelerate financing for sustainable development",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SD,QQ,BT,KH,LK",
    Image: "19ESCAP3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=17"
  },
  {
    ID: 425,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Macroeconomic policy, poverty reduction and financing for development",
    Title: "Member States design, assess or deploy macroeconomic policies to accelerate progress for climate-resilient development",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Member States in Asia and the Pacific ",
    BeneficiaryTwo: "Climate and environment",
    SpecificResult: "Inclusive and sustainable recovery from disasters; building resilience for future disasters",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=18"
  },
  {
    ID: 426,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Trade, investment and innovation",
    Title: "Countries strengthen trade agreement negotiations through tailored analytics",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Member States in Asia and the Pacific ",
    BeneficiaryTwo: "Public administration",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=21"
  },
  {
    ID: 427,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Trade, investment and innovation",
    Title: "More sustainable and efficient trade processes through increased digital and sustainable trade facilitation measures",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=22"
  },
  {
    ID: 428,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Trade, investment and innovation",
    Title: "Investment promotion agencies pledge commitment to advance gender equality through foreign direct investment",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=22"
  },
  {
    ID: 429,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Trade, investment and innovation",
    Title: "Improved access to opportunities for technology transfer and knowledge on emerging and innovative technologies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Member States in Asia and the Pacific ",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=23"
  },
  {
    ID: 430,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Transport",
    Title: "Member States increasingly integrate inclusive transport principles into their planning and policymaking processes for more accessible and socially inclusive transport systems in Asia-Pacific cities",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Member States in Asia and the Pacific ",
    BeneficiaryTwo: " ",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AZ,LA,MN,NP,FJ,KI,PG,SB,TL",
    Image: "19ESCAP9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=26"
  },
  {
    ID: 431,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Transport",
    Title: "Increased efficiency and resilience of transport connectivity and logistics networks in Asia and the Pacific",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Entrepreneurship and increased competitiveness of micro, small and medium-sized enterprises",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=27"
  },
  {
    ID: 432,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Transport",
    Title: "Accelerated transition to low-emission transport",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=27"
  },
  {
    ID: 433,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Transport",
    Title: "Strengthened regional cooperation for sustainable, resilient and inclusive transport development",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Member States in Asia and the Pacific ",
    BeneficiaryTwo: " ",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=28"
  },
  {
    ID: 434,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Environment and development and disaster risk reduction and management",
    Title: "Accelerated implementation of climate action",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BT,PG",
    Image: "19ESCAP13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=31"
  },
  {
    ID: 435,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Environment and development and disaster risk reduction and management",
    Title: "Member States in Asia and the Pacific increase cooperation to advance participatory approaches on environmental matters",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=32"
  },
  {
    ID: 436,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Environment and development and disaster risk reduction and management",
    Title: "Increased regional cooperation on ocean-based climate actions, including through ecosystem-based approaches and nature-based solutions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=32"
  },
  {
    ID: 437,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Environment and development and disaster risk reduction and management",
    Title: "Regional cooperation, partnerships and initiatives on sustainable urban development are expanded and enhanced",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Improved cooperation and partnerships and increased coherence, synergies and reduced overlap through consistent communication",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=33"
  },
  {
    ID: 438,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Information and communications technology and space applications",
    Title: "Strengthened implementation of Early Warnings for All",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Inclusive and sustainable recovery from disasters; building resilience for future disasters",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=36"
  },
  {
    ID: 439,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Information and communications technology and space applications",
    Title: "Increased adoption of digitally driven innovations to enable transformative adaptation to climate change",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Technological advancements that lead to improved quality, availability, accessibility and security of information",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "MN,LA",
    Image: "19ESCAP18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=37"
  },
  {
    ID: 440,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Information and communications technology and space applications",
    Title: "Scaled up geospatial applications by countries in special situations for achieving the 2030 Agenda",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=37"
  },
  {
    ID: 441,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Information and communications technology and space applications",
    Title: "Strengthened regional cooperation on leveraging the application of emerging technologies, especially artificial intelligence",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Member States in Asia and the Pacific ",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=38"
  },
  {
    ID: 442,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Social development",
    Title: "Strengthened regional dialogue and engagement on and joint review of safe, orderly and regular migration in Asia and the Pacific",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Member States in Asia and the Pacific ",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Improved information on population, migration, civil registrations and demographics including sex-disaggregated statistics",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=42"
  },
  {
    ID: 443,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Social development",
    Title: "Member States develop policy measures on valuing and investing in the care economy",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Improved information on population, migration, civil registrations and demographics including sex-disaggregated statistics",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "LA,TL",
    Image: "19ESCAP22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=42"
  },
  {
    ID: 444,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Social development",
    Title: "Strengthened national capacity to develop inclusive population ageing policies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Improved information on population, migration, civil registrations and demographics including sex-disaggregated statistics",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=43"
  },
  {
    ID: 445,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Social development",
    Title: "Member States identify country pathways for social protection policies that embed climate resilience",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Member States in Asia and the Pacific ",
    BeneficiaryTwo: "Climate and environment",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=44"
  },
  {
    ID: 446,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Statistics",
    Title: "Leveraging data to drive progress in civil registration",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Improved information on population, migration, civil registrations and demographics including sex-disaggregated statistics",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=47"
  },
  {
    ID: 447,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Statistics",
    Title: "Improved data governance by national statistical offices across Asia and the Pacific",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Improved information on population, migration, civil registrations and demographics including sex-disaggregated statistics",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=47"
  },
  {
    ID: 448,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Statistics",
    Title: "Establishment of national Sustainable Development Goal platforms to monitor progress towards the 2030 Agenda for Sustainable Development in Asia and the Pacific",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Increased capacity to report progress towards SDGs; Increased number / quality of voluntary national reviews.",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=48"
  },
  {
    ID: 449,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Statistics",
    Title: "Strengthened national statistical systems through a whole-of-society approach",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Member States in Asia and the Pacific ",
    BeneficiaryTwo: "Public administration",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=48"
  },
  {
    ID: 450,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Subregional activities for development: Subregional activities for development in the Pacific",
    Title: "Strengthened capacity for integration of economic valuation of ecosystem goods and services into policy and planning by Pacific Governments",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: "Climate and environment",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=51"
  },
  {
    ID: 451,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Subregional activities for development: Subregional activities for development in the Pacific",
    Title: "Pathways to mainstream the Antigua and Barbuda Agenda for Small Island Developing States into national development strategies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=52"
  },
  {
    ID: 452,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Subregional activities for development: Subregional activities for development in the Pacific",
    Title: "Increased effectiveness in the production and use of core indicators for national, regional and global reporting",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Increased capacity to report progress towards SDGs; Increased number / quality of voluntary national reviews.",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=53"
  },
  {
    ID: 453,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Subregional activities for development: Subregional activities for development in the Pacific",
    Title: "Amplify the Pacific’s voice to advance a more tailored United Nations multidimensional vulnerability index",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Increased cooperation, information and best practice sharing for progress towards the SDGs",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=53"
  },
  {
    ID: 454,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Subregional activities for development: Subregional activities for development in East and North-East Asia",
    Title: "Enhanced knowledge-sharing to advance local climate action",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Increased capacity to report progress towards SDGs; Increased number / quality of voluntary national reviews.",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=56"
  },
  {
    ID: 455,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Subregional activities for development: Subregional activities for development in East and North-East Asia",
    Title: "Efficient management of cross-border railway transport and transit",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Entrepreneurship and increased competitiveness of micro, small and medium-sized enterprises",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "MN,KR,RU,KU",
    Image: "19ESCAP34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=56"
  },
  {
    ID: 456,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Subregional activities for development: Subregional activities for development in East and North-East Asia",
    Title: "Strengthened cross-border collaboration on addressing desertification and land degradation in East and North-East Asia",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CN,HK,TW,KX,MO,KP,JP,MN,KR,RU,KU",
    Image: "19ESCAP35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=57"
  },
  {
    ID: 457,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Subregional activities for development: Subregional activities for development in East and North-East Asia",
    Title: "Strengthened collaboration on marine protected areas in North-East Asia",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CN,HK,TW,KX,MO,KP,JP,MN,KR,RU,KU",
    Image: "19ESCAP36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=58"
  },
  {
    ID: 458,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Subregional activities for development: Subregional activities for development in North and Central Asia",
    Title: "Member States in North and Central Asia develop recommendations to strengthen trade",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Member States in Asia and the Pacific ",
    BeneficiaryTwo: "Public administration",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=60"
  },
  {
    ID: 459,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Subregional activities for development: Subregional activities for development in North and Central Asia",
    Title: "Strengthened cooperation instruments of the United Nations Special Programme for the Economies of Central Asia",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Entrepreneurship and increased competitiveness of micro, small and medium-sized enterprises",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=61"
  },
  {
    ID: 460,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Subregional activities for development: Subregional activities for development in North and Central Asia",
    Title: "Member States advance digital transformation policies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=62"
  },
  {
    ID: 461,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Subregional activities for development: Subregional activities for development in North and Central Asia",
    Title: "Strengthened subregional cooperation on power grid modernization and renewable energy integration in North and Central Asia",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=62"
  },
  {
    ID: 462,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Subregional activities for development: Subregional activities for development in South and South-West Asia",
    Title: "Strengthened multi-stakeholder cooperation on water and climate change nexus in South Asia",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=65"
  },
  {
    ID: 463,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Subregional activities for development: Subregional activities for development in South and South-West Asia",
    Title: "Accelerated transition to sustainable energy",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=65"
  },
  {
    ID: 464,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Subregional activities for development: Subregional activities for development in South and South-West Asia",
    Title: "Bridging the digital gap to leave no one behind in South and South-West Asia",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=66"
  },
  {
    ID: 465,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Subregional activities for development: Subregional activities for development in South and South-West Asia",
    Title: "Strengthening cross-border trade connectivity in South and South-West Asia, with a focus on women entrepreneurs and start-ups at the borders",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Member States in Asia and the Pacific ",
    BeneficiaryTwo: "Women and girls",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=66"
  },
  {
    ID: 466,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Subregional activities for development: Subregional activities for development in South-East Asia",
    Title: "Integrated multi-stakeholder engagement for sustainable development in South-East Asia",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Member States in Asia and the Pacific ",
    BeneficiaryTwo: " ",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BN,KH,ID,LA,MY,MM,PH,SG,TH,TL,VN",
    Image: "19ESCAP45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=69"
  },
  {
    ID: 467,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Subregional activities for development: Subregional activities for development in South-East Asia",
    Title: "Aligned investment policies and regulations for the achievement of the Sustainable Development Goals",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "BN,KH,ID,LA,MY,MM,PH,SG,TH,TL,VN",
    Image: "19ESCAP46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=69"
  },
  {
    ID: 468,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Subregional activities for development: Subregional activities for development in South-East Asia",
    Title: "Youth engagement towards achieving the Sustainable Development Goals",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Youth",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BN,KH,ID,LA,MY,MM,PH,SG,TH,TL,VN",
    Image: "19ESCAP47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=70"
  },
  {
    ID: 469,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Subregional activities for development: Subregional activities for development in South-East Asia",
    Title: "Enhanced regional dialogue and cooperation on digital transformation for sustainable development",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Member States in Asia and the Pacific ",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "19ESCAP48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=70"
  },
  {
    ID: 470,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Energy",
    Title: "Enhanced policies related to sustainable energy transition",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KH,FJ,FM,TO,VN",
    Image: "19ESCAP49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=73"
  },
  {
    ID: 471,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Energy",
    Title: "Countries adopt national cooling action plans",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "VN",
    Image: "19ESCAP50.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=74"
  },
  {
    ID: 472,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Energy",
    Title: "Increased cooperation of member States in the Asia-Pacific region on cross-border power connectivity projects",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP51.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=75"
  },
  {
    ID: 473,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "Economic and Social Commission for Asia and the Pacific",
    Programme: "Economic and social development in Asia and the Pacific",
    Subprogramme: "Energy",
    Title: "New intergovernmentally agreed milestones to advance regional power system connectivity",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Asia and the Pacific ",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP52.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=en#page=75"
  },
  {
    ID: 474,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Environment",
    Title: "Member States apply foresight approaches to develop recommendations for environmental policies to address gaps and emerging issues",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=15"
  },
  {
    ID: 475,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Environment",
    Title: "Modernized database on pollutants to enable responsive fact-based decisions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=15"
  },
  {
    ID: 476,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Environment",
    Title: "Strengthened pan-European environmental knowledge base for informed policymaking",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=16"
  },
  {
    ID: 477,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Environment",
    Title: "Improved reporting of air emissions data",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=16"
  },
  {
    ID: 478,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Transport",
    Title: "Open-source software enables implementation of annex 11 of the Convention on International Transport of Goods under Cover of TIR Carnets",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=20"
  },
  {
    ID: 479,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Transport",
    Title: "Increased accessions to core road safety conventions as an initial step to contribute to fewer worldwide road accident fatalities and injuries",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=20"
  },
  {
    ID: 480,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Transport",
    Title: "Enhanced regulatory framework for sustainable inland transport systems",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=21"
  },
  {
    ID: 481,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Transport",
    Title: "Accelerated digitalization of legal instruments in inland transport",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=22"
  },
  {
    ID: 482,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Statistics",
    Title: "Member States adopt enhanced global statistical standards",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=26"
  },
  {
    ID: 483,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Statistics",
    Title: "Economic Commission for Europe statistical database for improved research and decision-making",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=26"
  },
  {
    ID: 484,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Statistics",
    Title: "Improved reporting for monitoring the Sustainable Development Goals",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Increased capacity to report progress towards SDGs; Increased number / quality of voluntary national reviews.",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=27"
  },
  {
    ID: 485,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Statistics",
    Title: "Enhanced availability and accessibility of climate change-related statistics",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=27"
  },
  {
    ID: 486,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Economic cooperation and integration",
    Title: "ECE Transformative Innovation Charter adopted by member States",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=30"
  },
  {
    ID: 487,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Economic cooperation and integration",
    Title: "More public-private partnership infrastructure projects assessed as compliant with the Sustainable Development Goals",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=30"
  },
  {
    ID: 488,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Economic cooperation and integration",
    Title: "Improved innovation policies and initiatives for sustainable development",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=31"
  },
  {
    ID: 489,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Economic cooperation and integration",
    Title: "Public-private partnerships aligned with ECE standards and guidelines on public-private partnerships in support of the Sustainable Development Goals",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=31"
  },
  {
    ID: 490,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Sustainable energy",
    Title: "Strengthened cross-border cooperation on energy connectivity",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=34"
  },
  {
    ID: 491,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Sustainable energy",
    Title: "More sustainable and resilient natural resource management based on the United Nations Framework Classification for Resources",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=35"
  },
  {
    ID: 492,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Sustainable energy",
    Title: "Increased adoption of electric mobility for a sustainable energy transition",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=36"
  },
  {
    ID: 493,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Sustainable energy",
    Title: "Reducing greenhouse gas emissions in high-emission intensity industries",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Inclusive and sustainable recovery from disasters; building resilience for future disasters",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=37"
  },
  {
    ID: 494,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Trade",
    Title: "Adopted gender action plans promote inclusive quality infrastructure for trade",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=39"
  },
  {
    ID: 495,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Trade",
    Title: "Enhanced digitalization of trade",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=40"
  },
  {
    ID: 496,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Trade",
    Title: "Improved transparency and traceability of value chains in critical sectors",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=41"
  },
  {
    ID: 497,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Trade",
    Title: "Agricultural quality standards revised with the aim of reducing food loss and waste",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=41"
  },
  {
    ID: 498,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Forests and the forest industry",
    Title: "Enhanced integration of sustainable urban forestry solutions into national planning",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=44"
  },
  {
    ID: 499,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Forests and the forest industry",
    Title: "Evidence-based planning and action for the sustainable production and consumption of forest products",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=45"
  },
  {
    ID: 500,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Forests and the forest industry",
    Title: "Increased access to data on forests and the forest industry",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=45"
  },
  {
    ID: 501,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Forests and the forest industry",
    Title: "Foresight-based planning for a resilient and sustainable forest industry",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=46"
  },
  {
    ID: 502,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Housing, land management and population",
    Title: "Member States commit themselves to advancing housing affordability and sustainability",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=49"
  },
  {
    ID: 503,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Housing, land management and population",
    Title: "More age-sensitive and inclusive policies to respond to the opportunities and challenges of individual and population ageing",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=49"
  },
  {
    ID: 504,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Housing, land management and population",
    Title: "Acceleration of Sustainable Development Goal localization by local and regional governments",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=50"
  },
  {
    ID: 505,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "Economic Commission for Europe",
    Programme: "Economic development in Europe",
    Subprogramme: "Housing, land management and population",
    Title: "Anticipatory regional policy framework on ageing",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=en#page=50"
  },
  {
    ID: 506,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "International trade, integration and infrastructure",
    Title: "A regional input-output table to inform evidence-based policymaking in Latin America and the Caribbean",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=16"
  },
  {
    ID: 507,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "International trade, integration and infrastructure",
    Title: "Improved coordination of policies on sustainable and resilient food trade, transport systems and logistics for better regional food security",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=17"
  },
  {
    ID: 508,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "International trade, integration and infrastructure",
    Title: "Policies enhancing comprehensive and accessible physical integration, infrastructure, transport and logistics",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=18"
  },
  {
    ID: 509,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "International trade, integration and infrastructure",
    Title: "Member States diversify their export basket through increased foreign sales of digitally delivered services",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=18"
  },
  {
    ID: 510,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Production and innovation",
    Title: "Strengthened integration of a gender perspective into territorial productive development policies",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "UY",
    Image: "21ECLAC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=21"
  },
  {
    ID: 511,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Production and innovation",
    Title: "Increased and enhanced cluster initiatives and other territorial productive articulation initiatives",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=22"
  },
  {
    ID: 512,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Production and innovation",
    Title: "Enhanced productive development policies to drive productivity growth across key sectors",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=23"
  },
  {
    ID: 513,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Production and innovation",
    Title: "Productive development policies that foster productive sophistication, diversification and structural change for equality",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=23"
  },
  {
    ID: 514,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Macroeconomic policies and growth",
    Title: "Costa Rica advances the development of social impact bonds to strengthen domestic resource mobilization",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CR",
    Image: "21ECLAC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=26"
  },
  {
    ID: 515,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Macroeconomic policies and growth",
    Title: "Macroeconomic and financing for development policies for economic growth, investment, fiscal sustainability and climate resilience",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=26"
  },
  {
    ID: 516,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Macroeconomic policies and growth",
    Title: "Strengthened tax expenditure policymaking to support the Sustainable Development Goals",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=27"
  },
  {
    ID: 517,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Macroeconomic policies and growth",
    Title: "Expanded domestic public resource mobilization in line with the objectives of the Sevilla Commitment",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=28"
  },
  {
    ID: 518,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Social development and equality",
    Title: "Paraguay establishes the social registry of households, helping to strengthen its social protection system",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PY",
    Image: "21ECLAC13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=30"
  },
  {
    ID: 519,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Social development and equality",
    Title: "Expanding social protection systems to include informal and independent workers",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=31"
  },
  {
    ID: 520,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Social development and equality",
    Title: "Better policies for labour inclusion, including the impacts of climate change",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=31"
  },
  {
    ID: 521,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Social development and equality",
    Title: "Design of intersectoral policy instruments for digital inclusion and transformation aimed at reducing inequality",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=32"
  },
  {
    ID: 522,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Gender equality and women's autonomy",
    Title: "A decade of action to achieve substantive gender equality and the care society",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=34"
  },
  {
    ID: 523,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Gender equality and women's autonomy",
    Title: "Advances in the production of gender statistics on time use and unpaid care work",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Increased capacity to report progress towards SDGs; Increased number / quality of voluntary national reviews.",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=35"
  },
  {
    ID: 524,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Gender equality and women's autonomy",
    Title: "Gender mainstreaming in foreign policies and international cooperation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Improved information on population, migration, civil registrations and demographics including sex-disaggregated statistics",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=35"
  },
  {
    ID: 525,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Gender equality and women's autonomy",
    Title: "Countries calculate the impact of investing in care policies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=36"
  },
  {
    ID: 526,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Population and development",
    Title: "Plurinational State of Bolivia publishes the results of its population and housing census",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Improved information on population, migration, civil registrations and demographics including sex-disaggregated statistics",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BO",
    Image: "21ECLAC21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=39"
  },
  {
    ID: 527,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Population and development",
    Title: "Strengthened demographic analysis for public policy",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Improved information on population, migration, civil registrations and demographics including sex-disaggregated statistics",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=39"
  },
  {
    ID: 528,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Population and development",
    Title: "Madrid International Plan of Action on Ageing implemented at the country level",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=40"
  },
  {
    ID: 529,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Population and development",
    Title: "Countries produce their own updated population and labour force estimates and projections",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Increased capacity to report progress towards SDGs; Increased number / quality of voluntary national reviews.",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=41"
  },
  {
    ID: 530,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Sustainable development and human settlements",
    Title: "Strengthened environmental impact assessment systems in Latin America",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=43"
  },
  {
    ID: 531,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Sustainable development and human settlements",
    Title: "Development of strategies on sustainable consumption and production patterns, including circular economy, for better environmental performance",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=44"
  },
  {
    ID: 532,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Sustainable development and human settlements",
    Title: "Improved simulations of the possible impacts of climate change to inform policy formulation and investment options",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Technological advancements that lead to improved quality, availability, accessibility and security of information",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=45"
  },
  {
    ID: 533,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Sustainable development and human settlements",
    Title: "Development of national priorities based on a common framework for implementation of the Escazú Agreement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=45"
  },
  {
    ID: 534,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Natural resources",
    Title: "Strengthened political dialogue and regional governance in the mining sector",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=47"
  },
  {
    ID: 535,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Natural resources",
    Title: "Countries in the region supply critical minerals for the energy transition with increased economic, social and environmental sustainability",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=48"
  },
  {
    ID: 536,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Natural resources",
    Title: "New initiatives to promote the energy transition in Latin America and the Caribbean",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=49"
  },
  {
    ID: 537,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Natural resources",
    Title: "Strengthened ocean governance and policies to strengthen the sustainable use and management of the ocean in the region",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=49"
  },
  {
    ID: 538,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Planning and public management for development",
    Title: "Adoption of the Regional Agenda on Governance of Planning and Public Management for Sustainable Development in Latin America and the Caribbean to guide long-term strategic planning",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=52"
  },
  {
    ID: 539,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Planning and public management for development",
    Title: "Integrated development policies to build more resilient territories to accelerate the implementation of the 2030 Agenda",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=52"
  },
  {
    ID: 540,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Planning and public management for development",
    Title: "Improved technical, operational, political and prospective capacities in public institutions to manage transformations and address complex challenges in changing environments",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Increased cooperation, information and best practice sharing for progress towards the SDGs",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=53"
  },
  {
    ID: 541,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Planning and public management for development",
    Title: "Member States develop long-term national and subnational development plans that integrate the four strategic areas of the Regional Agenda on Governance of Planning and Public Management for Sustainable Development in Latin America and the Caribbean",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=54"
  },
  {
    ID: 542,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Statistics",
    Title: "Improved accuracy of data to inform policies on poverty, inequality, employment, education and living conditions",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=56"
  },
  {
    ID: 543,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Statistics",
    Title: "Increased implementation of the United Nations Integrated Geospatial Information Framework at the national level",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=57"
  },
  {
    ID: 544,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Statistics",
    Title: "Enhanced use of administrative registers for statistical production",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Improved information on population, migration, civil registrations and demographics including sex-disaggregated statistics",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=58"
  },
  {
    ID: 545,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Statistics",
    Title: "Modernized national statistical systems for measuring economic activity in Latin American and Caribbean countries",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=58"
  },
  {
    ID: 546,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Subregional activities in Central America, Cuba, the Dominican Republic, Haiti and Mexico",
    Title: "Countries strengthen value chain–based productive development",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=61"
  },
  {
    ID: 547,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Subregional activities in Central America, Cuba, the Dominican Republic, Haiti and Mexico",
    Title: "Accelerated implementation of the Sustainable Development Goals by addressing structural gaps",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=61"
  },
  {
    ID: 548,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Subregional activities in Central America, Cuba, the Dominican Republic, Haiti and Mexico",
    Title: "Improved anticipatory governance to inform policymaking in the subregion",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Increased cooperation, information and best practice sharing for progress towards the SDGs",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=62"
  },
  {
    ID: 549,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Subregional activities in Central America, Cuba, the Dominican Republic, Haiti and Mexico",
    Title: "Improved public strategies for fostering productive development in specific subnational areas and sectors",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=62"
  },
  {
    ID: 550,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Subregional activities in the Caribbean",
    Title: "Development of an integrative natural resources management approach for sargassum management in the Caribbean",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=65"
  },
  {
    ID: 551,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Subregional activities in the Caribbean",
    Title: "Digital inclusion in the Caribbean",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=65"
  },
  {
    ID: 552,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Subregional activities in the Caribbean",
    Title: "Integration of the Antigua and Barbuda Agenda for Small Island Developing States into national development processes and agendas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=66"
  },
  {
    ID: 553,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Subregional activities in the Caribbean",
    Title: "Economic diversification through increased South-South cooperation with Latin American economies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Improved cooperation and partnerships and increased coherence, synergies and reduced overlap through consistent communication",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=67"
  },
  {
    ID: 554,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Support for regional and subregional integration and cooperation processes and organizations",
    Title: "Regional consensus on measuring sustainable development that goes beyond gross domestic product",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Improved cooperation and partnerships and increased coherence, synergies and reduced overlap through consistent communication",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=69"
  },
  {
    ID: 555,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Support for regional and subregional integration and cooperation processes and organizations",
    Title: "Strengthened multi-stakeholder initiatives in South-South and triangular cooperation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Increased cooperation, information and best practice sharing for progress towards the SDGs",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC50.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=70"
  },
  {
    ID: 556,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Support for regional and subregional integration and cooperation processes and organizations",
    Title: "Latin American and Caribbean countries engage with extraregional actors on South-South and triangular cooperation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Increased cooperation, information and best practice sharing for progress towards the SDGs",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC51.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=71"
  },
  {
    ID: 557,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "Economic Commission for Latin America and the Caribbean",
    Programme: "Economic and social development in Latin America and the Caribbean",
    Subprogramme: "Support for regional and subregional integration and cooperation processes and organizations",
    Title: "Enhanced South-South and triangular cooperation and regional integration in line with the Sevilla Commitment",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: "Member States in Latin America and the Caribbean",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC52.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=en#page=71"
  },
  {
    ID: 558,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "Climate change and natural resource sustainability",
    Title: "Arab least developed countries make the transition to affordable, reliable, sustainable and modern energy supported by the deployment of risk-mitigating financial and business model tools",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=12"
  },
  {
    ID: 559,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "Climate change and natural resource sustainability",
    Title: "Transitioning to sustainable food systems",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Strengthened regulatory frameworks and environmental governance; increased climate action for sustainable development",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "22ESCWA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=12"
  },
  {
    ID: 560,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "Climate change and natural resource sustainability",
    Title: "Member States identify joint priority action to combat sand and dust storms",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Inclusive and sustainable recovery from disasters; building resilience for future disasters",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=13"
  },
  {
    ID: 561,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "Climate change and natural resource sustainability",
    Title: "Improved resilience of surface water and groundwater basins in the Arab region",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Climate and environment",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=13"
  },
  {
    ID: 562,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "Gender justice, population and inclusive development",
    Title: "Young people in the Arab region are connected with employment opportunities",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Youth",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=16"
  },
  {
    ID: 563,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "Gender justice, population and inclusive development",
    Title: "Member States adopt multidimensional approach to poverty reduction",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Increased capacity to report progress towards SDGs; Increased number / quality of voluntary national reviews.",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=17"
  },
  {
    ID: 564,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "Gender justice, population and inclusive development",
    Title: "Member States leverage machine learning to forecast budget needs for social assistance programming",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=17"
  },
  {
    ID: 565,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "Gender justice, population and inclusive development",
    Title: "Member States identify and initiate priority action for the economic empowerment of persons with disabilities",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "More Inclusive development to leave no one behind; poverty eradication and reduced inequalities; reduced discrimination against women and girls and strengthened gender equality.",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=18"
  },
  {
    ID: 566,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "Shared economic prosperity",
    Title: "Jordan and Tunisia developed macro-fiscal policies for enhanced social sector financing and fiscal sustainability",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=21"
  },
  {
    ID: 567,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "Shared economic prosperity",
    Title: "Enhanced debt sustainability for increased investment in sustainable development priorities",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Improved information on population, migration, civil registrations and demographics including sex-disaggregated statistics",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=21"
  },
  {
    ID: 568,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "Shared economic prosperity",
    Title: "Member States reach bilateral trade agreements beyond the region",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Private sector, including micro, small and medium-sized enterprises",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=22"
  },
  {
    ID: 569,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "Shared economic prosperity",
    Title: "Arab countries conduct macroeconomic impact assessments for economic diversification",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=22"
  },
  {
    ID: 570,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "Statistics, the information society and technology",
    Title: "Strengthened national accounts in the Arab region for evidence-based policymaking",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=25"
  },
  {
    ID: 571,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "Statistics, the information society and technology",
    Title: "Geostatistical evidence enhances decision-making and development planning in the Arab region",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=26"
  },
  {
    ID: 572,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "Statistics, the information society and technology",
    Title: "Arab member States, including least developed countries, produce external trade statistics",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Improved measurement and statistics for evidence-based policies for sustainable development",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=27"
  },
  {
    ID: 573,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "Statistics, the information society and technology",
    Title: "Policymakers use the integrated regional data platform for evidence-based policymaking",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Technological advancements that lead to improved quality, availability, accessibility and security of information",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=27"
  },
  {
    ID: 574,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "2030 Agenda and SDG coordination",
    Title: "Member States agree on a shared position to negotiate the political declaration of the Second World Summit for Social Development",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Increased cooperation, information and best practice sharing for progress towards the SDGs",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=30"
  },
  {
    ID: 575,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "2030 Agenda and SDG coordination",
    Title: "Increased private sector investment in regional and national sustainable development priorities",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Enhanced understanding of financing needs, improved policy options to finance sustainable capital investments, and increased commitment and engagement to fund sustainable projects",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=31"
  },
  {
    ID: 576,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "2030 Agenda and SDG coordination",
    Title: "Member States identify and address policy gaps linked to the implementation of the 2030 Agenda",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Increased cooperation, information and best practice sharing for progress towards the SDGs",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=32"
  },
  {
    ID: 577,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "2030 Agenda and SDG coordination",
    Title: "A regional outlook in place for identifying medium- to long-term regional development pathways",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=32"
  },
  {
    ID: 578,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "Governance and conflict prevention",
    Title: "Oman employs evidence-based local development planning",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "OM",
    Image: "22ESCWA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=35"
  },
  {
    ID: 579,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "Governance and conflict prevention",
    Title: "Modernization of public administration systems for effective and transparent public governance and socioeconomic development",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Strengthened institutions, rule of law and prevention of conflicts",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=35"
  },
  {
    ID: 580,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "Governance and conflict prevention",
    Title: "Member States develop and deploy development policies resilient to fragility and sudden shocks",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=36"
  },
  {
    ID: 581,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "Economic and Social Commission for Western Asia",
    Programme: "Economic and social development in Western Asia",
    Subprogramme: "Governance and conflict prevention",
    Title: "Strengthened competition governance for transparent and inclusive markets",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Public administration",
    BeneficiaryTwo: "Member States in Europe, Central Asia and Western Asia",
    SpecificResult: "Enhanced capacities and reduced barriers, including though e-commerce and digital economy, for improved trade and competitiveness",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=en#page=37"
  },
  {
    ID: 582,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Human rights mainstreaming, right to development, and research: Human rights mainstreaming",
    Title: "Integration of human rights norms and standards into common country analyses and United Nations Sustainable Development Cooperation Frameworks",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion of human rights",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=17"
  },
  {
    ID: 583,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Human rights mainstreaming, right to development, and research: Human rights mainstreaming",
    Title: "International human rights standards on economic, social and cultural rights are integrated into the development of State budgets",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=18"
  },
  {
    ID: 584,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Human rights mainstreaming, right to development, and research: Human rights mainstreaming",
    Title: "Increased promotion and protection of human rights in national policies and practices through the economic, social and cultural rights knowledge hub",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=19"
  },
  {
    ID: 585,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Human rights mainstreaming, right to development, and research: Human rights mainstreaming",
    Title: "Member States adopt counter-terrorism laws and implement measures that are consistent with and are applied in a manner that fully respects the rights enshrined in the Universal Declaration of Human Rights and their obligations under international human rights law",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=20"
  },
  {
    ID: 586,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Human rights mainstreaming, right to development, and research: Right to development",
    Title: "Member States and other stakeholders equipped to operationalize the right to development in the achievement of the Sustainable Development Goals",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion of human rights",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=22"
  },
  {
    ID: 587,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Human rights mainstreaming, right to development, and research: Right to development",
    Title: "Anti-corruption policies and practices to address the negative impact of corruption on the enjoyment of human rights",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=23"
  },
  {
    ID: 588,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Human rights mainstreaming, right to development, and research: Right to development",
    Title: "Strengthened promotion and protection of the right to development",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=23"
  },
  {
    ID: 589,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Human rights mainstreaming, right to development, and research: Right to development",
    Title: "Advancement of the promotion of the right to development at the regional and national levels",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "LDCs, LLDCs, SIDS and other developing countries",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=24"
  },
  {
    ID: 590,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Human rights mainstreaming, right to development, and research: Research and analysis ",
    Title: "Member States promote laws, policies and practices related to drugs that comply with international human rights law",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion of human rights",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BR,CO,PK",
    Image: "24UHCHR9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=27"
  },
  {
    ID: 591,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Human rights mainstreaming, right to development, and research: Research and analysis ",
    Title: "Young human rights defenders from Indigenous, minority and people of African descent communities deepen their understanding of human rights",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Youth",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=27"
  },
  {
    ID: 592,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Human rights mainstreaming, right to development, and research: Research and analysis ",
    Title: "Improved understanding by Member States and other stakeholders of the human rights implications of digital technologies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=28"
  },
  {
    ID: 593,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Human rights mainstreaming, right to development, and research: Research and analysis ",
    Title: "Member States adopt and implement evidence-based anti-racism policies and action that strengthen equality, non-discrimination, tolerance and the enjoyment of all human rights",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=29"
  },
  {
    ID: 594,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Supporting human rights treaty bodies",
    Title: "Increased adoption by the treaty bodies of lists of issues and lists of issues prior to reporting",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion of human rights",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=31"
  },
  {
    ID: 595,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Supporting human rights treaty bodies",
    Title: "Increased international cooperation to support national mechanisms for implementation, reporting and follow-up",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=32"
  },
  {
    ID: 596,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Supporting human rights treaty bodies",
    Title: "Improved access by State Parties and stakeholders to the recommendations of treaty bodies to facilitate their implementation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=32"
  },
  {
    ID: 597,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Supporting human rights treaty bodies",
    Title: "One-stop shop for gaining access to information on the work of treaty bodies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=33"
  },
  {
    ID: 598,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Advisory services, technical cooperation and field activities",
    Title: "Human Rights Council-mandated investigations contribute to accountability processes by providing comprehensive, independent and evidence-based analyses of human rights violations and abuses of international humanitarian law and international human rights law",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion of human rights",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=37"
  },
  {
    ID: 599,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Advisory services, technical cooperation and field activities",
    Title: "Strengthened effectiveness of national human rights institutions in line with the Paris Principles",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=38"
  },
  {
    ID: 600,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Advisory services, technical cooperation and field activities",
    Title: "Increased technical cooperation to support Member States in the Caribbean Community in their efforts to promote, protect and fulfil human rights",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "Member States in Latin America and the Caribbean",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,BS,BD,BZ,DM,GD,GY,HT,JM,MS,LC,KN,VC,SR,TT,AI,BM,VG,KY,TC",
    Image: "24UHCHR19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=39"
  },
  {
    ID: 601,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Advisory services, technical cooperation and field activities",
    Title: "Member States and other stakeholders take action to address human rights situations at the country and regional levels",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=39"
  },
  {
    ID: 602,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Supporting the Human Rights Council, its subsidiary bodies",
    Title: "Enhanced impact of special procedures at the global, regional and national levels",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion of human rights",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=43"
  },
  {
    ID: 603,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Supporting the Human Rights Council, its subsidiary bodies",
    Title: "Enhanced contribution of national human rights institutions to the universal periodic review mechanism",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=44"
  },
  {
    ID: 604,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Supporting the Human Rights Council, its subsidiary bodies",
    Title: "Enhanced engagement of United Nations country teams with the universal periodic review mechanism",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in the protection and enjoyment of Human Rights, reduced inequalities and discrimination; and further integration of the right to development",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=44"
  },
  {
    ID: 605,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Supporting the Human Rights Council, its subsidiary bodies",
    Title: "Improved access of persons with disabilities to the work of the Human Rights Council",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion of human rights",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Improved multi-lateral meetings and deliberations",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=45"
  },
  {
    ID: 606,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Office of the Victims' Rights Advocate ",
    Title: "Strengthened system-wide implementation of the Secretary-General's strategy of placing the rights and dignity of victims at the centre of prevention and response from sexual exploitation and abuse ",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion of human rights",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Women and girls",
    SpecificResult: "Enhanced response against sexual exploitation and abuse, sexual harassment and fraud and corruption; improved mainstreaming of victim-centered approach",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=110"
  },
  {
    ID: 607,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "Office of the United Nations High Commissioner for Human Rights",
    Programme: "Human rights",
    Subprogramme: "Office of the Victims' Rights Advocate ",
    Title: "Enhanced support for victims through the leveraging of diverse experiences and knowledge of Victims' Rights Officers in peacekeeping, humanitarian and development contexts ",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion of human rights",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Women and girls",
    SpecificResult: "Enhanced response against sexual exploitation and abuse, sexual harassment and fraud and corruption; improved mainstreaming of victim-centered approach",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "ET,HT,ML,UA",
    Image: "24UHCHR26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=en#page=110"
  },
  {
    ID: 608,
    BudgetSection: 25,
    Entity: "UNHCR",
    EntityFullName: "Office of the United Nations High Commissioner for Refugees",
    Programme: "International protection, durable solutions and assistance to refugees",
    Subprogramme: "International protection, durable solutions and assistance to refugees",
    Title: "Global Refugee Forum pledges advance responsibility-sharing and support for refugees and host communities",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.25)&l=en#page=6"
  },
  {
    ID: 609,
    BudgetSection: 25,
    Entity: "UNHCR",
    EntityFullName: "Office of the United Nations High Commissioner for Refugees",
    Programme: "International protection, durable solutions and assistance to refugees",
    Subprogramme: "International protection, durable solutions and assistance to refugees",
    Title: "Increased prevalence of national and local partners in refugee response plans globally",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.25)&l=en#page=6"
  },
  {
    ID: 610,
    BudgetSection: 25,
    Entity: "UNHCR",
    EntityFullName: "Office of the United Nations High Commissioner for Refugees",
    Programme: "International protection, durable solutions and assistance to refugees",
    Subprogramme: "International protection, durable solutions and assistance to refugees",
    Title: "Strengthened protection and access to services for refugees and asylum-seekers",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.25)&l=en#page=7"
  },
  {
    ID: 611,
    BudgetSection: 25,
    Entity: "UNHCR",
    EntityFullName: "Office of the United Nations High Commissioner for Refugees",
    Programme: "International protection, durable solutions and assistance to refugees",
    Subprogramme: "International protection, durable solutions and assistance to refugees",
    Title: "Increased adherence to international conventions on statelessness",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.25)&l=en#page=7"
  },
  {
    ID: 612,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees are protected through the realization of their rights under international law",
    Title: "Increased access to rehabilitation support for Palestine refugees with disabilities",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=7"
  },
  {
    ID: 613,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees are protected through the realization of their rights under international law",
    Title: "Safety and dignity of Palestine refugees accessing the Agency’s services is increased",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=8"
  },
  {
    ID: 614,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees are protected through the realization of their rights under international law",
    Title: "Strengthened protection for Palestine refugees from gender-based violence",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Women and girls",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=9"
  },
  {
    ID: 615,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees are protected through the realization of their rights under international law",
    Title: "Improved effectiveness of social work interventions for vulnerable Palestine refugees",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=10"
  },
  {
    ID: 616,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees have universal access to quality primary healthcare and targeted access to secondary and tertiary care, leading to improved health",
    Title: "Improved control of noncommunicable diseases among Palestine refugees",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=11"
  },
  {
    ID: 617,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees have universal access to quality primary healthcare and targeted access to secondary and tertiary care, leading to improved health",
    Title: "Access to preconception care and reproductive planning services for Palestine refugees is improved",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Women and girls",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=12"
  },
  {
    ID: 618,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees have universal access to quality primary healthcare and targeted access to secondary and tertiary care, leading to improved health",
    Title: "Infectious diseases controlled in Palestine refugee communities",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=13"
  },
  {
    ID: 619,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees have universal access to quality primary healthcare and targeted access to secondary and tertiary care, leading to improved health",
    Title: "Sustained access to mental health and psychosocial support for Palestine refugees with identified needs",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=13"
  },
  {
    ID: 620,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees have access to inclusive and equitable quality education",
    Title: "Sustained participation of Palestine refugee children in elementary education",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Youth",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=15"
  },
  {
    ID: 621,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees have access to inclusive and equitable quality education",
    Title: "Safety and inclusiveness of the learning environment for students in Agency schools increased",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Youth",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=16"
  },
  {
    ID: 622,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees have access to inclusive and equitable quality education",
    Title: "Social and emotional development of Palestine refugee children protected",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Youth",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=16"
  },
  {
    ID: 623,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees have access to inclusive and equitable quality education",
    Title: "Expanded provision of blended and adapted learning across UNRWA fields of operation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Youth",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=17"
  },
  {
    ID: 624,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees have sustained and, where feasible, strengthened opportunities for decent work and income generation through skills, enterprise support and fair access to labour markets",
    Title: "Expanded employment opportunities through infrastructure and camp improvement works",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=19"
  },
  {
    ID: 625,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees have sustained and, where feasible, strengthened opportunities for decent work and income generation through skills, enterprise support and fair access to labour markets",
    Title: "Private sector employment opportunities created",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=20"
  },
  {
    ID: 626,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees have sustained and, where feasible, strengthened opportunities for decent work and income generation through skills, enterprise support and fair access to labour markets",
    Title: "Improved youth employment opportunities through vocational training",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Youth",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=21"
  },
  {
    ID: 627,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees have sustained and, where feasible, strengthened opportunities for decent work and income generation through skills, enterprise support and fair access to labour markets",
    Title: "Expanded access to inclusive financial services for Palestine refugee women",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Women and girls",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=22"
  },
  {
    ID: 628,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees have access to basic and public service infrastructure in safe and sustainable camp environments that protect their health and dignity",
    Title: "Health risks associated with water and sanitation reduced for Palestine refugees in camps",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=23"
  },
  {
    ID: 629,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees have access to basic and public service infrastructure in safe and sustainable camp environments that protect their health and dignity",
    Title: "Safety and dignity of Palestine refugees living in camps improved",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=24"
  },
  {
    ID: 630,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees have access to basic and public service infrastructure in safe and sustainable camp environments that protect their health and dignity",
    Title: "Improved water quality for Palestine refugees",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=25"
  },
  {
    ID: 631,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees have access to basic and public service infrastructure in safe and sustainable camp environments that protect their health and dignity",
    Title: "Improved living conditions for Palestine refugees in camps",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=25"
  },
  {
    ID: 632,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "The most vulnerable Palestine refugees receive more impactful, better-targeted social assistance",
    Title: "Improved access to employment for vulnerable Palestine refugee youth",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "Youth",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=27"
  },
  {
    ID: 633,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "The most vulnerable Palestine refugees receive more impactful, better-targeted social assistance",
    Title: "Access to affordable hospital care ensured",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=27"
  },
  {
    ID: 634,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "The most vulnerable Palestine refugees receive more impactful, better-targeted social assistance",
    Title: "Social transfers for the most vulnerable Palestine refugees safeguarded",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=28"
  },
  {
    ID: 635,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "The most vulnerable Palestine refugees receive more impactful, better-targeted social assistance",
    Title: "Improved resilience of households receiving social transfers",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=28"
  },
  {
    ID: 636,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees are accurately registered and their status is securely maintained",
    Title: "Historic family records are preserved and secured through large-scale digitization",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,LU,PS,SY",
    Image: "26UNRWA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=30"
  },
  {
    ID: 637,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "United Nations Relief and Works Agency for Palestine Refugees in the Near East ",
    Programme: "Palestine refugees",
    Subprogramme: "Palestine refugees are accurately registered and their status is securely maintained",
    Title: "Registered Palestine refugees have improved digital access to their records and services",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened protection of refugee rights, improved living conditions, including health and education, improved responsiveness and shared burden.",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=en#page=31"
  },
  {
    ID: 638,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "Office for the Coordination of Humanitarian Affairs",
    Programme: "Humanitarian assistance",
    Subprogramme: "Policy and analysis",
    Title: "Locally driven consultations informed humanitarian response priorities, financing and preparedness actions",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced coherence, timeliness, effectiveness and reach of humanitarian response; substantially reduced disaster risk.",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CO,PH,SO",
    Image: "27OCHA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=en#page=8"
  },
  {
    ID: 639,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "Office for the Coordination of Humanitarian Affairs",
    Programme: "Humanitarian assistance",
    Subprogramme: "Policy and analysis",
    Title: "Increased engagement of communities in humanitarian response to effectively address their needs",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced coherence, timeliness, effectiveness and reach of humanitarian response; substantially reduced disaster risk.",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CO,NE,PH,SS,II,SO",
    Image: "27OCHA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=en#page=9"
  },
  {
    ID: 640,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "Office for the Coordination of Humanitarian Affairs",
    Programme: "Humanitarian assistance",
    Subprogramme: "Policy and analysis",
    Title: "Improved collective learning through the integration of local perspectives",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced coherence, timeliness, effectiveness and reach of humanitarian response; substantially reduced disaster risk.",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=en#page=9"
  },
  {
    ID: 641,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "Office for the Coordination of Humanitarian Affairs",
    Programme: "Humanitarian assistance",
    Subprogramme: "Policy and analysis",
    Title: "More efficient and structured humanitarian responses for affected communities",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced coherence, timeliness, effectiveness and reach of humanitarian response; substantially reduced disaster risk.",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=en#page=10"
  },
  {
    ID: 642,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "Office for the Coordination of Humanitarian Affairs",
    Programme: "Humanitarian assistance",
    Subprogramme: "Coordination of humanitarian action and emergency response",
    Title: "Reaching people in need amid severe funding shortfalls",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced coherence, timeliness, effectiveness and reach of humanitarian response; substantially reduced disaster risk.",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=en#page=12"
  },
  {
    ID: 643,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "Office for the Coordination of Humanitarian Affairs",
    Programme: "Humanitarian assistance",
    Subprogramme: "Coordination of humanitarian action and emergency response",
    Title: "Increased participation of local and national actors in humanitarian coordination mechanisms",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced coherence, timeliness, effectiveness and reach of humanitarian response; substantially reduced disaster risk.",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=en#page=13"
  },
  {
    ID: 644,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "Office for the Coordination of Humanitarian Affairs",
    Programme: "Humanitarian assistance",
    Subprogramme: "Coordination of humanitarian action and emergency response",
    Title: "Scaled up anticipatory approaches and early warning early action systems",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced coherence, timeliness, effectiveness and reach of humanitarian response; substantially reduced disaster risk.",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=en#page=14"
  },
  {
    ID: 645,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "Office for the Coordination of Humanitarian Affairs",
    Programme: "Humanitarian assistance",
    Subprogramme: "Coordination of humanitarian action and emergency response",
    Title: "Strengthened system-wide diplomacy to defend humanitarian principles, secure access and protect civilians",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced coherence, timeliness, effectiveness and reach of humanitarian response; substantially reduced disaster risk.",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=en#page=15"
  },
  {
    ID: 646,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "Office for the Coordination of Humanitarian Affairs",
    Programme: "Humanitarian assistance",
    Subprogramme: "Emergency support services",
    Title: "Strengthened international emergency response through updated guidance",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Enhanced coherence, timeliness, effectiveness and reach of humanitarian response; substantially reduced disaster risk.",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=en#page=17"
  },
  {
    ID: 647,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "Office for the Coordination of Humanitarian Affairs",
    Programme: "Humanitarian assistance",
    Subprogramme: "Emergency support services",
    Title: "Enhanced partnership with the private sector in collective humanitarian action",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "International community",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Enhanced coherence, timeliness, effectiveness and reach of humanitarian response; substantially reduced disaster risk.",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "SD,QQ,SB",
    Image: "27OCHA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=en#page=18"
  },
  {
    ID: 648,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "Office for the Coordination of Humanitarian Affairs",
    Programme: "Humanitarian assistance",
    Subprogramme: "Emergency support services",
    Title: "Crisis-affected people receive emergency humanitarian assistance in the immediate aftermath of a catastrophe",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced coherence, timeliness, effectiveness and reach of humanitarian response; substantially reduced disaster risk.",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=en#page=19"
  },
  {
    ID: 649,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "Office for the Coordination of Humanitarian Affairs",
    Programme: "Humanitarian assistance",
    Subprogramme: "Emergency support services",
    Title: "Enhanced global readiness of urban search and rescue teams",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced coherence, timeliness, effectiveness and reach of humanitarian response; substantially reduced disaster risk.",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=en#page=19"
  },
  {
    ID: 650,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "Office for the Coordination of Humanitarian Affairs",
    Programme: "Humanitarian assistance",
    Subprogramme: "Humanitarian emergency information and advocacy",
    Title: "Crisis-affected people received data-driven support from humanitarian actors",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced coherence, timeliness, effectiveness and reach of humanitarian response; substantially reduced disaster risk.",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=en#page=21"
  },
  {
    ID: 651,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "Office for the Coordination of Humanitarian Affairs",
    Programme: "Humanitarian assistance",
    Subprogramme: "Humanitarian emergency information and advocacy",
    Title: "Reliable network and connectivity services for humanitarian responders",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced coherence, timeliness, effectiveness and reach of humanitarian response; substantially reduced disaster risk.",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=en#page=22"
  },
  {
    ID: 652,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "Office for the Coordination of Humanitarian Affairs",
    Programme: "Humanitarian assistance",
    Subprogramme: "Humanitarian emergency information and advocacy",
    Title: "Enhanced access to critical data and information",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced coherence, timeliness, effectiveness and reach of humanitarian response; substantially reduced disaster risk.",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=en#page=23"
  },
  {
    ID: 653,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "Office for the Coordination of Humanitarian Affairs",
    Programme: "Humanitarian assistance",
    Subprogramme: "Humanitarian emergency information and advocacy",
    Title: "Strengthened public awareness of humanitarian crises",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=en#page=24"
  },
  {
    ID: 654,
    BudgetSection: 27,
    Entity: "UNDRR",
    EntityFullName: "United Nations Office for Disaster Risk Reduction",
    Programme: "Humanitarian assistance",
    Subprogramme: "United Nations Office for Disaster Risk Reduction",
    Title: "Member States and stakeholders review progress on the implementation of the Sendai Framework and identify recommendations to enhance disaster risk reduction",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Inclusive and sustainable recovery from disasters; building resilience for future disasters",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=en#page=42"
  },
  {
    ID: 655,
    BudgetSection: 27,
    Entity: "UNDRR",
    EntityFullName: "United Nations Office for Disaster Risk Reduction",
    Programme: "Humanitarian assistance",
    Subprogramme: "United Nations Office for Disaster Risk Reduction",
    Title: "Strengthened inclusive multi-hazard early warning systems that reach the most vulnerable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Inclusive and sustainable recovery from disasters; building resilience for future disasters",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=en#page=43"
  },
  {
    ID: 656,
    BudgetSection: 27,
    Entity: "UNDRR",
    EntityFullName: "United Nations Office for Disaster Risk Reduction",
    Programme: "Humanitarian assistance",
    Subprogramme: "United Nations Office for Disaster Risk Reduction",
    Title: "National strategies in place to finance disaster risk reduction",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "Inclusive and sustainable recovery from disasters; building resilience for future disasters",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=en#page=43"
  },
  {
    ID: 657,
    BudgetSection: 27,
    Entity: "UNDRR",
    EntityFullName: "United Nations Office for Disaster Risk Reduction",
    Programme: "Humanitarian assistance",
    Subprogramme: "United Nations Office for Disaster Risk Reduction",
    Title: "Governments assess, strengthen and institutionalize their readiness for resilient recovery to build back better",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Effective coordination of humanitarian assistance efforts and support for refugees",
    Beneficiary: "Public administration",
    BeneficiaryTwo: " ",
    SpecificResult: "Inclusive and sustainable recovery from disasters; building resilience for future disasters",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=en#page=44"
  },
  {
    ID: 658,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Department of Global Communications",
    Programme: "Global communications",
    Subprogramme: "Campaigns and country operations services",
    Title: "Strengthened public engagement on United Nations priority issues",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=en#page=6"
  },
  {
    ID: 659,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Department of Global Communications",
    Programme: "Global communications",
    Subprogramme: "Campaigns and country operations services",
    Title: "Increased action on the 2030 Agenda for Sustainable Development",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=en#page=7"
  },
  {
    ID: 660,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Department of Global Communications",
    Programme: "Global communications",
    Subprogramme: "Campaigns and country operations services",
    Title: "Greater public understanding of and engagement on critical issues related to the Sustainable Development Goals",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Increased cooperation, information and best practice sharing for progress towards the SDGs",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=en#page=7"
  },
  {
    ID: 661,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Department of Global Communications",
    Programme: "Global communications",
    Subprogramme: "Campaigns and country operations services",
    Title: "Expanded access to advocacy material and messaging on priority issues",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved cooperation and partnerships and increased coherence, synergies and reduced overlap through consistent communication",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=en#page=8"
  },
  {
    ID: 662,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Department of Global Communications",
    Programme: "Global communications",
    Subprogramme: "News services",
    Title: "Increased public reach on United Nations news coverage",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=en#page=10"
  },
  {
    ID: 663,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Department of Global Communications",
    Programme: "Global communications",
    Subprogramme: "News services",
    Title: "Deeper engagement of audiences through live-blogging tools and formats",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=en#page=11"
  },
  {
    ID: 664,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Department of Global Communications",
    Programme: "Global communications",
    Subprogramme: "News services",
    Title: "Increased audience engagement and support for United Nations international observances",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=en#page=11"
  },
  {
    ID: 665,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Department of Global Communications",
    Programme: "Global communications",
    Subprogramme: "News services",
    Title: "Enhanced and timely global access to United Nations News",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=en#page=12"
  },
  {
    ID: 666,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Department of Global Communications",
    Programme: "Global communications",
    Subprogramme: "Outreach and knowledge services",
    Title: "Strengthened global support and action for the work of the United Nations",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved cooperation and partnerships and increased coherence, synergies and reduced overlap through consistent communication",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=en#page=14"
  },
  {
    ID: 667,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Department of Global Communications",
    Programme: "Global communications",
    Subprogramme: "Outreach and knowledge services",
    Title: "Young journalists gain access and insight into the work of the United Nations",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Youth",
    BeneficiaryTwo: "International community",
    SpecificResult: "Improved cooperation and partnerships and increased coherence, synergies and reduced overlap through consistent communication",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=en#page=14"
  },
  {
    ID: 668,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Department of Global Communications",
    Programme: "Global communications",
    Subprogramme: "Outreach and knowledge services",
    Title: "Advancing implementation of the Sustainable Development Goals through higher education institutions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Sustainable development",
    Beneficiary: "Youth",
    BeneficiaryTwo: "International community",
    SpecificResult: "Improved cooperation and partnerships and increased coherence, synergies and reduced overlap through consistent communication",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=en#page=15"
  },
  {
    ID: 669,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "Department of Global Communications",
    Programme: "Global communications",
    Subprogramme: "Outreach and knowledge services",
    Title: "Increased number of visitors to United Nations Headquarters through thematic guided tours",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "International community",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=en#page=16"
  },
  {
    ID: 670,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Enterprise resource planning solution, services to the Fifth Committee of the General Assembly and to the Committee for Programme and Coordination, and management advisory services: Enterprise resource planning solution",
    Title: "Digital transformation using Umoja for improved efficiency and effective decision-making",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=9"
  },
  {
    ID: 671,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Enterprise resource planning solution, services to the Fifth Committee of the General Assembly and to the Committee for Programme and Coordination, and management advisory services: Enterprise resource planning solution",
    Title: "Data-driven actionable insights through NextGen Umoja Analytics",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=9"
  },
  {
    ID: 672,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Enterprise resource planning solution, services to the Fifth Committee of the General Assembly and to the Committee for Programme and Coordination, and management advisory services: Enterprise resource planning solution",
    Title: "Decision-making facilitated through enhancements to Member State portals",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved multi-lateral meetings and deliberations",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=10"
  },
  {
    ID: 673,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Enterprise resource planning solution, services to the Fifth Committee of the General Assembly and to the Committee for Programme and Coordination, and management advisory services: Enterprise resource planning solution",
    Title: "Upgrade to the Next Generation Enterprise Resource Planning (NextGen ERP)",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=10"
  },
  {
    ID: 674,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Enterprise resource planning solution, services to the Fifth Committee of the General Assembly and to the Committee for Programme and Coordination, and management advisory services: Services to the Fifth Committee of the General Assembly and to the Committee for Programme and Coordination",
    Title: "Supported Fifth Committee processes through expanded information and efficient reporting",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: "International community",
    SpecificResult: "Improved multi-lateral meetings and deliberations",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=12"
  },
  {
    ID: 675,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Enterprise resource planning solution, services to the Fifth Committee of the General Assembly and to the Committee for Programme and Coordination, and management advisory services: Services to the Fifth Committee of the General Assembly and to the Committee for Programme and Coordination",
    Title: "Improved access to information, including pre-sessional information, for members of the Fifth Committee and the Committee for Programme and Coordination",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: "International community",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=13"
  },
  {
    ID: 676,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Enterprise resource planning solution, services to the Fifth Committee of the General Assembly and to the Committee for Programme and Coordination, and management advisory services: Services to the Fifth Committee of the General Assembly and to the Committee for Programme and Coordination",
    Title: "Simplified and streamlined processes and improved services for meeting participants",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: "International community",
    SpecificResult: "Improved multi-lateral meetings and deliberations",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=13"
  },
  {
    ID: 677,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Enterprise resource planning solution, services to the Fifth Committee of the General Assembly and to the Committee for Programme and Coordination, and management advisory services: Services to the Fifth Committee of the General Assembly and to the Committee for Programme and Coordination",
    Title: "Strengthened support on election- and appointment-related processes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: "International community",
    SpecificResult: "Improved efficiency of processes due to science, technology and innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=14"
  },
  {
    ID: 678,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Enterprise resource planning solution, services to the Fifth Committee of the General Assembly and to the Committee for Programme and Coordination, and management advisory services: Management advisory services",
    Title: "Timely responses to management evaluation requests",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=16"
  },
  {
    ID: 679,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Enterprise resource planning solution, services to the Fifth Committee of the General Assembly and to the Committee for Programme and Coordination, and management advisory services: Management advisory services",
    Title: "Organizational resilience management system is institutionalized in United Nations system organizations",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=16"
  },
  {
    ID: 680,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Enterprise resource planning solution, services to the Fifth Committee of the General Assembly and to the Committee for Programme and Coordination, and management advisory services: Management advisory services",
    Title: "Recommendations of the Headquarters Committee on Contracts accepted by delegated officials",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=17"
  },
  {
    ID: 681,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Enterprise resource planning solution, services to the Fifth Committee of the General Assembly and to the Committee for Programme and Coordination, and management advisory services: Management advisory services",
    Title: "Enhanced understanding by staff of the Organization’s formal system of justice",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened mechanisms of internal justice and mediation for more ethical behaviour, enhanced harmony and improved access to justice within the UN",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=17"
  },
  {
    ID: 682,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Programme planning, finance and budget: Finance",
    Title: "Improved access to consolidated cost-recovery information for decision-making by Secretariat entities",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparency and ease of access for improved implementation of programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=20"
  },
  {
    ID: 683,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Programme planning, finance and budget: Finance",
    Title: "Improved client experience with United Nations global payment systems",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=20"
  },
  {
    ID: 684,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Programme planning, finance and budget: Finance",
    Title: "Implementation of approved updates to the International Public Sector Accounting Standards and impact analysis of upcoming changes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=21"
  },
  {
    ID: 685,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Programme planning, finance and budget: Finance",
    Title: "Strengthened financial management regulatory framework through newly established and updated policy instruments",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Enabling legal and regulatory frameworks; reduced exposure to legal liabilities",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=22"
  },
  {
    ID: 686,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Programme planning, finance and budget: Field operations",
    Title: "Strengthened oversight and accountability in property management",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=24"
  },
  {
    ID: 687,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Programme planning, finance and budget: Field operations",
    Title: "Coordination and exchanges towards synergy and standardization in facilities management",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved multi-lateral meetings and deliberations",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=25"
  },
  {
    ID: 688,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Programme planning, finance and budget: Field operations",
    Title: "Quality and cost-efficient capital construction projects of the Organization",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=26"
  },
  {
    ID: 689,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Programme planning, finance and budget: Field operations",
    Title: "Greater transparency and efficiency in the formulation of budgetary requirements for special political missions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparency and ease of access for improved implementation of programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=26"
  },
  {
    ID: 690,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Programme planning, finance and budget: Programme planning and budgeting",
    Title: "Successful conclusion of budgetary deliberations on the UN80 initiative within a condensed timeline",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: "International community",
    SpecificResult: "Improved multi-lateral meetings and deliberations",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=29"
  },
  {
    ID: 691,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Programme planning, finance and budget: Programme planning and budgeting",
    Title: "Enhanced transparency on the programme budget implications process for Member States",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=29"
  },
  {
    ID: 692,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Programme planning, finance and budget: Programme planning and budgeting",
    Title: "Enhanced budgetary information available on the Budget Information Pilot to support Member States’ decision-making",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=30"
  },
  {
    ID: 693,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Programme planning, finance and budget: Programme planning and budgeting",
    Title: "Greater efficiency reflected in budgetary requirements across Secretariat entities",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=30"
  },
  {
    ID: 694,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Human resources: Global strategy and policy",
    Title: "Staff members, managers and senior leadership navigated organizational change",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=34"
  },
  {
    ID: 695,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Human resources: Global strategy and policy",
    Title: "Fewer unrepresented and underrepresented Member States in the desirable ranges system",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved recruitment and staffing of UN entities, including reduced inequalities in terms of gender and geographic representation",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=34"
  },
  {
    ID: 696,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Human resources: Global strategy and policy",
    Title: "A fair, effective, efficient and agile staff selection system",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved recruitment and staffing of UN entities, including reduced inequalities in terms of gender and geographic representation",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=35"
  },
  {
    ID: 697,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Human resources: Global strategy and policy",
    Title: "Comprehensive young-talent approach enhancing the Organization’s ability to attract, develop and retain early-career talent",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: "Youth",
    SpecificResult: "Improved recruitment and staffing of UN entities, including reduced inequalities in terms of gender and geographic representation",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=35"
  },
  {
    ID: 698,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Human resources: Administrative law",
    Title: "Expanded use of screening tools for conduct and discipline matters",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced response against sexual exploitation and abuse, sexual harassment and fraud and corruption; improved mainstreaming of victim-centered approach",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=37"
  },
  {
    ID: 699,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Human resources: Administrative law",
    Title: "Adjustments to the Secretariat’s policy framework and management practices facilitated by United Nations Dispute Tribunal judgments",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Enabling legal and regulatory frameworks; reduced exposure to legal liabilities",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=38"
  },
  {
    ID: 700,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Human resources: Administrative law",
    Title: "Enhanced decision-making capacity of senior leadership in handling conduct and discipline matters",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened mechanisms of internal justice and mediation for more ethical behaviour, enhanced harmony and improved access to justice within the UN",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=39"
  },
  {
    ID: 701,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Human resources: Administrative law",
    Title: "Enhanced accountability through efficiency and consistency in the review and disposition of disciplinary cases",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened mechanisms of internal justice and mediation for more ethical behaviour, enhanced harmony and improved access to justice within the UN",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=39"
  },
  {
    ID: 702,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Business transformation and accountability",
    Title: "Problem-solving using generative artificial intelligence to improve efficiency",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: "International community",
    SpecificResult: "Technological advancements that lead to improved quality, availability, accessibility and security of information",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=41"
  },
  {
    ID: 703,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Business transformation and accountability",
    Title: "Increased use of internal evaluation by smaller entities to inform decision-making",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Technological advancements that lead to improved quality, availability, accessibility and security of information",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=42"
  },
  {
    ID: 704,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Business transformation and accountability",
    Title: "Enhanced data-driven decision-making through continuous improvement of the management dashboard",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Technological advancements that lead to improved quality, availability, accessibility and security of information",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=43"
  },
  {
    ID: 705,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Business transformation and accountability",
    Title: "Timely implementation of oversight bodies’ recommendations",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=43"
  },
  {
    ID: 706,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Addressing racism in the workplace",
    Title: "Addressing interpersonal, institutional, and systemic forms of racism in the Organization",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened mechanisms of internal justice and mediation for more ethical behaviour, enhanced harmony and improved access to justice within the UN",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=45"
  },
  {
    ID: 707,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Addressing racism in the workplace",
    Title: "Strengthened accountability systems to address allegations of racism in the workplace",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened mechanisms of internal justice and mediation for more ethical behaviour, enhanced harmony and improved access to justice within the UN",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=46"
  },
  {
    ID: 708,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Addressing racism in the workplace",
    Title: "Improved institutional transparency on diversity",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened mechanisms of internal justice and mediation for more ethical behaviour, enhanced harmony and improved access to justice within the UN",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=47"
  },
  {
    ID: 709,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Department of Management Strategy, Policy and Compliance",
    Programme: "Department of Management Strategy, Policy and Compliance",
    Subprogramme: "Addressing racism in the workplace",
    Title: "Increased knowledge related to addressing racism and racial discrimination in the workplace",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=en#page=47"
  },
  {
    ID: 710,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Support operations: Human resources support",
    Title: "Secretariat entities receive comprehensive operational human resources support and guidance for restructuring and downsizing",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved recruitment and staffing of UN entities, including reduced inequalities in terms of gender and geographic representation",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=7"
  },
  {
    ID: 711,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Support operations: Human resources support",
    Title: "Improved performance management across the Secretariat",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=7"
  },
  {
    ID: 712,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Support operations: Human resources support",
    Title: "Enhanced roster building and management for the global Secretariat",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved recruitment and staffing of UN entities, including reduced inequalities in terms of gender and geographic representation",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=8"
  },
  {
    ID: 713,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Support operations: Human resources support",
    Title: "Enhanced recruitment of gratis personnel",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved recruitment and staffing of UN entities, including reduced inequalities in terms of gender and geographic representation",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=8"
  },
  {
    ID: 714,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Support operations: Capacity development and operational training",
    Title: "United Nations staff and personnel, Member States, job candidates and hiring managers have access to a centralized hub for language and communications skills",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=10"
  },
  {
    ID: 715,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Support operations: Capacity development and operational training",
    Title: "UNTold: collective learning and innovation across the United Nations system",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "",
    Image: "29BDOS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=11"
  },
  {
    ID: 716,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Support operations: Capacity development and operational training",
    Title: "Strengthened organizational capabilities in innovation, data analytics, digital transformation, strategic foresight and behavioural science",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=11"
  },
  {
    ID: 717,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Support operations: Capacity development and operational training",
    Title: "Improved availability and accessibility of administrative and operational guidance",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparency and ease of access for improved implementation of programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=12"
  },
  {
    ID: 718,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Support operations: Healthcare management and occupational safety and health",
    Title: "Improved preparedness to prevent and mitigate communicable disease risks affecting United Nations staff and personnel",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=14"
  },
  {
    ID: 719,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Support operations: Healthcare management and occupational safety and health",
    Title: "United Nations personnel use preventive health services to improve their health and well-being",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=14"
  },
  {
    ID: 720,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Support operations: Healthcare management and occupational safety and health",
    Title: "Improved quality of patient care",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Technological advancements that lead to improved quality, availability, accessibility and security of information",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "",
    Image: "29BDOS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=15"
  },
  {
    ID: 721,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Support operations: Healthcare management and occupational safety and health",
    Title: "Enhanced access to digital mental health support for peacekeeping personnel",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved performance, safety and security of PK missions, including smooth transitions following the Security Council resolutions",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=15"
  },
  {
    ID: 722,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Supply chain management: Integrated supply chain management",
    Title: "Safe and timely repatriation of uniformed personnel in line with mission contingency plans",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved performance, safety and security of PK missions, including smooth transitions following the Security Council resolutions",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=17"
  },
  {
    ID: 723,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Supply chain management: Integrated supply chain management",
    Title: "Diversified participation in United Nations business opportunities",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "Women and girls",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "",
    Image: "29BDOS14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=18"
  },
  {
    ID: 724,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Supply chain management: Integrated supply chain management",
    Title: "Increased availability of on-call logistics solutions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparency and ease of access for improved implementation of programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=18"
  },
  {
    ID: 725,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Supply chain management: Integrated supply chain management",
    Title: "Integrated supply chain solutions for humanitarian and complex environments",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparency and ease of access for improved implementation of programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=19"
  },
  {
    ID: 726,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Supply chain management: Uniformed capabilities support",
    Title: "Peacekeeping missions implement contingency plans that enabled cost reductions",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved performance, safety and security of PK missions, including smooth transitions following the Security Council resolutions",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=21"
  },
  {
    ID: 727,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Supply chain management: Uniformed capabilities support",
    Title: "A secure one-stop-gateway for Member States to submit claims and access information on their deployments to peace operations",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Technological advancements that lead to improved quality, availability, accessibility and security of information",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=22"
  },
  {
    ID: 728,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Supply chain management: Uniformed capabilities support",
    Title: "Updated policies, procedures, standards and definitions for uniformed personnel and contingent-owned equipment",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparency and ease of access for improved implementation of programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=23"
  },
  {
    ID: 729,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Supply chain management: Uniformed capabilities support",
    Title: "Strengthened management of contingent-owned ammunition",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved efficiency of processes due to science, technology and innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=23"
  },
  {
    ID: 730,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Special activities",
    Title: "United Nations Support Office in Haiti established",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "HT",
    Image: "29BDOS21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=26"
  },
  {
    ID: 731,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Special activities",
    Title: "Enhanced through-life management of operational support functions by entities undergoing transitions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved performance, safety and security of PK missions, including smooth transitions following the Security Council resolutions",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=26"
  },
  {
    ID: 732,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Special activities",
    Title: "Efficient and improved service delivery through enhanced support and advisory services",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparency and ease of access for improved implementation of programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CO,PK,ZW",
    Image: "29BDOS23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=27"
  },
  {
    ID: 733,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Special activities",
    Title: "Strengthened support partnership arrangements",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparency and ease of access for improved implementation of programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=28"
  },
  {
    ID: 734,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Administration, New York",
    Title: "Rental cost recovery automated through payroll",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved efficiency of processes due to science, technology and innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=30"
  },
  {
    ID: 735,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Administration, New York",
    Title: "Historical records digitally preserved",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=30"
  },
  {
    ID: 736,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Administration, New York",
    Title: "Office space aligned with the needs of the Organization",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=31"
  },
  {
    ID: 737,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Department of Operational Support",
    Programme: "Department of Operational Support",
    Subprogramme: "Administration, New York",
    Title: "Increased accessibility of premises and facilities at United Nations Headquarters for persons with disabilities",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "Refugees, minorities and other groups in vulnerable situations",
    BeneficiaryTwo: "enabling",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=en#page=31"
  },
  {
    ID: 738,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Office of Information and Communications Technology",
    Programme: "Office of Information and Communications Technology",
    Subprogramme: "Strategy and technology innovation",
    Title: "Improved information and security technology security awareness to safeguard the Secretariat",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=en#page=7"
  },
  {
    ID: 739,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Office of Information and Communications Technology",
    Programme: "Office of Information and Communications Technology",
    Subprogramme: "Strategy and technology innovation",
    Title: "Enhanced effectiveness in mandate delivery by leveraging generative artificial intelligence",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved efficiency of processes due to science, technology and innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=en#page=8"
  },
  {
    ID: 740,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Office of Information and Communications Technology",
    Programme: "Office of Information and Communications Technology",
    Subprogramme: "Strategy and technology innovation",
    Title: "Ethical and responsible use of artificial intelligence",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Technological advancements that lead to improved quality, availability, accessibility and security of information",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=en#page=8"
  },
  {
    ID: 741,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Office of Information and Communications Technology",
    Programme: "Office of Information and Communications Technology",
    Subprogramme: "Strategy and technology innovation",
    Title: "Enable Secretariat entities to apply the information and communications technology strategy effectively for improved mandate delivery",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=en#page=9"
  },
  {
    ID: 742,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Office of Information and Communications Technology",
    Programme: "Office of Information and Communications Technology",
    Subprogramme: "Operations support",
    Title: "More reliable and stable connectivity for delegates and staff due to improved Wi-Fi at Headquarters",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=en#page=11"
  },
  {
    ID: 743,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Office of Information and Communications Technology",
    Programme: "Office of Information and Communications Technology",
    Subprogramme: "Operations support",
    Title: "Strengthened governance of technologies that support intergovernmental meetings",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=en#page=12"
  },
  {
    ID: 744,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Office of Information and Communications Technology",
    Programme: "Office of Information and Communications Technology",
    Subprogramme: "Operations support",
    Title: "Reduced risks through cloud-based authentication for secure access",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=en#page=13"
  },
  {
    ID: 745,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Office of Information and Communications Technology",
    Programme: "Office of Information and Communications Technology",
    Subprogramme: "Operations support",
    Title: "Reduced fragmentation and strengthened information and communications technology resilience, security and standardization of data centre infrastructure",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=en#page=14"
  },
  {
    ID: 746,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Office of Information and Communications Technology",
    Programme: "Office of Information and Communications Technology",
    Subprogramme: "Enterprise solutions",
    Title: "Increased availability of websites and applications by migrating away from the primary technology centre of New York",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=en#page=16"
  },
  {
    ID: 747,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Office of Information and Communications Technology",
    Programme: "Office of Information and Communications Technology",
    Subprogramme: "Enterprise solutions",
    Title: "Timely custom information technology solutions for mandate delivery",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Advancements in science, technology and innovation, including artificial intelligence, for sustainable development ",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=en#page=16"
  },
  {
    ID: 748,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Office of Information and Communications Technology",
    Programme: "Office of Information and Communications Technology",
    Subprogramme: "Enterprise solutions",
    Title: "Information and communications technology solutions integrate artificial intelligence to assist in decision-making",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved efficiency of processes due to science, technology and innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=en#page=17"
  },
  {
    ID: 749,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Office of Information and Communications Technology",
    Programme: "Office of Information and Communications Technology",
    Subprogramme: "Enterprise solutions",
    Title: "Enhanced standards, security, multilingualism and accessibility of United Nations public information websites",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29COICT12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=en#page=18"
  },
  {
    ID: 750,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "United Nations Office at Nairobi",
    Programme: "Administration, Nairobi",
    Subprogramme: "Programme planning, finance and budget",
    Title: "Improved timeliness in processing accounting journals for clients",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=en#page=7"
  },
  {
    ID: 751,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "United Nations Office at Nairobi",
    Programme: "Administration, Nairobi",
    Subprogramme: "Programme planning, finance and budget",
    Title: "Improved assets accounting for United Nations Office at Nairobi buildings, facilities and infrastructure",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparency and ease of access for improved implementation of programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=en#page=7"
  },
  {
    ID: 752,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "United Nations Office at Nairobi",
    Programme: "Administration, Nairobi",
    Subprogramme: "Programme planning, finance and budget",
    Title: "Improved timeliness in the resolution of rejected and returned payments",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved efficiency of processes due to science, technology and innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "KE",
    Image: "29DUNON3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=en#page=8"
  },
  {
    ID: 753,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "United Nations Office at Nairobi",
    Programme: "Administration, Nairobi",
    Subprogramme: "Programme planning, finance and budget",
    Title: "Improved timeliness for financial reporting to donors",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: "International community",
    SpecificResult: "Simplification, transparency and ease of access for improved implementation of programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=en#page=9"
  },
  {
    ID: 754,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "United Nations Office at Nairobi",
    Programme: "Administration, Nairobi",
    Subprogramme: "Human resources management",
    Title: "Staff and personnel have access to enhanced well-being and mental health support",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=en#page=11"
  },
  {
    ID: 755,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "United Nations Office at Nairobi",
    Programme: "Administration, Nairobi",
    Subprogramme: "Human resources management",
    Title: "Staff and personnel acquire new knowledge and skills to improve organizational effectiveness",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved recruitment and staffing of UN entities, including reduced inequalities in terms of gender and geographic representation",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=en#page=11"
  },
  {
    ID: 756,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "United Nations Office at Nairobi",
    Programme: "Administration, Nairobi",
    Subprogramme: "Human resources management",
    Title: "Improved timeliness of staff benefits and entitlements services for all clients",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=en#page=12"
  },
  {
    ID: 757,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "United Nations Office at Nairobi",
    Programme: "Administration, Nairobi",
    Subprogramme: "Human resources management",
    Title: "Improved timeliness by client offices in recruitment pre-screening processes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved recruitment and staffing of UN entities, including reduced inequalities in terms of gender and geographic representation",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=en#page=13"
  },
  {
    ID: 758,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "United Nations Office at Nairobi",
    Programme: "Administration, Nairobi",
    Subprogramme: "Support services",
    Title: "United Nations entities in Kenya have access to an events centre inside the United Nations complex in Nairobi",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=en#page=15"
  },
  {
    ID: 759,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "United Nations Office at Nairobi",
    Programme: "Administration, Nairobi",
    Subprogramme: "Support services",
    Title: "New meeting and collaboration areas for delegates, staff and personnel",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=en#page=15"
  },
  {
    ID: 760,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "United Nations Office at Nairobi",
    Programme: "Administration, Nairobi",
    Subprogramme: "Support services",
    Title: "United Nations personnel in Kenya and the region receive smooth and efficient host country services",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=en#page=16"
  },
  {
    ID: 761,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "United Nations Office at Nairobi",
    Programme: "Administration, Nairobi",
    Subprogramme: "Support services",
    Title: "Improved conference service facilities that are integrated with the United Nations premises in Nairobi",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=en#page=16"
  },
  {
    ID: 762,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "United Nations Office at Nairobi",
    Programme: "Administration, Nairobi",
    Subprogramme: "Information and communications technology operations",
    Title: "A modernized information and communication technology platform that is compliant with United Nations Global Standards",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Technological advancements that lead to improved quality, availability, accessibility and security of information",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=en#page=18"
  },
  {
    ID: 763,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "United Nations Office at Nairobi",
    Programme: "Administration, Nairobi",
    Subprogramme: "Information and communications technology operations",
    Title: "Improved alignment of information and communications technology policies and practices in the United Nations",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Technological advancements that lead to improved quality, availability, accessibility and security of information",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=en#page=19"
  },
  {
    ID: 764,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "United Nations Office at Nairobi",
    Programme: "Administration, Nairobi",
    Subprogramme: "Information and communications technology operations",
    Title: "Smooth intergovernmental deliberations through the upgrade and maintenance of conference technology",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved multi-lateral meetings and deliberations",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "KE",
    Image: "29DUNON15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=en#page=20"
  },
  {
    ID: 765,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "United Nations Office at Nairobi",
    Programme: "Administration, Nairobi",
    Subprogramme: "Information and communications technology operations",
    Title: "Enhanced network interoperability under a single service provider platform",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=en#page=20"
  },
  {
    ID: 766,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "United Nations Office at Geneva",
    Programme: "Administration, Geneva",
    Subprogramme: "Programme planning, finance and budget",
    Title: "Improved timeliness of vendor payments",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=en#page=7"
  },
  {
    ID: 767,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "United Nations Office at Geneva",
    Programme: "Administration, Geneva",
    Subprogramme: "Programme planning, finance and budget",
    Title: "Entities have access to dedicated support when moving to or relocating from the Palais des Nations",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=en#page=7"
  },
  {
    ID: 768,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "United Nations Office at Geneva",
    Programme: "Administration, Geneva",
    Subprogramme: "Programme planning, finance and budget",
    Title: "Resilient and efficient treasury transaction processes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=en#page=8"
  },
  {
    ID: 769,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "United Nations Office at Geneva",
    Programme: "Administration, Geneva",
    Subprogramme: "Programme planning, finance and budget",
    Title: "Clients gain clearer insight into service performance through quarterly reporting",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=en#page=8"
  },
  {
    ID: 770,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "United Nations Office at Geneva",
    Programme: "Administration, Geneva",
    Subprogramme: "Human resources management",
    Title: "Staff support for career transition and early separation",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved recruitment and staffing of UN entities, including reduced inequalities in terms of gender and geographic representation",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=en#page=10"
  },
  {
    ID: 771,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "United Nations Office at Geneva",
    Programme: "Administration, Geneva",
    Subprogramme: "Human resources management",
    Title: "Staff and external applicants better understand the United Nations recruitment process and make informed career-related decisions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved recruitment and staffing of UN entities, including reduced inequalities in terms of gender and geographic representation",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CH",
    Image: "29EUNOG6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=en#page=10"
  },
  {
    ID: 772,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "United Nations Office at Geneva",
    Programme: "Administration, Geneva",
    Subprogramme: "Human resources management",
    Title: "Expanded youth engagement and intergenerational dialogue",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: "Youth",
    SpecificResult: "Improved recruitment and staffing of UN entities, including reduced inequalities in terms of gender and geographic representation",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CH",
    Image: "29EUNOG7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=en#page=11"
  },
  {
    ID: 773,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "United Nations Office at Geneva",
    Programme: "Administration, Geneva",
    Subprogramme: "Human resources management",
    Title: "Improved workforce support and organizational readiness through transitions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved recruitment and staffing of UN entities, including reduced inequalities in terms of gender and geographic representation",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=en#page=12"
  },
  {
    ID: 774,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "United Nations Office at Geneva",
    Programme: "Administration, Geneva",
    Subprogramme: "Support services",
    Title: "Assembly Hall audiovisual systems help deliver large-scale intergovernmental meetings and events",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: "International community",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=en#page=13"
  },
  {
    ID: 775,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "United Nations Office at Geneva",
    Programme: "Administration, Geneva",
    Subprogramme: "Support services",
    Title: "Event support centre, phase II",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: "International community",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=en#page=14"
  },
  {
    ID: 776,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "United Nations Office at Geneva",
    Programme: "Administration, Geneva",
    Subprogramme: "Support services",
    Title: "Clients benefit from modern building facilities following strategic heritage plan renovations",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=en#page=15"
  },
  {
    ID: 777,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "United Nations Office at Geneva",
    Programme: "Administration, Geneva",
    Subprogramme: "Support services",
    Title: "Improved energy management across the Palais des Nations",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: "Climate and environment",
    SpecificResult: "Sustainable resource management; Advancements in renewable energy",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=en#page=15"
  },
  {
    ID: 778,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "United Nations Office at Geneva",
    Programme: "Administration, Geneva",
    Subprogramme: "Information and communications technology operations",
    Title: "Clients achieve more efficient fixed phone line use",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=en#page=17"
  },
  {
    ID: 779,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "United Nations Office at Geneva",
    Programme: "Administration, Geneva",
    Subprogramme: "Information and communications technology operations",
    Title: "Event support centre, phase I",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved multi-lateral meetings and deliberations",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=en#page=18"
  },
  {
    ID: 780,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "United Nations Office at Geneva",
    Programme: "Administration, Geneva",
    Subprogramme: "Information and communications technology operations",
    Title: "Enhanced efficiency and security through the Internet of things for a better client experience",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved efficiency of processes due to science, technology and innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=en#page=18"
  },
  {
    ID: 781,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "United Nations Office at Geneva",
    Programme: "Administration, Geneva",
    Subprogramme: "Information and communications technology operations",
    Title: "Faster, more reliable network services for clients",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved efficiency of processes due to science, technology and innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=en#page=19"
  },
  {
    ID: 782,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "United Nations Office at Geneva",
    Programme: "Administration, Geneva",
    Subprogramme: "Library services",
    Title: "Irreplaceable and historic library collections protected for future generations during renovations",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=en#page=20"
  },
  {
    ID: 783,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "United Nations Office at Geneva",
    Programme: "Administration, Geneva",
    Subprogramme: "Library services",
    Title: "Increased availability of tools for clients to gain access to and use information resources efficiently and responsibly",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CH",
    Image: "29EUNOG18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=en#page=21"
  },
  {
    ID: 784,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "United Nations Office at Geneva",
    Programme: "Administration, Geneva",
    Subprogramme: "Library services",
    Title: "Enhanced access to more United Nations knowledge",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=en#page=22"
  },
  {
    ID: 785,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "United Nations Office at Geneva",
    Programme: "Administration, Geneva",
    Subprogramme: "Library services",
    Title: "Long-term sustainable access to United Nations archives for Member States and other stakeholders",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=en#page=22"
  },
  {
    ID: 786,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "United Nations Office at Vienna",
    Programme: "Administration, Vienna",
    Subprogramme: "Programme planning, finance and budget",
    Title: "Maintaining programme delivery amid unexpected funding disruption",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: "International community",
    SpecificResult: "Simplification, transparency and ease of access for improved implementation of programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=en#page=6"
  },
  {
    ID: 787,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "United Nations Office at Vienna",
    Programme: "Administration, Vienna",
    Subprogramme: "Programme planning, finance and budget",
    Title: "Improved financial accounting and reporting through implementation of IPSAS 47",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=en#page=7"
  },
  {
    ID: 788,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "United Nations Office at Vienna",
    Programme: "Administration, Vienna",
    Subprogramme: "Programme planning, finance and budget",
    Title: "Reduced unresolved financial issues in field offices",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=en#page=7"
  },
  {
    ID: 789,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "United Nations Office at Vienna",
    Programme: "Administration, Vienna",
    Subprogramme: "Programme planning, finance and budget",
    Title: "Improved financial transparency and management oversight",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=en#page=8"
  },
  {
    ID: 790,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "United Nations Office at Vienna",
    Programme: "Administration, Vienna",
    Subprogramme: "Human resources management",
    Title: "Improved contractual modality for field-based project personnel",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved recruitment and staffing of UN entities, including reduced inequalities in terms of gender and geographic representation",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=en#page=10"
  },
  {
    ID: 791,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "United Nations Office at Vienna",
    Programme: "Administration, Vienna",
    Subprogramme: "Human resources management",
    Title: "Towards inclusion of persons with disabilities in the workforce",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Improved recruitment and staffing of UN entities, including reduced inequalities in terms of gender and geographic representation",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AT",
    Image: "29FUNOV6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=en#page=10"
  },
  {
    ID: 792,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "United Nations Office at Vienna",
    Programme: "Administration, Vienna",
    Subprogramme: "Human resources management",
    Title: "Clients are informed and aware of all relevant human resources policies and developments",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved dissemination and access of information",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=en#page=11"
  },
  {
    ID: 793,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "United Nations Office at Vienna",
    Programme: "Administration, Vienna",
    Subprogramme: "Human resources management",
    Title: "Increased awareness of the Code of Conduct to Prevent Harassment, Including Sexual Harassment, at United Nations System Events",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened mechanisms of internal justice and mediation for more ethical behaviour, enhanced harmony and improved access to justice within the UN",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=en#page=11"
  },
  {
    ID: 794,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "United Nations Office at Vienna",
    Programme: "Administration, Vienna",
    Subprogramme: "Support services",
    Title: "Strengthened property management",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=en#page=14"
  },
  {
    ID: 795,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "United Nations Office at Vienna",
    Programme: "Administration, Vienna",
    Subprogramme: "Support services",
    Title: "Improved monitoring of implementing partners",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparency and ease of access for improved implementation of programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=en#page=14"
  },
  {
    ID: 796,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "United Nations Office at Vienna",
    Programme: "Administration, Vienna",
    Subprogramme: "Support services",
    Title: "A streamlined workflow for registering and distributing official correspondence",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved efficiency of processes due to science, technology and innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AT",
    Image: "29FUNOV11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=en#page=15"
  },
  {
    ID: 797,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "United Nations Office at Vienna",
    Programme: "Administration, Vienna",
    Subprogramme: "Support services",
    Title: "Improved utilization of office space",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=en#page=15"
  },
  {
    ID: 798,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "United Nations Office at Vienna",
    Programme: "Administration, Vienna",
    Subprogramme: "Information and communications technology operations",
    Title: "Strengthened reliability of information and communications technology operations through the consolidation of virtual infrastructure and a reduced reliance on subscription-based licences",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=en#page=17"
  },
  {
    ID: 799,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "United Nations Office at Vienna",
    Programme: "Administration, Vienna",
    Subprogramme: "Information and communications technology operations",
    Title: "Strengthened information security in the field",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Technological advancements that lead to improved quality, availability, accessibility and security of information",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=en#page=18"
  },
  {
    ID: 800,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "United Nations Office at Vienna",
    Programme: "Administration, Vienna",
    Subprogramme: "Information and communications technology operations",
    Title: "Digital transformation by client entities for improved mandate delivery",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparency and ease of access for improved implementation of programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=en#page=18"
  },
  {
    ID: 801,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "United Nations Office at Vienna",
    Programme: "Administration, Vienna",
    Subprogramme: "Information and communications technology operations",
    Title: "Harmonized approach to information and communications technology security across all United Nations Office at Vienna client department locations",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=en#page=19"
  },
  {
    ID: 802,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "Office of Internal Oversight Services",
    Programme: "Internal oversight",
    Subprogramme: "Internal audit",
    Title: "Strengthened accountability regarding staff time and attendance",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=en#page=6"
  },
  {
    ID: 803,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "Office of Internal Oversight Services",
    Programme: "Internal oversight",
    Subprogramme: "Internal audit",
    Title: "Strengthened monitoring systems to improve performance management to support programme delivery",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=en#page=7"
  },
  {
    ID: 804,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "Office of Internal Oversight Services",
    Programme: "Internal oversight",
    Subprogramme: "Internal audit",
    Title: "Enhanced delivery of United Nations mandates and programmes through strengthened organizational capabilities",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=en#page=7"
  },
  {
    ID: 805,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "Office of Internal Oversight Services",
    Programme: "Internal oversight",
    Subprogramme: "Internal audit",
    Title: "Increased efficiencies in the administration of the Organization",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=en#page=8"
  },
  {
    ID: 806,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "Office of Internal Oversight Services",
    Programme: "Internal oversight",
    Subprogramme: "Inspection and evaluation",
    Title: "Strengthened self-evaluation capacity in the Secretariat",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=en#page=10"
  },
  {
    ID: 807,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "Office of Internal Oversight Services",
    Programme: "Internal oversight",
    Subprogramme: "Inspection and evaluation",
    Title: "Strengthening the resident coordinator system",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=en#page=11"
  },
  {
    ID: 808,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "Office of Internal Oversight Services",
    Programme: "Internal oversight",
    Subprogramme: "Inspection and evaluation",
    Title: "Enhanced programme outcomes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=en#page=11"
  },
  {
    ID: 809,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "Office of Internal Oversight Services",
    Programme: "Internal oversight",
    Subprogramme: "Inspection and evaluation",
    Title: "Better mandate implementation through enhanced programme planning",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=en#page=12"
  },
  {
    ID: 810,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "Office of Internal Oversight Services",
    Programme: "Internal oversight",
    Subprogramme: "Investigations",
    Title: "The Organization’s ability to protect its resources and hold its personnel accountable strengthened",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced response against sexual exploitation and abuse, sexual harassment and fraud and corruption; improved mainstreaming of victim-centered approach",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=en#page=14"
  },
  {
    ID: 811,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "Office of Internal Oversight Services",
    Programme: "Internal oversight",
    Subprogramme: "Investigations",
    Title: "Strengthened response to misconduct investigations requiring a victim-centred response",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced response against sexual exploitation and abuse, sexual harassment and fraud and corruption; improved mainstreaming of victim-centered approach",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=en#page=14"
  },
  {
    ID: 812,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "Office of Internal Oversight Services",
    Programme: "Internal oversight",
    Subprogramme: "Investigations",
    Title: "Improved handling of and timely decision-making on misconduct complaints",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced response against sexual exploitation and abuse, sexual harassment and fraud and corruption; improved mainstreaming of victim-centered approach",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=en#page=15"
  },
  {
    ID: 813,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "Office of Internal Oversight Services",
    Programme: "Internal oversight",
    Subprogramme: "Investigations",
    Title: "Timely investigation of cases with a potential financial loss to the Organization",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Enhanced response against sexual exploitation and abuse, sexual harassment and fraud and corruption; improved mainstreaming of victim-centered approach",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=en#page=15"
  },
  {
    ID: 814,
    BudgetSection: 31,
    Entity: "ICSC",
    EntityFullName: "International Civil Service Commission",
    Programme: "Jointly financed administrative activities",
    Subprogramme: "International Civil Service Commission",
    Title: "A fair and equitable personal transitional allowance model ",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=en#page=4"
  },
  {
    ID: 815,
    BudgetSection: 31,
    Entity: "ICSC",
    EntityFullName: "International Civil Service Commission",
    Programme: "Jointly financed administrative activities",
    Subprogramme: "International Civil Service Commission",
    Title: "More flexibility afforded to staff working in extreme hardship locations",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=en#page=5"
  },
  {
    ID: 816,
    BudgetSection: 31,
    Entity: "ICSC",
    EntityFullName: "International Civil Service Commission",
    Programme: "Jointly financed administrative activities",
    Subprogramme: "International Civil Service Commission",
    Title: "Revised standards of conduct to guide organizations on emerging issues",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=en#page=6"
  },
  {
    ID: 817,
    BudgetSection: 31,
    Entity: "ICSC",
    EntityFullName: "International Civil Service Commission",
    Programme: "Jointly financed administrative activities",
    Subprogramme: "International Civil Service Commission",
    Title: "A compensation package that reflects the objectives, criteria and parameters approved by the General Assembly",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=en#page=6"
  },
  {
    ID: 818,
    BudgetSection: 31,
    Entity: "JIU",
    EntityFullName: "Joint Inspection Unit",
    Programme: "Jointly financed administrative activities",
    Subprogramme: "Joint Inspection",
    Title: "Increased responsiveness to Joint Inspection Unit recommendations through access to a new recommendation tracking tool",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved efficiency of processes due to science, technology and innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=en#page=14"
  },
  {
    ID: 819,
    BudgetSection: 31,
    Entity: "JIU",
    EntityFullName: "Joint Inspection Unit",
    Programme: "Jointly financed administrative activities",
    Subprogramme: "Joint Inspection",
    Title: "Enhanced management of administrative and programmatic issues by organizations of the United Nations system through the implementation of strategic and operational recommendations of the Joint Inspection Unit",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=en#page=15"
  },
  {
    ID: 820,
    BudgetSection: 31,
    Entity: "JIU",
    EntityFullName: "Joint Inspection Unit",
    Programme: "Jointly financed administrative activities",
    Subprogramme: "Joint Inspection",
    Title: "Strengthened impact of Joint Inspection Unit recommendations",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=en#page=15"
  },
  {
    ID: 821,
    BudgetSection: 31,
    Entity: "JIU",
    EntityFullName: "Joint Inspection Unit",
    Programme: "Jointly financed administrative activities",
    Subprogramme: "Joint Inspection",
    Title: "Strengthened system wide knowledge base and informed decision making through evidence-based oversight findings",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved efficiency of processes due to science, technology and innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=en#page=16"
  },
  {
    ID: 822,
    BudgetSection: 31,
    Entity: "CEB",
    EntityFullName: "United Nations System Chief Executives Board for Coordination",
    Programme: "Jointly financed administrative activities",
    Subprogramme: "United Nations System Chief Executives Board for Coordination",
    Title: "Far-reaching efficiency initiatives to collectively streamline United Nations system operations, reduce costs and sustain impact",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved efficiency of processes due to science, technology and innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=en#page=23"
  },
  {
    ID: 823,
    BudgetSection: 31,
    Entity: "CEB",
    EntityFullName: "United Nations System Chief Executives Board for Coordination",
    Programme: "Jointly financed administrative activities",
    Subprogramme: "United Nations System Chief Executives Board for Coordination",
    Title: "United Nations Digital ID, a building block in enabling interoperability across United Nations organizations",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Technological advancements that lead to improved quality, availability, accessibility and security of information",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=en#page=24"
  },
  {
    ID: 824,
    BudgetSection: 31,
    Entity: "CEB",
    EntityFullName: "United Nations System Chief Executives Board for Coordination",
    Programme: "Jointly financed administrative activities",
    Subprogramme: "United Nations System Chief Executives Board for Coordination",
    Title: "Improved coherence of United Nations system activities for the acceleration of progress towards the Sustainable Development Goals and implementation of the Pact for the Future",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Accelerated progress towards achieving the Sustainable Development Goals, including through robust coordination structures and leveraging of interlinkages across SDGs.",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=en#page=25"
  },
  {
    ID: 825,
    BudgetSection: 31,
    Entity: "CEB",
    EntityFullName: "United Nations System Chief Executives Board for Coordination",
    Programme: "Jointly financed administrative activities",
    Subprogramme: "United Nations System Chief Executives Board for Coordination",
    Title: "United Nations system coordination and coherence delivers efficient, sustained and principled action",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparency and ease of access for improved implementation of programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=en#page=25"
  },
  {
    ID: 826,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "Department of Safety and Security ",
    Programme: "Safety and security",
    Subprogramme: "Security and safety services",
    Title: "A safe and secure environment for all delegates and participants at the eightieth session of the General Assembly",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: "International community",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=en#page=7"
  },
  {
    ID: 827,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "Department of Safety and Security ",
    Programme: "Safety and security",
    Subprogramme: "Security and safety services",
    Title: "Improved ease of movement of delegates and staff across duty stations",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=en#page=7"
  },
  {
    ID: 828,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "Department of Safety and Security ",
    Programme: "Safety and security",
    Subprogramme: "Security and safety services",
    Title: "Improved registration, badging and security facilities for persons with disabilities",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: "Refugees, minorities and other groups in vulnerable situations",
    SpecificResult: "Improved infrastructure that supports UN operations in a more efficient and effective manner",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=en#page=8"
  },
  {
    ID: 829,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "Department of Safety and Security ",
    Programme: "Safety and security",
    Subprogramme: "Security and safety services",
    Title: "Improved safety and security decision-making",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved efficiency of processes due to science, technology and innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=en#page=9"
  },
  {
    ID: 830,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "Department of Safety and Security ",
    Programme: "Safety and security",
    Subprogramme: "Field operations",
    Title: "Increased operational efficiencies with a focus on high-risk locations",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=en#page=11"
  },
  {
    ID: 831,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "Department of Safety and Security ",
    Programme: "Safety and security",
    Subprogramme: "Field operations",
    Title: "Improved preparedness and response to crises",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=en#page=11"
  },
  {
    ID: 832,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "Department of Safety and Security ",
    Programme: "Safety and security",
    Subprogramme: "Field operations",
    Title: "Improved security decision-making",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=en#page=12"
  },
  {
    ID: 833,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "Department of Safety and Security ",
    Programme: "Safety and security",
    Subprogramme: "Field operations",
    Title: "Risk-informed safety and security decision-making",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=en#page=13"
  },
  {
    ID: 834,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "Department of Safety and Security ",
    Programme: "Safety and security",
    Subprogramme: "Partnerships and specialized services",
    Title: "New digital systems strengthened the safety and security of United Nations personnel",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Improved efficiency of processes due to science, technology and innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=en#page=15"
  },
  {
    ID: 835,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "Department of Safety and Security ",
    Programme: "Safety and security",
    Subprogramme: "Partnerships and specialized services",
    Title: "Consistent and coherent operations across the United Nations security management system",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=en#page=15"
  },
  {
    ID: 836,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "Department of Safety and Security ",
    Programme: "Safety and security",
    Subprogramme: "Partnerships and specialized services",
    Title: "Strengthened personal protection services for senior United Nations officials",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=en#page=16"
  },
  {
    ID: 837,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "Department of Safety and Security ",
    Programme: "Safety and security",
    Subprogramme: "Partnerships and specialized services",
    Title: "Harmonized approach to psychosocial support following critical incidents",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Enabling progress towards the eight priorities",
    Beneficiary: "enabling",
    BeneficiaryTwo: " ",
    SpecificResult: "Strengthened organizational capacity, accountability and responsiveness for more effective mandate delivery",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=en#page=16"
  }
]